webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_USERDATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REGISTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVATE; });
/* unused harmony export REFRESH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REQUEST_NEW_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SUBMIT_PASSWORD_CHANGE; });
/* unused harmony export UNPACKED_TOKEN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IS_AUTHENTICATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_TOKEN; });
/* unused harmony export GET_USERID */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_instance__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jwt_decode__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__proposal_progress__ = __webpack_require__(27);





var _mutations, _actions, _getters;






var namespace = 'auth/';

var SET_USERDATA = namespace + 'set_userdata';
var CLEAR_USERDATA = namespace + 'clear_userdata';

var LOGIN = namespace + 'login';
var LOGOUT = namespace + 'logout';
var REGISTER = namespace + 'register';
var ACTIVATE = namespace + 'activate';
var REFRESH = namespace + 'refresh';
var REQUEST_NEW_PASSWORD = namespace + 'request_new_password';
var SUBMIT_PASSWORD_CHANGE = namespace + 'submit_password_change';

var UNPACKED_TOKEN = namespace + 'unpacked_token';
var IS_AUTHENTICATED = namespace + 'is_auth';
var GET_TOKEN = namespace + 'token';
var GET_USERID = namespace + 'userid';

var TOKEN_KEY = 'token';
var REFRESH_TOKEN_KEY = 'refresh_token';
var INSTALLATION_PLACED_KEY = 'INSTALLATION_PLACED';

/* harmony default export */ __webpack_exports__["j"] = ({
    state: {
        token: localStorage.getItem(TOKEN_KEY),
        refresh_token: localStorage.getItem(REFRESH_TOKEN_KEY)
    },
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, SET_USERDATA, function (state, _ref) {
        var token = _ref.token,
            refresh_token = _ref.refresh_token;

        state.token = token;
        localStorage.setItem(TOKEN_KEY, token);
        state.refresh_token = refresh_token;
        localStorage.setItem(REFRESH_TOKEN_KEY, refresh_token);
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, CLEAR_USERDATA, function (state) {
        state.token = null;
        localStorage.removeItem(TOKEN_KEY);
        state.refresh_token = null;
        localStorage.removeItem(REFRESH_TOKEN_KEY);
        localStorage.setItem(INSTALLATION_PLACED_KEY, null);
    }), _mutations),
    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, LOGIN, function (_ref2, payload) {
        var commit = _ref2.commit,
            dispatch = _ref2.dispatch;

        payload.platform = 'client_dashboard';
        return __WEBPACK_IMPORTED_MODULE_4__api_instance__["a" /* default */].post('auth/api/accounts/authorize', payload).then(function (authdata) {
            commit(SET_USERDATA, authdata);
            dispatch(__WEBPACK_IMPORTED_MODULE_7__proposal_progress__["a" /* ADD_INSTALLATION_PLACED */], authdata.installation_placed, { root: true });
        });
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, LOGOUT, function (_ref3) {
        var commit = _ref3.commit,
            getters = _ref3.getters;

        if (!getters[IS_AUTHENTICATED]) {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
        }
        return __WEBPACK_IMPORTED_MODULE_4__api_instance__["a" /* default */].delete('auth/api/accounts/session').finally(function () {
            return commit(CLEAR_USERDATA);
        });
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, REGISTER, function (_ref4, form) {
        var commit = _ref4.commit;

        return __WEBPACK_IMPORTED_MODULE_4__api_instance__["a" /* default */].post('auth/register', form);
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, ACTIVATE, function (_ref5, payload) {
        var _this = this;

        var commit = _ref5.commit,
            dispatch = _ref5.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var authdata;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            payload.platform = 'client_dashboard';
                            _context.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_4__api_instance__["a" /* default */].post('auth/api/accounts/activate', payload);

                        case 3:
                            authdata = _context.sent;

                            commit(SET_USERDATA, authdata);
                            dispatch(__WEBPACK_IMPORTED_MODULE_7__proposal_progress__["a" /* ADD_INSTALLATION_PLACED */], authdata.installation_placed, { root: true });

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, REQUEST_NEW_PASSWORD, function (_ref6, payload) {
        var _this2 = this;

        var commit = _ref6.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            payload.platform = 'client_dashboard';
                            _context2.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_4__api_instance__["a" /* default */].post('auth/api/accounts/password_reset', payload);

                        case 3:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, REFRESH, function (_ref7) {
        var commit = _ref7.commit,
            state = _ref7.state;

        var refresh_token = state.refresh_token;
        if (!refresh_token) return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject('no refresh_token');
        return __WEBPACK_IMPORTED_MODULE_4__api_instance__["a" /* default */].post('auth/api/accounts/refresh', { refresh_token: refresh_token }).then(function (authdata) {
            commit(SET_USERDATA, authdata);
        });
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, SUBMIT_PASSWORD_CHANGE, function (_ref8, payload) {
        var _this3 = this;

        var commit = _ref8.commit,
            dispatch = _ref8.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var authdata;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_4__api_instance__["a" /* default */].put('auth/api/accounts/password', payload);

                        case 3:
                            authdata = _context3.sent;

                            commit(SET_USERDATA, authdata);
                            _context3.next = 10;
                            break;

                        case 7:
                            _context3.prev = 7;
                            _context3.t0 = _context3['catch'](0);
                            throw 'Could not change password';

                        case 10:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3, [[0, 7]]);
        }))();
    }), _actions),
    getters: (_getters = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_getters, UNPACKED_TOKEN, function (state) {
        var token = state.token;

        if (!token) return undefined;
        try {
            var token_data = __WEBPACK_IMPORTED_MODULE_5_jwt_decode___default()(token);

            if (!token_data) return undefined;
            var issued_timestamp = __WEBPACK_IMPORTED_MODULE_6_moment___default()(token_data.issuedAt);
            var expire_timestamp = issued_timestamp.clone().add(token_data.ttl, 'seconds');

            if (expire_timestamp.isBefore(__WEBPACK_IMPORTED_MODULE_6_moment___default()())) return undefined;
            return token_data;
        } catch (error) {
            return undefined;
        }
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_getters, IS_AUTHENTICATED, function (state, getters) {
        return !state.error && !!getters[UNPACKED_TOKEN];
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_getters, GET_TOKEN, function (state) {
        return state.token;
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_getters, GET_USERID, function (state, getters) {
        return safeGet(getters[UNPACKED_TOKEN], 'id');
    }), _getters)
});

function safeGet(obj, field) {
    return obj ? obj[field] : undefined;
}

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create());

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RESET_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_ACCOUNT_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SUBMIT_ACCOUNT_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IS_DIRTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_USERNAME; });
/* unused harmony export GET_ADDRESS_DETAILS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FIELDS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_instance__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clone_deep__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clone_deep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_clone_deep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_dateformat__ = __webpack_require__(230);



var _mutations, _actions, _getters;






var namespace = 'account_details/';

var SET_ACCOUNT_DATA = namespace + 'set_account';
var SET_FIELD = namespace + 'set_field';
var MARK_CLEAN = namespace + 'mark_clean';
var RESET_FIELDS = namespace + 'reset';

var FETCH_ACCOUNT_DETAILS = namespace + 'fetch';
var SUBMIT_ACCOUNT_DETAILS = namespace + 'submit';

var GET_FIELD = namespace + 'get_field';
var IS_DIRTY = namespace + 'is_dirty';
var GET_USERNAME = namespace + 'get_username';
var GET_ADDRESS_DETAILS = namespace + 'get_address_details';

var FIELDS = ['gender', 'name', 'first_name', 'last_name', 'address', 'address_number', 'postal_code', 'city_name', 'country_name', 'telephone_number', 'mobile_number', 'email_address', 'guarantee'];
var DATE_FIELDS = ['last_login', 'created', 'modified', 'guarantee'];

/* harmony default export */ __webpack_exports__["i"] = ({
    state: {
        account: {
            'gender': null,
            'name': null,
            'first_name': null,
            'last_name': null,
            'address': null,
            'address_number': null,
            'postal_code': null,
            'city_name': null,
            'country_name': null,
            'mobile_number': null,
            'telephone_number': null,
            'email_address': null,
            'guarantee': null
        },
        fields: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapValues(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(FIELDS), function (value) {
            return { value: value, original: value };
        })
    },
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, SET_ACCOUNT_DATA, function (state, account) {
        state.account = __WEBPACK_IMPORTED_MODULE_3_clone_deep___default()(account);
        state.account.password = undefined;
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, SET_FIELD, function (state, _ref) {
        var field = _ref.field,
            value = _ref.value;

        var data = state.fields[field];
        if (!data) return;
        data.value = value;
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, MARK_CLEAN, function (state) {
        __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.each(state.fields, function (field) {
            return field.original = field.value;
        });
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, RESET_FIELDS, function (state) {
        __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.each(state.fields, function (field) {
            return field.value = field.original;
        });
    }), _mutations),
    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, FETCH_ACCOUNT_DETAILS, function (_ref2) {
        var commit = _ref2.commit;

        return __WEBPACK_IMPORTED_MODULE_2__api_instance__["a" /* default */].get('auth/api/accounts/details').then(function (account) {
            DATE_FIELDS.forEach(function (field) {
                return account[field] = Object(__WEBPACK_IMPORTED_MODULE_5__api_dateformat__["b" /* importDate */])(account[field]);
            });

            commit(SET_ACCOUNT_DATA, account);

            FIELDS.forEach(function (field) {
                return commit(SET_FIELD, { field: field, value: account[field] });
            });
            commit(MARK_CLEAN);
        });
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, SUBMIT_ACCOUNT_DETAILS, function (_ref3) {
        var commit = _ref3.commit,
            state = _ref3.state;

        var payload = {};
        __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.each(state.fields, function (field, key) {
            if (field.value !== field.original) {
                payload[key] = field.value;
            }
        });
        if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.keys(payload).length) {
            return __WEBPACK_IMPORTED_MODULE_2__api_instance__["a" /* default */].put('auth/api/accounts/details', payload).then(function (account) {
                FIELDS.forEach(function (field) {
                    return commit(SET_FIELD, { field: field, value: account[field] });
                });
                commit(MARK_CLEAN);
            });
        } else {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
        }
    }), _actions),
    getters: (_getters = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, GET_FIELD, function (state) {
        return function (fieldname) {
            return state.fields[fieldname].value;
        };
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, IS_DIRTY, function (state) {
        return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.some(state.fields, function (field) {
            return field.value !== field.original;
        });
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, GET_USERNAME, function (state) {
        return state.account.name;
    }), _getters)
});

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GET_APPOINTMENT */
/* unused harmony export SET_APPOINTMENT */
/* unused harmony export RESET_APPOINTMENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_INSTALLATION_PROGRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_INSTALLATION_PLACED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_INSTALLATION_PROGRESS; });
/* unused harmony export CLEAR_INSTALLATION_PROGRESS_DATA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_INSTALLATION_PLACED; });
/* unused harmony export ADD_PROGRESS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_instance__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clone_deep__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clone_deep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_clone_deep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);



var _mutations, _actions, _getters;





var namespace = 'proposal_progress/';

var SET_INSTALLATION_PLACED = namespace + 'set_installation_placed';
var SET_INSTALLATION_PROGRESS = namespace + 'set_installation_progress';

var GET_APPOINTMENT = namespace + 'get_appointment';
var SET_APPOINTMENT = namespace + 'set_appointment';
var RESET_APPOINTMENT = namespace + 'reset_appointment';

var FETCH_INSTALLATION_PROGRESS = namespace + 'fetch_installation_progress';

var GET_INSTALLATION_PLACED = namespace + 'installation_placed';
var GET_INSTALLATION_PROGRESS = namespace + 'installation_progress';
var CLEAR_INSTALLATION_PROGRESS_DATA = namespace + 'clear_installation_data';
var ADD_INSTALLATION_PLACED = namespace + 'installation_placed';
var ADD_PROGRESS = namespace + 'add_progress';

var INSTALLATION_PLACED_KEY = 'INSTALLATION_PLACED';

/* harmony default export */ __webpack_exports__["e"] = ({
    state: {
        installation_placed: localStorage.getItem(INSTALLATION_PLACED_KEY),
        installation_progress: {
            requested: {
                completed: false,
                date: null
            },
            signed: {
                completed: false,
                date: null
            },
            called: {
                completed: false,
                date: null
            },
            install: {
                completed: false,
                date: null,
                slot: 'morning'
            }
        },
        appointment: {
            moments: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, '2018-01-01', ['morning']),
            address: {
                street: '',
                number: '',
                postalCode: '',
                city: '',
                country: '' },
            comment: ''
        }
    },
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, SET_INSTALLATION_PROGRESS, function (state, installation_progress) {
        state.installation_progress = installation_progress;
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, SET_INSTALLATION_PLACED, function (state, installation_placed) {
        state.installation_placed = installation_placed;
        localStorage.setItem(INSTALLATION_PLACED_KEY, installation_placed);
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, SET_APPOINTMENT, function (state, value) {
        state.appointment = __WEBPACK_IMPORTED_MODULE_3_clone_deep___default()(value);
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, RESET_APPOINTMENT, function (state) {
        state.appointment = {
            moments: {},
            address: {
                street: '',
                number: '',
                postalCode: '',
                city: '',
                country: ''
            },
            comment: ''
        };
    }), _mutations),
    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, FETCH_INSTALLATION_PROGRESS, function (_ref) {
        var dispatch = _ref.dispatch;

        return __WEBPACK_IMPORTED_MODULE_2__api_instance__["a" /* default */].get('proposals/api/proposals').then(function (response) {
            var installation_placed = response.installation_placed;
            var installation_process = response.installation_process;
            dispatch(ADD_PROGRESS, installation_process);
            dispatch(ADD_INSTALLATION_PLACED, installation_placed);
        });
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, ADD_INSTALLATION_PLACED, function (_ref2, installation_placed) {
        var commit = _ref2.commit;

        if (installation_placed) {
            commit(SET_INSTALLATION_PLACED, true);
        } else {
            commit(SET_INSTALLATION_PLACED, false);
        }
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, ADD_PROGRESS, function (_ref3, installation_process) {
        var commit = _ref3.commit;

        var installation_progress = installation_process;

        var installationProgress = {
            requested: {
                completed: false,
                date: null
            },
            signed: {
                completed: false,
                date: null
            },
            called: {
                completed: false,
                date: null
            },
            install: {
                completed: false,
                date: null
            }
        };

        if (installation_progress.date_signed) {
            installationProgress.signed.completed = true;
            installationProgress.signed.date = installation_progress.date_signed;
        }
        if (installation_progress.date_requested) {
            installationProgress.requested.completed = true;
            installationProgress.requested.date = installation_progress.date_requested;
        }
        if (installation_progress.date_called) {
            installationProgress.called.completed = true;
            installationProgress.called.date = installation_progress.date_called;
        }
        if (installation_progress.installation_date) {
            installationProgress.install.completed = true;
            installationProgress.install.date = installation_progress.installation_date;
        }
        commit(SET_INSTALLATION_PROGRESS, installationProgress);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, CLEAR_INSTALLATION_PROGRESS_DATA, function (commit) {
        commit(SET_INSTALLATION_PLACED, null);
        commit(SET_INSTALLATION_PROGRESS, {});
        localStorage.setItem(INSTALLATION_PLACED_KEY, null);
    }), _actions),
    getters: (_getters = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, GET_APPOINTMENT, function (state) {
        return __WEBPACK_IMPORTED_MODULE_3_clone_deep___default()(state.appointment);
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, GET_INSTALLATION_PROGRESS, function (state) {
        return __WEBPACK_IMPORTED_MODULE_3_clone_deep___default()(state.installation_progress);
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, GET_INSTALLATION_PLACED, function (state) {
        return state.installation_placed === true || state.installation_placed == 'true';
    }), _getters)
});

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocaleButton_vue__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2553b14a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocaleButton_vue__ = __webpack_require__(339);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocaleButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2553b14a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocaleButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ebf9b38_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__(382);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ebf9b38_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_LANGUAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_LANGUAGE; });
/* unused harmony export LANGUAGE_CODES */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__languages__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);



var _getters;




var namespace = 'locale/';

var GET_LANGUAGE = namespace + 'get_language';
var SET_LANGUAGE = namespace + 'set_language';
var LANGUAGE_CODES = namespace + 'languages';

var STORAGE_KEY = 'lang';

/* harmony default export */ __webpack_exports__["c"] = ({
    state: {
        languages: ['nl', 'fr'],
        active: __WEBPACK_IMPORTED_MODULE_2__languages__["c" /* i18n */].locale = localStorage.getItem(STORAGE_KEY) || __WEBPACK_IMPORTED_MODULE_2__languages__["a" /* DEFAULT_LANGUAGE */]
    },
    mutations: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, SET_LANGUAGE, function (state, code) {
        console.assert(state.languages.includes(code));
        state.active = code;

        __WEBPACK_IMPORTED_MODULE_2__languages__["c" /* i18n */].locale = code;
        __WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale(code);
        localStorage.setItem(STORAGE_KEY, code);
        document.querySelector('html').setAttribute('lang', code);
    }),
    actions: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, SET_LANGUAGE, function (_ref, code) {
        var commit = _ref.commit;

        commit(SET_LANGUAGE, code);

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    }),
    getters: (_getters = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, GET_LANGUAGE, function (state) {
        return state.active;
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, LANGUAGE_CODES, function (state) {
        return state.languages;
    }), _getters)
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_LANGUAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return i18n; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_locale_nl__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_locale_nl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_locale_nl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_locale_fr__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_locale_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_locale_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fr_json__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fr_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fr_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nl_json__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nl_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__nl_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__numbers__ = __webpack_require__(338);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);




var messages = {
    fr: __WEBPACK_IMPORTED_MODULE_4__fr_json___default.a,
    nl: __WEBPACK_IMPORTED_MODULE_5__nl_json___default.a
};



var DEFAULT_LANGUAGE = 'nl';

var url = window.location.href;
if (url.includes('portal.minimax.fr') || url.includes('minimax-client-dashboard.k.elnino-acceptance.com')) {
    DEFAULT_LANGUAGE = 'fr';
} else {
    DEFAULT_LANGUAGE = 'nl';
}

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
    locale: DEFAULT_LANGUAGE,
    fallbackLocale: DEFAULT_LANGUAGE,
    messages: messages,
    numberFormats: __WEBPACK_IMPORTED_MODULE_6__numbers__["a" /* numberFormats */]
});

/* harmony default export */ __webpack_exports__["b"] = (i18n);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_EXPERIENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SUBMIT_EXPERIENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_EXPERIENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_EXPERIENCES_COUNT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_instance__ = __webpack_require__(17);




var _mutations, _actions, _getters;



var namespace = 'experiences/';

var SET_EXPERIENCES = namespace + 'set_experiences';
var ADD_EXPERIENCES = namespace + 'add_experiences';

var FETCH_EXPERIENCES = namespace + 'fetch_experiences';
var SUBMIT_EXPERIENCE = namespace + 'submit';

var GET_EXPERIENCES = namespace + 'get_experiences';
var GET_EXPERIENCES_COUNT = namespace + 'get_experiences_count';

/* harmony default export */ __webpack_exports__["e"] = ({
    state: {
        experiences: [{
            id: 14,
            author_id: 343,
            author_name: 'Philippe Thirons',
            rating: 3,
            title: 'Titel',
            text: 'Review',
            status: 'pending',
            language: 1,
            created: '2021-03-17 11:51:00',
            created_by: 343,
            modified: '2021-03-17 11:51:00',
            modified_by: 343
        }]
    },
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, SET_EXPERIENCES, function (state, experiences) {
        return state.experiences = experiences;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, ADD_EXPERIENCES, function (state, experience) {
        return state.experiences.splice(0, 0, experience);
    }), _mutations),
    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, FETCH_EXPERIENCES, function (_ref) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var experiences;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_3__api_instance__["a" /* default */].get('experiences/api/experiences');

                        case 2:
                            experiences = _context.sent;

                            commit(SET_EXPERIENCES, experiences);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, SUBMIT_EXPERIENCE, function (_ref2, payload) {
        var _this2 = this;

        var commit = _ref2.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var experiences;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_3__api_instance__["a" /* default */].post('experiences/api/experiences', payload);

                        case 2:
                            experiences = _context2.sent;

                            commit(SET_EXPERIENCES, experiences);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    }), _actions),
    getters: (_getters = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_getters, GET_EXPERIENCES, function (state) {
        return state.experiences;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_getters, GET_EXPERIENCES_COUNT, function (state) {
        return state.experiences.length;
    }), _getters)
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RESET_WIZARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SUBMIT_SUPPORT_ISSUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_TITLE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_DETAIL_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_DETAIL; });
/* unused harmony export CAN_SUBMIT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return TITLE_CUSTOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DETAIL_CUSTOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_APPOINTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_APPOINTMENT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_instance__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clone_deep__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clone_deep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_clone_deep__);




var _mutations, _getters;




var namespace = 'support_wizard/';

var RESET_WIZARD = namespace + 'reset';
var SET_TITLE = namespace + 'set_title';
var SET_DETAIL = namespace + 'set_detail';

var SUBMIT_SUPPORT_ISSUE = namespace + 'submit';

var GET_TITLE_OPTIONS = namespace + 'get_title_list';
var GET_DETAIL_OPTIONS = namespace + 'get_detail_list';
var GET_TITLE = namespace + 'get_title';
var GET_DETAIL = namespace + 'get_detail';
var CAN_SUBMIT = namespace + 'can_submit';

var TITLE_CUSTOM = 'custom';
var DETAIL_CUSTOM = 'custom';

var GET_APPOINTMENT = namespace + 'get_appointment';
var SET_APPOINTMENT = namespace + 'set_appointment';

/* harmony default export */ __webpack_exports__["m"] = ({
    state: {
        titleCode: '',
        titleText: '',
        detailsCode: '',
        detailsText: '',
        appointment: {
            moments: {},
            address: {
                street: '',
                number: '',
                postalCode: '',
                city: '',
                country: ''
            },
            comment: ''
        },
        wizard: {
            'hardness': ['hardness_too_high', 'hardness_too_low'],
            'salt_blocks': ['salt_too_high', 'salt_too_low', 'salt_block_doesnt_fit'],
            'malfunction': ['malfunction_leak', 'malfunction_broken', 'malfunction_error'],
            'custom': []
        }
    },
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, RESET_WIZARD, function (state) {
        state.titleCode = '';
        state.titleText = '';
        state.detailsCode = '';
        state.detailsText = '';
        state.appointment = {
            moments: {},
            address: {
                street: '',
                number: '',
                postalCode: '',
                city: '',
                country: ''
            },
            comment: ''
        };
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, SET_TITLE, function (state) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref$code = _ref.code,
            code = _ref$code === undefined ? '' : _ref$code,
            _ref$text = _ref.text,
            text = _ref$text === undefined ? '' : _ref$text;

        if (state.titleCode !== code) {
            state.detailsCode = '';
            state.detailsText = '';
        }
        state.titleCode = code;
        state.titleText = text;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, SET_DETAIL, function (state) {
        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref2$code = _ref2.code,
            code = _ref2$code === undefined ? '' : _ref2$code,
            _ref2$text = _ref2.text,
            text = _ref2$text === undefined ? '' : _ref2$text;

        state.detailsCode = code;
        state.detailsText = text;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, SET_APPOINTMENT, function (state, value) {
        return state.appointment = __WEBPACK_IMPORTED_MODULE_4_clone_deep___default()(value);
    }), _mutations),
    actions: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, SUBMIT_SUPPORT_ISSUE, function (_ref3) {
        var commit = _ref3.commit,
            state = _ref3.state;

        var payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state);
        return __WEBPACK_IMPORTED_MODULE_3__api_instance__["a" /* default */].post('support/api/support', payload).then(function (ticket) {
            commit(RESET_WIZARD);
            return ticket;
        });
    }),
    getters: (_getters = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_getters, GET_TITLE_OPTIONS, function (state) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.wizard);
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_getters, GET_DETAIL_OPTIONS, function (state) {
        return state.wizard[state.titleCode] || [];
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_getters, GET_TITLE, function (state) {
        return { code: state.titleCode, text: state.titleText };
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_getters, GET_DETAIL, function (state) {
        return { code: state.detailsCode, text: state.detailsText };
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_getters, GET_APPOINTMENT, function (state) {
        return __WEBPACK_IMPORTED_MODULE_4_clone_deep___default()(state.appointment);
    }), _getters)
});

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SCREEN_XS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SCREEN_SM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCREEN_MD; });
/* unused harmony export SCREEN_LG */
/* unused harmony export SCREEN_XL */

var BREAKPOINTS = {
    XS: 575,
    SM: 767,
    MD: 991,
    LG: 1199,
    XL: 1399
};

var SCREEN_XS = BREAKPOINTS.XS;
var SCREEN_SM = BREAKPOINTS.SM;
var SCREEN_MD = BREAKPOINTS.MD;
var SCREEN_LG = BREAKPOINTS.LG;
var SCREEN_XL = BREAKPOINTS.XL;

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalWrapper_vue__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3e9aad6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalWrapper_vue__ = __webpack_require__(356);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalWrapper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3e9aad6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalWrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_account_details__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_auth__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_locale__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_moments__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_order_salt__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_orders__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_proposal_progress__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_referrals__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_support_wizard__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_experiences__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_available_contact_moments__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_plan_installation__ = __webpack_require__(237);















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        account_details: __WEBPACK_IMPORTED_MODULE_2__modules_account_details__["i" /* default */],
        auth: __WEBPACK_IMPORTED_MODULE_3__modules_auth__["j" /* default */],
        locale: __WEBPACK_IMPORTED_MODULE_4__modules_locale__["c" /* default */],
        moments: __WEBPACK_IMPORTED_MODULE_5__modules_moments__["e" /* default */],
        order_salt: __WEBPACK_IMPORTED_MODULE_6__modules_order_salt__["d" /* default */],
        orders: __WEBPACK_IMPORTED_MODULE_7__modules_orders__["g" /* default */],
        plan_installation: __WEBPACK_IMPORTED_MODULE_13__modules_plan_installation__["d" /* default */],
        proposal_progress: __WEBPACK_IMPORTED_MODULE_8__modules_proposal_progress__["e" /* default */],
        referrals: __WEBPACK_IMPORTED_MODULE_9__modules_referrals__["g" /* default */],
        support_wizard: __WEBPACK_IMPORTED_MODULE_10__modules_support_wizard__["m" /* default */],
        experiences: __WEBPACK_IMPORTED_MODULE_11__modules_experiences__["e" /* default */],
        available_contact_moments: __WEBPACK_IMPORTED_MODULE_12__modules_available_contact_moments__["j" /* default */]
    }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REMOVE_MOMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_MOMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_MOMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_MOMENTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);



var _actions;

var namespace = 'moments/';

var SET_MOMENTS = namespace + 'set_moments';

var REMOVE_MOMENT = namespace + 'remove_moment';
var CLEAR_MOMENTS = namespace + 'clear_moments';
var ADD_MOMENT = namespace + 'add_moment';
var GET_MOMENTS = namespace + 'get_moments';

/* harmony default export */ __webpack_exports__["e"] = ({
    state: {
        moments: {
            '2021-02-20': ['morning', 'afternoon']
        }
    },
    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, SET_MOMENTS, function (state, moments) {
        state.moments = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(moments));
    }),
    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, CLEAR_MOMENTS, function (_ref) {
        var commit = _ref.commit;

        commit(SET_MOMENTS, {});
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, ADD_MOMENT, function (_ref2, _ref3) {
        var commit = _ref2.commit,
            getters = _ref2.getters;
        var key = _ref3.key,
            times = _ref3.times;

        var moments = getters[GET_MOMENTS];
        moments[key] = times;
        commit(SET_MOMENTS, moments);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, REMOVE_MOMENT, function (_ref4, key) {
        var commit = _ref4.commit,
            getters = _ref4.getters;

        var moments = getters[GET_MOMENTS];
        delete moments[key];
        commit(SET_MOMENTS, moments);
    }), _actions),
    getters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, GET_MOMENTS, function (state) {
        return state.moments;
    })
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SET_FETCHING_LAST_ORDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_PDF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_LAST_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_LAST_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_FETCHING_LAST_ORDER; });
/* unused harmony export TYPE_MAINTENANCE */
/* unused harmony export TYPE_REPAIR */
/* unused harmony export TYPE_PROPOSAL */
/* unused harmony export TYPE_INSTALLATION */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_instance__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__experiences__ = __webpack_require__(52);




var _mutations, _actions, _getters;




var namespace = 'orders/';

var SET_ORDERS = namespace + 'set';
var SET_LAST_ORDER = namespace + 'set_last_order';
var SET_FETCHING_LAST_ORDER = namespace + 'SET_FETCHING_LAST_ORDER';

var FETCH_ORDERS = namespace + 'fetch';

var GET_ORDERS = namespace + 'get';

var FETCH_PDF = namespace + 'fetch_pdf';

var FETCH_LAST_ORDER = namespace + 'fetch_last_order';
var GET_LAST_ORDER = namespace + 'get_last_order';
var GET_FETCHING_LAST_ORDER = namespace + 'GET_FETCHING_LAST_ORDER';

var TYPE_MAINTENANCE = 'maintenance';
var TYPE_REPAIR = 'repair';
var TYPE_PROPOSAL = 'proposal';
var TYPE_INSTALLATION = 'installation';

/* harmony default export */ __webpack_exports__["g"] = ({
    state: {
        items: [{
            id: 1,
            date: new Date('2018-01-01'),
            price: 10.25,
            type: TYPE_MAINTENANCE,
            download_url: 'http://google.com/'
        }, {
            id: 2,
            date: new Date('2018-01-02'),
            price: 2048.50,
            type: TYPE_REPAIR,
            download_url: 'http://google.com/'
        }, {
            id: 3,
            date: new Date('2018-01-03'),
            price: 12345.01,
            type: TYPE_PROPOSAL,
            download_url: 'http://google.com/'
        }, {
            id: 4,
            date: new Date('2018-01-04'),
            price: 0.00,
            type: TYPE_INSTALLATION,
            download_url: 'http://google.com/'
        }],
        last_order: null,
        fetchingLastOrder: false
    },
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, SET_ORDERS, function (state, orders) {
        return state.items = orders;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, SET_LAST_ORDER, function (state, order) {
        return state.last_order = order;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, SET_FETCHING_LAST_ORDER, function (state, fetching) {
        return state.fetchingLastOrder = fetching;
    }), _mutations),
    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, FETCH_ORDERS, function (_ref) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var orders;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_3__api_instance__["a" /* default */].get('orders/api/orders');

                        case 2:
                            orders = _context.sent;

                            commit(SET_ORDERS, orders);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, FETCH_LAST_ORDER, function (_ref2) {
        var _this2 = this;

        var commit = _ref2.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var order;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;

                            commit(SET_FETCHING_LAST_ORDER, true);
                            _context2.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_3__api_instance__["a" /* default */].get('/salt/api/refills/order');

                        case 4:
                            order = _context2.sent;

                            commit(SET_LAST_ORDER, order);

                        case 6:
                            _context2.prev = 6;

                            commit(SET_FETCHING_LAST_ORDER, false);
                            return _context2.finish(6);

                        case 9:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[0,, 6, 9]]);
        }))();
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, FETCH_PDF, function (_ref3, url) {
        var _this3 = this;

        var commit = _ref3.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var fullUrl, response, file, fileURL;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            fullUrl = 'orders/api/orders/file' + url;
                            _context3.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_3__api_instance__["a" /* default */].get(fullUrl, { responseType: 'arraybuffer' });

                        case 3:
                            response = _context3.sent;
                            file = new Blob([response], { type: 'application/pdf' });
                            fileURL = URL.createObjectURL(file);

                            window.open(fileURL);

                        case 7:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    }), _actions),
    getters: (_getters = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_getters, GET_ORDERS, function (state) {
        return state.items;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_getters, GET_LAST_ORDER, function (state) {
        return state.last_order;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_getters, GET_FETCHING_LAST_ORDER, function (state) {
        return state.fetchingLastOrder;
    }), _getters)
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_SELECTED_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_COMMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_AVAILABLE_CONTACT_MOMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_AVAILABLE_CONTACT_MOMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_FETCHING_AVAILABLE_CONTACT_MOMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_SELECTED_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_COMMENT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_instance__ = __webpack_require__(17);




var _mutations, _getters;



var namespace = 'available_contact_moments/';

var SET_AVAILABLE_CONTACT_MOMENTS = namespace + 'SET_AVAILABLE_CONTACT_MOMENTS';
var SET_FETCHING_AVAILABLE_CONTACT_MOMENTS = namespace + 'SET_FETCHING_AVAILABLE_CONTACT_MOMENTS';

var SET_SELECTED_OPTION = namespace + 'SET_SELECTED_OPTION';
var SET_COMMENT = namespace + 'SET_COMMENT';
var SET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS = namespace + 'SET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS';

var FETCH_AVAILABLE_CONTACT_MOMENTS = namespace + 'FETCH_AVAILABLE_CONTACT_MOMENTS';
var GET_AVAILABLE_CONTACT_MOMENTS = namespace + 'GET_AVAILABLE_CONTACT_MOMENTS';
var GET_FETCHING_AVAILABLE_CONTACT_MOMENTS = namespace + 'GET_FETCHING_AVAILABLE_CONTACT_MOMENTS';
var GET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS = namespace + 'GET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS';
var GET_SELECTED_OPTION = namespace + 'GET_SELECTED_OPTION';
var GET_COMMENT = namespace + 'GET_COMMENT';

/* harmony default export */ __webpack_exports__["j"] = ({
    state: {
        availableContactMoments: [],
        fetchingAvailableContactMoments: false,
        errorFetchingAvailableContactMoments: false,
        selectedOption: null,
        comment: ''
    },
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, SET_AVAILABLE_CONTACT_MOMENTS, function (state, availableContactMoments) {
        return state.availableContactMoments = availableContactMoments;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, SET_FETCHING_AVAILABLE_CONTACT_MOMENTS, function (state, fetching) {
        return state.fetchingAvailableContactMoments = fetching;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, SET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS, function (state, error) {
        return state.errorFetchingAvailableContactMoments = error;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, SET_SELECTED_OPTION, function (state, option) {
        return state.selectedOption = option;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, SET_COMMENT, function (state, comment) {
        return state.comment = comment;
    }), _mutations),
    actions: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, FETCH_AVAILABLE_CONTACT_MOMENTS, function (_ref) {
        var _this = this;

        var commit = _ref.commit;

        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref2$type = _ref2.type,
            type = _ref2$type === undefined ? 'salt' : _ref2$type;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var experiences;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;

                            commit(SET_FETCHING_AVAILABLE_CONTACT_MOMENTS, true);
                            _context.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_3__api_instance__["a" /* default */].get('/planners/api/planners/available_x_contact_moments', { params: { type: type } });

                        case 4:
                            experiences = _context.sent;

                            commit(SET_AVAILABLE_CONTACT_MOMENTS, experiences);

                        case 6:
                            _context.prev = 6;

                            commit(SET_FETCHING_AVAILABLE_CONTACT_MOMENTS, false);
                            return _context.finish(6);

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[0,, 6, 9]]);
        }))();
    }),
    getters: (_getters = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_getters, GET_AVAILABLE_CONTACT_MOMENTS, function (state) {
        return state.availableContactMoments;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_getters, GET_FETCHING_AVAILABLE_CONTACT_MOMENTS, function (state) {
        return state.fetchingAvailableContactMoments;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_getters, GET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS, function (state) {
        return state.errorFetchingAvailableContactMoments;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_getters, GET_SELECTED_OPTION, function (state) {
        return state.selectedOption;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_getters, GET_COMMENT, function (state) {
        return state.comment;
    }), _getters)
});

/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetupSteps_vue__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e7b5cd6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetupSteps_vue__ = __webpack_require__(346);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetupSteps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e7b5cd6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetupSteps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = importDate;
/* unused harmony export exportDate */
/* harmony export (immutable) */ __webpack_exports__["a"] = exportDateShort;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

var API_DATE_FORMAT = 'DD-MM-YYYY HH:mm';

function importDate(value) {
    if (!value) return null;
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value, API_DATE_FORMAT).toDate();
}

function exportDate(value) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format(API_DATE_FORMAT);
}

function exportDateShort(value) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('DD-MM-YYYY');
}

/***/ }),
/* 231 */,
/* 232 */,
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_auth__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_proposal_progress__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_modules_locale__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Orders__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Support__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Account__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_account_ViewAccount__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_account_AccountInfoForm__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_account_ChangePassword__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Referrals__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Experiences__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Styleguide__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_PageNotFound__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_AuthenticationPage__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Guidelines__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_WelcomePage__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_OrderSaltBlocks__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_auth_forms_LoginForm__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_auth_forms_RegisterForm__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_auth_forms_PasswordResetForm__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_auth_forms_PasswordForgottenForm__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_auth_forms_ActivationForm__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_raven_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_raven_js__);




























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    linkActiveClass: 'is-active',
    routes: [{
        path: '/',
        name: 'home',
        redirect: '/account'
    }, {
        path: '/saltblocks',
        name: 'saltblocks',
        component: __WEBPACK_IMPORTED_MODULE_19__pages_OrderSaltBlocks__["a" /* default */],
        meta: {
            auth: true,
            crumbs: ['home']
        }
    }, {
        path: '/orders',
        name: 'orders',
        component: __WEBPACK_IMPORTED_MODULE_6__pages_Orders__["a" /* default */],
        meta: {
            auth: true,
            crumbs: ['home']
        }
    }, {
        path: '/support',
        name: 'support',
        component: __WEBPACK_IMPORTED_MODULE_7__pages_Support__["a" /* default */],
        meta: {
            auth: true,
            crumbs: ['home']
        }
    }, {
        path: '/account',
        component: __WEBPACK_IMPORTED_MODULE_8__pages_Account__["a" /* default */],
        meta: {
            auth: true
        },
        children: [{
            path: '/',
            name: 'account',
            component: __WEBPACK_IMPORTED_MODULE_9__components_account_ViewAccount__["a" /* default */],
            meta: {
                crumbs: ['home']
            }
        }, {
            path: 'edit',
            name: 'edit-account',
            component: __WEBPACK_IMPORTED_MODULE_10__components_account_AccountInfoForm__["a" /* default */],
            meta: {
                crumbs: ['home', 'account']
            }
        }, {
            path: 'password',
            name: 'change-password',
            component: __WEBPACK_IMPORTED_MODULE_11__components_account_ChangePassword__["a" /* default */],
            meta: {
                crumbs: ['home', 'account']
            }
        }, {
            path: 'password',
            name: 'password-reset-form',
            component: __WEBPACK_IMPORTED_MODULE_11__components_account_ChangePassword__["a" /* default */],
            meta: {
                crumbs: ['home', 'account']
            }
        }]
    }, {
        path: '/experiences',
        name: 'experiences',
        component: __WEBPACK_IMPORTED_MODULE_13__pages_Experiences__["a" /* default */],
        meta: {
            crumbs: ['home']
        }
    }, {
        path: '/referrals',
        name: 'referrals',
        component: __WEBPACK_IMPORTED_MODULE_12__pages_Referrals__["a" /* default */],
        meta: {
            auth: true,
            crumbs: ['home']
        }
    }, {
        path: '/welcome-to-minimax',
        name: 'welcome',
        component: __WEBPACK_IMPORTED_MODULE_18__pages_WelcomePage__["a" /* default */],
        meta: {
            auth: true,
            crumbs: ['home']
        }
    }, {
        path: '/styleguide',
        name: 'styleguide',
        component: __WEBPACK_IMPORTED_MODULE_14__pages_Styleguide__["a" /* default */],
        meta: {
            auth: false,
            crumbs: ['home'],
            debugRoute: true
        }
    }, {
        path: '/guidelines',
        name: 'guidelines',
        component: __WEBPACK_IMPORTED_MODULE_17__pages_Guidelines__["a" /* default */],
        meta: {
            auth: false,
            crumbs: ['home'],
            debugRoute: true
        }
    }, {
        path: '/auth',
        component: __WEBPACK_IMPORTED_MODULE_16__pages_AuthenticationPage__["a" /* default */],
        children: [{
            path: '/',
            name: 'sign-in',
            component: __WEBPACK_IMPORTED_MODULE_20__components_auth_forms_LoginForm__["a" /* default */],
            meta: {
                crumbs: ['home']
            }
        }, {
            path: 'register',
            name: 'register',
            component: __WEBPACK_IMPORTED_MODULE_21__components_auth_forms_RegisterForm__["a" /* default */],
            meta: {
                crumbs: ['home', 'sign-in']
            }
        }, {
            path: 'reset',
            name: 'reset',
            component: __WEBPACK_IMPORTED_MODULE_23__components_auth_forms_PasswordForgottenForm__["a" /* default */],
            meta: {
                crumbs: ['home', 'sign-in']
            }
        }, {
            path: 'reset/:token',
            name: 'reset/token',
            component: __WEBPACK_IMPORTED_MODULE_22__components_auth_forms_PasswordResetForm__["a" /* default */],
            meta: {
                crumbs: ['home']
            }
        }, {
            path: 'activate/:token',
            name: 'activate',
            component: __WEBPACK_IMPORTED_MODULE_24__components_auth_forms_ActivationForm__["a" /* default */],
            meta: {
                crumbs: ['home']
            }
        }]
    }, {
        path: '**',
        name: 'page-not-found',
        component: __WEBPACK_IMPORTED_MODULE_15__pages_PageNotFound__["a" /* default */],
        meta: {
            crumbs: ['home']
        }
    }]
});

router.beforeEach(function (to, from, next) {
    if (to.matched.some(function (record) {
        return record.meta.auth;
    })) {
        if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters[__WEBPACK_IMPORTED_MODULE_3__store_modules_auth__["d" /* IS_AUTHENTICATED */]]) {
            next({
                name: 'sign-in',
                query: {
                    redirect: to.path
                }
            });
            return;
        } else {
            if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters[__WEBPACK_IMPORTED_MODULE_4__store_modules_proposal_progress__["c" /* GET_INSTALLATION_PLACED */]]) {
                if (to.name !== 'welcome') {
                    next({
                        name: 'welcome'
                    });
                    return;
                }
            } else {
                if (to.name === 'welcome') {
                    next({
                        name: 'saltblocks'
                    });
                    return;
                }
            }
        }
    }
    next();
});

router.beforeEach(function (to, from, next) {
    try {
        if (to.query.force_lang === 'nl') {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_5__store_modules_locale__["b" /* SET_LANGUAGE */], 'nl');
        }
        if (to.query.force_lang === 'fr') {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_5__store_modules_locale__["b" /* SET_LANGUAGE */], 'fr');
        }
    } catch (e) {
        __WEBPACK_IMPORTED_MODULE_25_raven_js___default.a.captureException(e);
    }
    next();
});

router.beforeEach(function (to, from, next) {
    if (to.matched.some(function (record) {
        return record.meta.debugRoute;
    })) {
        if (!__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$config.debug) {
            next({ path: '/page-not-found' });
        } else {
            next();
        }
    } else {
        next();
    }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_SUBMITTING_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SUBMIT_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_SUBMITTING_ORDER; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_instance__ = __webpack_require__(17);





var namespace = 'order_salt/';

var SET_SUBMITTING_ORDER = namespace + 'SET_SUBMITTING_ORDER';
var SUBMIT_ORDER = namespace + 'submit';
var GET_SUBMITTING_ORDER = namespace + 'GET_SUBMITTING_ORDER';

/* harmony default export */ __webpack_exports__["d"] = ({
    state: {
        amount: null,
        submittingOrder: false
    },
    mutations: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, SET_SUBMITTING_ORDER, function (state, submitting) {
        return state.submittingOrder = submitting;
    }),
    actions: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, SUBMIT_ORDER, function (_, payload) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_3__api_instance__["a" /* default */].post('planners/api/planners/customer_contact_moment_selection', payload);

                        case 2:
                            return _context.abrupt('return', _context.sent);

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }),
    getters: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, GET_SUBMITTING_ORDER, function (state) {
        return state.submittingOrder;
    })
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_REFERRALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SUBMIT_REFERRAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_REFERRALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REFERRAL_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REFERRAL_ACCEPTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REFERRAL_DISCOUNT_RECEIVED; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_instance__ = __webpack_require__(17);




var _mutations, _actions;



var namespace = 'referrals/';

var SET_REFERRALS = namespace + 'set_referrals';
var ADD_REFERRAL = namespace + 'add_referral';

var FETCH_REFERRALS = namespace + 'fetch_referrals';
var SUBMIT_REFERRAL = namespace + 'submit';
var GET_REFERRALS = namespace + 'get_referrals';

var REFERRAL_PENDING = 'pending';
var REFERRAL_ACCEPTED = 'accepted';
var REFERRAL_DISCOUNT_RECEIVED = 'discount_received';

/* harmony default export */ __webpack_exports__["g"] = ({
    state: {
        referrals: [{
            email: 'user1@example.com',
            date: '17-08-2021 12:11',
            state: REFERRAL_PENDING
        }, {
            email: 'user2@example.com',
            date: '17-08-2021 12:11',
            state: REFERRAL_ACCEPTED
        }, {
            email: 'user5@example.com',
            date: '17-08-2021 12:11',
            state: REFERRAL_DISCOUNT_RECEIVED
        }]
    },
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, SET_REFERRALS, function (state, referrals) {
        return state.referrals = referrals;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, ADD_REFERRAL, function (state, referral) {
        return state.referrals.splice(0, 0, referral);
    }), _mutations),
    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, FETCH_REFERRALS, function (_ref) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_3__api_instance__["a" /* default */].get('contact_persons/api/contact_persons/references');

                        case 2:
                            response = _context.sent;

                            if (!Array.isArray(response)) {
                                _context.next = 7;
                                break;
                            }

                            commit(SET_REFERRALS, response);
                            _context.next = 9;
                            break;

                        case 7:
                            commit(SET_REFERRALS, []);
                            throw 'Response is not an array';

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, SUBMIT_REFERRAL, function (_ref2, email) {
        var _this2 = this;

        var commit = _ref2.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var payload, response;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            payload = {
                                email: email
                            };
                            _context2.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_3__api_instance__["a" /* default */].post('contact_persons/api/contact_persons/pre_reference', payload);

                        case 3:
                            response = _context2.sent;

                            commit(ADD_REFERRAL, response);

                        case 5:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    }), _actions),
    getters: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, GET_REFERRALS, function (state) {
        return state.referrals;
    })
});

/***/ }),
/* 236 */,
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_SCHEDULING_INSTALLATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SUBMIT_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_SCHEDULING_INSTALLATION; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_instance__ = __webpack_require__(17);





var namespace = 'plan_installation/';

var SET_SCHEDULING_INSTALLATION = namespace + 'SET_SCHEDULING_INSTALLATION';

var SUBMIT_ORDER = namespace + 'submit';
var GET_SCHEDULING_INSTALLATION = namespace + 'GET_SCHEDULING_INSTALLATION';

/* harmony default export */ __webpack_exports__["d"] = ({
    state: {
        amount: null,
        schedulingInstallation: false
    },
    mutations: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, SET_SCHEDULING_INSTALLATION, function (state, scheduling) {
        return state.schedulingInstallation = scheduling;
    }),
    actions: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, SUBMIT_ORDER, function (_, payload) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_3__api_instance__["a" /* default */].post('planners/api/planners/installation_contact_moment_selection', payload);

                        case 2:
                            return _context.abrupt('return', _context.sent);

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }),
    getters: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, GET_SCHEDULING_INSTALLATION, function (state) {
        return state.schedulingInstallation;
    })
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__languages__ = __webpack_require__(51);



var dynLanguage = {
    get language() {
        return __WEBPACK_IMPORTED_MODULE_1__languages__["b" /* default */].locale;
    },
    get months() {
        return __WEBPACK_IMPORTED_MODULE_1__languages__["b" /* default */].t('datepicker.months');
    },
    get monthsAbbr() {
        return __WEBPACK_IMPORTED_MODULE_1__languages__["b" /* default */].t('datepicker.months_short');
    },
    get days() {
        return __WEBPACK_IMPORTED_MODULE_1__languages__["b" /* default */].t('datepicker.days');
    },
    get rtl() {
        return false;
    },
    get ymd() {
        return false;
    },
    get yearSuffix() {
        return __WEBPACK_IMPORTED_MODULE_1__languages__["b" /* default */].t('datepicker.year_suffix');
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'datepicker',
    extends: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */],
    created: function created() {
        this.language = dynLanguage;
    }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STAGE_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STAGE_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STAGE_APPOINTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STAGE_POSTED; });
var STAGE_TITLE = 0;
var STAGE_DETAIL = 1;
var STAGE_APPOINTMENT = 2;
var STAGE_POSTED = 3;

/***/ }),
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logging__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unique_id_helper__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_hooks__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notifications__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__languages__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_js_modal__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_axios__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_raven_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_raven_js_plugins_vue__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_v_tooltip__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_v_media_query__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_v_media_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_v_media_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_modules_locale__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants_breakpoints__ = __webpack_require__(77);




















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_js_modal___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_v_tooltip__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_v_media_query___default.a);

__WEBPACK_IMPORTED_MODULE_14_v_tooltip__["a" /* default */].enabled = window.innerWidth > __WEBPACK_IMPORTED_MODULE_17__constants_breakpoints__["b" /* SCREEN_SM */];

var configFileName =  true ? 'config.json' : process.env.NODE_ENV + '.json';
__WEBPACK_IMPORTED_MODULE_10__api__["a" /* axiosInstance */].get('/static/' + configFileName).then(function (config) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$config = config;
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$config.debug = "production" === 'development';

    __WEBPACK_IMPORTED_MODULE_10__api__["a" /* axiosInstance */].defaults.baseURL = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$config.api.url;
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_10__api__["a" /* axiosInstance */]);

    connectRaven();
    connectAnalytics();

    __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_16__store_modules_locale__["b" /* SET_LANGUAGE */], __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters[__WEBPACK_IMPORTED_MODULE_16__store_modules_locale__["a" /* GET_LANGUAGE */]]);

    new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
        el: '#app',
        router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
        i18n: __WEBPACK_IMPORTED_MODULE_7__languages__["b" /* default */],
        store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
        template: '<App/>',
        components: { App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */] }
    });
}, function (err) {
    return console.log('No configuration fie provided.');
});

function connectRaven() {
    var config = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$config;
    if (!config.debug && config.errorTracking && config.errorTracking.enabled) {
        __WEBPACK_IMPORTED_MODULE_12_raven_js___default.a.config(config.errorTracking.url).addPlugin(__WEBPACK_IMPORTED_MODULE_13_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_1_vue__["default"]).install();
    }
}

function connectAnalytics() {
    var config = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$config;
    if (!config.debug && config.analytics && config.analytics.enabled) {
        var VueAnalytics = __webpack_require__(492);
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(VueAnalytics, {
            id: config.analytics.id,
            router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
            autoTracking: {
                screenview: true,
                pageviewTemplate: function pageviewTemplate(route) {
                    return {
                        page: route.path,
                        title: route.name,
                        location: window.location.href
                    };
                }
            }
        });
    }
}

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);



if (false) {
    ['log', 'warn', 'error'].forEach(function (name) {
        var func = console[name];
        console[name] = function () {
            for (var _len = arguments.length, str = Array(_len), _key = 0; _key < _len; _key++) {
                str[_key] = arguments[_key];
            }

            var message = str.map(function (item) {
                if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') {
                    item = _JSON$stringify(item, null, 4);
                }
                return item;
            }).join(' ');
            func(message);
        };
    });
}

/***/ }),
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('gen', function (el, binding, vnode) {
    var elementKeys = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(binding.modifiers, function (value, key) {
        return value ? key : undefined;
    }).filter(function (key) {
        return key;
    });

    var componentName = vnode.context.$vnode.tag;

    var id = componentName;
    if (binding.arg) {
        id += '--' + binding.arg;
    }
    if (binding.value) {
        id += '--' + binding.value;
    }
    elementKeys.forEach(function (key) {
        return el.setAttribute(key, id);
    });
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);


__WEBPACK_IMPORTED_MODULE_0_vue_class_component___default.a.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate']);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_notify__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_notify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_notify__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue2_notify___default.a, {
    itemClass: '',
    permanent: false,
    duration: 300,
    visibility: 5000,

    position: 'bottom-right'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$notify.setTypes({
    info: { itemClass: 'toaster', iconClass: 'toaster__icon mdi mdi-information' },
    error: { itemClass: 'toaster--error', iconClass: 'toaster__icon mdi mdi-alert-circle' },
    warning: { itemClass: 'toaster--warning', iconClass: 'toaster__icon mdi mdi-alert' },
    success: { itemClass: 'toaster--success', iconClass: 'toaster__icon mdi mdi-checkbox-marked-circle' }
});

/***/ }),
/* 271 */,
/* 272 */,
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_458d2f70_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(369);
function injectStyle (ssrContext) {
  __webpack_require__(274)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_458d2f70_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */,
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return App; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mdi_font_css_materialdesignicons_css__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mdi_font_css_materialdesignicons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__mdi_font_css_materialdesignicons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_TheFooter__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_general_TheHeader__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_general_TheSidebar__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_cookies_CookieNotification__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_general_RouterBreadcrumb__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_modules_auth__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_modules_account_details__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_modules_proposal_progress__ = __webpack_require__(27);






var _dec, _class;













var App = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])({
    components: {
        TheFooter: __WEBPACK_IMPORTED_MODULE_8__components_general_TheFooter__["a" /* default */],
        TheHeader: __WEBPACK_IMPORTED_MODULE_9__components_general_TheHeader__["a" /* default */],
        TheSidebar: __WEBPACK_IMPORTED_MODULE_10__components_general_TheSidebar__["a" /* default */],
        CookieNotification: __WEBPACK_IMPORTED_MODULE_11__components_cookies_CookieNotification__["a" /* default */],
        RouterBreadcrumb: __WEBPACK_IMPORTED_MODULE_12__components_general_RouterBreadcrumb__["a" /* default */]
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(App, _Vue);

    function App() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, App);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = App.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(App)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'app', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(App, [{
        key: 'created',
        value: function created() {
            if (this.$store.getters[__WEBPACK_IMPORTED_MODULE_13__store_modules_auth__["d" /* IS_AUTHENTICATED */]]) {
                this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__store_modules_account_details__["a" /* FETCH_ACCOUNT_DETAILS */]);
                this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_15__store_modules_proposal_progress__["b" /* FETCH_INSTALLATION_PROGRESS */]);
            }
        }
    }, {
        key: 'showNavigation',
        get: function get() {
            return !this.$route.path.startsWith('/auth');
        }
    }, {
        key: 'componentHiddenOnRoute',
        get: function get() {
            return ['activate', 'sign-in', 'reset', 'reset/token'].includes(this.$route.name);
        }
    }]);

    return App;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"])) || _class);


/***/ }),
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 289 */,
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheFooter_vue__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5c2549a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheFooter_vue__ = __webpack_require__(340);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5c2549a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TheFooter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_modules_auth__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LocaleButton__ = __webpack_require__(30);







var _dec, _dec2, _class, _desc, _value, _class2, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}






var TheFooter = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])({
    components: {
        LocaleButton: __WEBPACK_IMPORTED_MODULE_9__LocaleButton__["a" /* default */]
    }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])(), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TheFooter, _Vue);

    function TheFooter() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TheFooter);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = TheFooter.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(TheFooter)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'the-footer', _initDefineProp(_this, 'localeHidden', _descriptor, _this), _this.nlContactPageUrl = 'https://www.minimax.be/waterontharder/contact-wie-zijn-wij', _this.frContactPageUrl = 'https://www.minimax.be/adoucisseur/contact-qui-sommes-nous/contact', _this.locale = {}, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TheFooter, [{
        key: 'created',
        value: function created() {
            this.locale = this.$i18n.locale;
        }
    }, {
        key: 'signOut',
        value: function signOut() {
            var _this2 = this;

            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_8__store_modules_auth__["f" /* LOGOUT */]).then(function () {
                _this2.$router.replace({
                    name: 'sign-in'
                });
            });
        }
    }, {
        key: 'contactPageUrl',
        get: function get() {
            if (this.locale == 'fr') {
                return this.frContactPageUrl;
            } else {
                return this.nlContactPageUrl;
            }
        }
    }, {
        key: 'authenticated',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_8__store_modules_auth__["d" /* IS_AUTHENTICATED */]];
        }
    }]);

    return TheFooter;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'localeHidden', [_dec2], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 108,
	"./af.js": 108,
	"./ar": 109,
	"./ar-dz": 110,
	"./ar-dz.js": 110,
	"./ar-kw": 111,
	"./ar-kw.js": 111,
	"./ar-ly": 112,
	"./ar-ly.js": 112,
	"./ar-ma": 113,
	"./ar-ma.js": 113,
	"./ar-sa": 114,
	"./ar-sa.js": 114,
	"./ar-tn": 115,
	"./ar-tn.js": 115,
	"./ar.js": 109,
	"./az": 116,
	"./az.js": 116,
	"./be": 117,
	"./be.js": 117,
	"./bg": 118,
	"./bg.js": 118,
	"./bm": 119,
	"./bm.js": 119,
	"./bn": 120,
	"./bn.js": 120,
	"./bo": 121,
	"./bo.js": 121,
	"./br": 122,
	"./br.js": 122,
	"./bs": 123,
	"./bs.js": 123,
	"./ca": 124,
	"./ca.js": 124,
	"./cs": 125,
	"./cs.js": 125,
	"./cv": 126,
	"./cv.js": 126,
	"./cy": 127,
	"./cy.js": 127,
	"./da": 128,
	"./da.js": 128,
	"./de": 129,
	"./de-at": 130,
	"./de-at.js": 130,
	"./de-ch": 131,
	"./de-ch.js": 131,
	"./de.js": 129,
	"./dv": 132,
	"./dv.js": 132,
	"./el": 133,
	"./el.js": 133,
	"./en-au": 134,
	"./en-au.js": 134,
	"./en-ca": 135,
	"./en-ca.js": 135,
	"./en-gb": 136,
	"./en-gb.js": 136,
	"./en-ie": 137,
	"./en-ie.js": 137,
	"./en-il": 138,
	"./en-il.js": 138,
	"./en-nz": 139,
	"./en-nz.js": 139,
	"./eo": 140,
	"./eo.js": 140,
	"./es": 141,
	"./es-do": 142,
	"./es-do.js": 142,
	"./es-us": 143,
	"./es-us.js": 143,
	"./es.js": 141,
	"./et": 144,
	"./et.js": 144,
	"./eu": 145,
	"./eu.js": 145,
	"./fa": 146,
	"./fa.js": 146,
	"./fi": 147,
	"./fi.js": 147,
	"./fo": 148,
	"./fo.js": 148,
	"./fr": 74,
	"./fr-ca": 149,
	"./fr-ca.js": 149,
	"./fr-ch": 150,
	"./fr-ch.js": 150,
	"./fr.js": 74,
	"./fy": 151,
	"./fy.js": 151,
	"./gd": 152,
	"./gd.js": 152,
	"./gl": 153,
	"./gl.js": 153,
	"./gom-latn": 154,
	"./gom-latn.js": 154,
	"./gu": 155,
	"./gu.js": 155,
	"./he": 156,
	"./he.js": 156,
	"./hi": 157,
	"./hi.js": 157,
	"./hr": 158,
	"./hr.js": 158,
	"./hu": 159,
	"./hu.js": 159,
	"./hy-am": 160,
	"./hy-am.js": 160,
	"./id": 161,
	"./id.js": 161,
	"./is": 162,
	"./is.js": 162,
	"./it": 163,
	"./it.js": 163,
	"./ja": 164,
	"./ja.js": 164,
	"./jv": 165,
	"./jv.js": 165,
	"./ka": 166,
	"./ka.js": 166,
	"./kk": 167,
	"./kk.js": 167,
	"./km": 168,
	"./km.js": 168,
	"./kn": 169,
	"./kn.js": 169,
	"./ko": 170,
	"./ko.js": 170,
	"./ky": 171,
	"./ky.js": 171,
	"./lb": 172,
	"./lb.js": 172,
	"./lo": 173,
	"./lo.js": 173,
	"./lt": 174,
	"./lt.js": 174,
	"./lv": 175,
	"./lv.js": 175,
	"./me": 176,
	"./me.js": 176,
	"./mi": 177,
	"./mi.js": 177,
	"./mk": 178,
	"./mk.js": 178,
	"./ml": 179,
	"./ml.js": 179,
	"./mn": 180,
	"./mn.js": 180,
	"./mr": 181,
	"./mr.js": 181,
	"./ms": 182,
	"./ms-my": 183,
	"./ms-my.js": 183,
	"./ms.js": 182,
	"./mt": 184,
	"./mt.js": 184,
	"./my": 185,
	"./my.js": 185,
	"./nb": 186,
	"./nb.js": 186,
	"./ne": 187,
	"./ne.js": 187,
	"./nl": 75,
	"./nl-be": 188,
	"./nl-be.js": 188,
	"./nl.js": 75,
	"./nn": 189,
	"./nn.js": 189,
	"./pa-in": 190,
	"./pa-in.js": 190,
	"./pl": 191,
	"./pl.js": 191,
	"./pt": 192,
	"./pt-br": 193,
	"./pt-br.js": 193,
	"./pt.js": 192,
	"./ro": 194,
	"./ro.js": 194,
	"./ru": 195,
	"./ru.js": 195,
	"./sd": 196,
	"./sd.js": 196,
	"./se": 197,
	"./se.js": 197,
	"./si": 198,
	"./si.js": 198,
	"./sk": 199,
	"./sk.js": 199,
	"./sl": 200,
	"./sl.js": 200,
	"./sq": 201,
	"./sq.js": 201,
	"./sr": 202,
	"./sr-cyrl": 203,
	"./sr-cyrl.js": 203,
	"./sr.js": 202,
	"./ss": 204,
	"./ss.js": 204,
	"./sv": 205,
	"./sv.js": 205,
	"./sw": 206,
	"./sw.js": 206,
	"./ta": 207,
	"./ta.js": 207,
	"./te": 208,
	"./te.js": 208,
	"./tet": 209,
	"./tet.js": 209,
	"./tg": 210,
	"./tg.js": 210,
	"./th": 211,
	"./th.js": 211,
	"./tl-ph": 212,
	"./tl-ph.js": 212,
	"./tlh": 213,
	"./tlh.js": 213,
	"./tr": 214,
	"./tr.js": 214,
	"./tzl": 215,
	"./tzl.js": 215,
	"./tzm": 216,
	"./tzm-latn": 217,
	"./tzm-latn.js": 217,
	"./tzm.js": 216,
	"./ug-cn": 218,
	"./ug-cn.js": 218,
	"./uk": 219,
	"./uk.js": 219,
	"./ur": 220,
	"./ur.js": 220,
	"./uz": 221,
	"./uz-latn": 222,
	"./uz-latn.js": 222,
	"./uz.js": 221,
	"./vi": 223,
	"./vi.js": 223,
	"./x-pseudo": 224,
	"./x-pseudo.js": 224,
	"./yo": 225,
	"./yo.js": 225,
	"./zh-cn": 226,
	"./zh-cn.js": 226,
	"./zh-hk": 227,
	"./zh-hk.js": 227,
	"./zh-tw": 228,
	"./zh-tw.js": 228
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 326;

/***/ }),
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocaleButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_modules_locale__ = __webpack_require__(50);







var _dec, _class, _desc, _value, _class2, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}





var LocaleButton = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: String, required: true }), Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(LocaleButton, _Vue);

    function LocaleButton() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, LocaleButton);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = LocaleButton.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(LocaleButton)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'language', _descriptor, _this), _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(LocaleButton, [{
        key: 'click',
        value: function click() {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_8__store_modules_locale__["b" /* SET_LANGUAGE */], this.language);
        }
    }, {
        key: 'active',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_8__store_modules_locale__["a" /* GET_LANGUAGE */]] === this.language;
        }
    }, {
        key: 'label',
        get: function get() {
            return this.language.toUpperCase();
        }
    }]);

    return LocaleButton;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'language', [_dec], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),
/* 335 */,
/* 336 */
/***/ (function(module, exports) {

module.exports = {"account_info":{"address_information":"Votre adresse a changé?","address_information_contact":"Nous contacter","address_information_contact_url":"https://www.minimax.be/adoucisseur/contact-qui-sommes-nous/contact","button_change_password":"Changer le mot de passe","button_edit":"Modifier les données","header_main":"Informations de votre compte","guarantee":{"active_until":"Votre garantie Minimax est valable jusqu'au : {date}","expired_on":"Votre garantie a malheureusement expiré le {date}","no-installation-moment-found":"Aucune information de garantie disponible","unavailable":"Votre garantie a malheureusement expiré"}},"app_advert":{"btn_download":"Télécharger l'application","do_you_know":"Connaissez-vous déjà notre application pour le sel?","easy_order":"Commandez vos blocs de sel de l'application","reasons":{"0":"Recevez un rappel lorsque vos blocs de sel sont presque finis","1":"Commandez vos blocs de sel de l'application"},"the_app_is_free":"L'application est téléchargeable gratuitement pour les téléphones android"},"auth":{"already_activated_account":"Le compte est déjà activé. Cliquez ici pour vous connecter.","button_activate_account":"Activer le compte","button_cancel":"Annuler","button_change_password":"Modifier le mot de passe","button_reset_activate_account_link":"Votre lien a expiré. Nous vous avons envoyé un nouveau lien par courriel. Consultez votre boîte de réception pour continuer.","button_reset_password":"Réinitialiser le mot de passe","button_send_reset_activate_account_link":"Renvoyer","button_signin":"Se connecter","desired_password":"Mot de passe choisi","error_email":"Veuillez entrer une adresse e-mail valide (e.g. vous@fournisseur.com)","error_missing_email":"Veuillez entrer votre adresse e-mail","error_password":"Entrez votre mot de passe","header_activate_account":"Activer votre compte","header_forgotten_password":"Mot de passe oublié?","header_reset_password":"Modifier votre mot de passe","header_signin":"Se connecter","header_sub_activate_account":"Complétez votre compte en définissant un mot de passe.","header_sub_activate_account_resend":"Entrez votre adresse e-mail ci-dessous pour obtenir un nouveau lien.","header_sub_reset_password":"Pour modifier votre mot de passe, entrez ici deux fois le mot de passe souhaité.","header_sub_signin":"Commandez des blocs de sel, affichez les commandes et laissez des avis, le tout dans un seul tableau de bord!","hint_email":"Adresse e-mail","hint_password":"Mot de passe","invalid_email_password":"Vous avez entré une combinaison invalide du nom d'utilisateur et du mot de passe.","link_forgot_password":"Mot de passe oublié?","link_no_account":"Pas encore de compte?","new_password":"Nouveau mot de passe","notify_failures":{"activate_account":{"general":"Échec de l'activation du compte","invalid_token":"Ce lien n'est plus valide","resend_activation_link":"Une erreur s'est produite lors de l'envoi d'un nouvel e-mail, veuillez réessayer dans quelques minutes."},"reset_password":{"general":"Échec de la réinitialisation du mot de passe","invalid_token":"Ce lien n'est plus valide"}},"notify_login_failure":"Échec de la connexion","notify_success_activate_account":"Votre compte a été activé avec succès","notify_success_resend_activation_link":"Votre nouveau lien a été envoyé avec succès.","notify_success_reset_password":"Votre mot de passe a été réinitialisé avec succès","old_password":"Mot de passe actuel","repeat_desired_password":"Répéter le mot de passe choisi","repeat_new_password":"Répéter le nouveau mot de passe"},"common":{"account_title":{"F":"Madame","M":"Monsieur"},"button":{"add":"Ajouter","cancel":"Annuler","edit":"Modifier","go_back":"Retour","remove":"Enlever"},"languages":{"fr":"Français","nl":"Néerlandais"},"notify_fetch_failure":"Échec de la récupération des données","order_type":{"installations":"Installation","maintenance":"Entretien","orders":"Commande","proposal":"Proposition","repair":"Intervention"},"question_unsaved_changes":"Des modifications n'ont pas été enregistrées, voulez-vous vraiment continuer?","referral_state":{"completed":"Vendu","error":"Message d'erreur","in_progress":"En traitement","send":"E-mail envoyé","used":"Vendu"}},"cookies":{"confirm":"Je comprends","cookies":"Cookies","description":"Ce site utilise des cookies pour une meilleure expérience utilisateur.","more_information":"Plus d'information"},"datepicker":{"days":{"0":"Dim","1":"Lun","2":"Mar","3":"Mer","4":"Jeu","5":"Ven","6":"Sam"},"months":{"0":"Janvier","1":"Février","2":"Mars","3":"Avril","4":"Mai","5":"Juin","6":"Juillet","7":"Août","8":"Septembre","9":"Octobre","10":"Novembre","11":"Décembre"},"months_short":{"0":"Jan","1":"Fév","2":"Mar","3":"Avr","4":"Mai","5":"Juin","6":"Juil","7":"Août","8":"Sep","9":"Oct","10":"Nov","11":"Déc"}},"experiences":{"header_main":"Expériences et avis","history":{"header_sub":"Vos avis","info":"Vous voyez ici vos avis et vos témoignages. Dès leur acceptation par nos administrateurs web, ils deviendront visibles sur le site.","status":"Statut"},"no_reviews":"Vous n'avez pas encore d'avis.","status":{"approved":"Approuvé","declined":"Rejeté","error":"Erreur","pending":"En attente","unknown":"Inconnu"},"view_more":"Voir plus"},"footer":{"address":"Notre adresse","call_us":"Appelez-nous","contact":"Contact","copyrights":"Adoucisseurs d'eau Minimax","mail_us":"Envoyez-nous un e-mail","more_contact_info":"Plus d'informations de contact"},"form":{"account_info":{"button_submit":"Enregistrer les modifications","label_address":"Nom de rue","label_address_number":"Numéro de maison","label_city_name":"Commune","label_country_name":"Pays","label_email_address":"adresse électronique","label_first_name":"Prénom","label_gender":"Bonjour","label_last_name":"Nom de famille","label_mobile_number":"GSM","label_postal_code":"Code postal","label_telephone_number":"Téléphone","label_guarantee":"Garantie","notify_failure":"L'enregistrement a échoué","notify_failure_change_password":"La modification du mot de passe a échoué","notify_success":"Modifications enregistrées","placeholder_address":"e.g. Route des Crêtes","placeholder_address_number":"e.g. 44a","placeholder_city_name":"e.g. Paris","placeholder_country_name":"e.g. France","placeholder_email_address":"e.g. nom@example.com","placeholder_first_name":"Prénom...","placeholder_gender":"Mme, Mr","placeholder_last_name":"Nom de famille...","placeholder_mobile_number":"e.g. 0412 34 56 78","placeholder_postal_code":"e.g. 7500","placeholder_telephone_number":"e.g. 01 234 56 78"},"appointment":{"add_date":"Ajouter une date","address":"Les blocs de sel seront envoyés à l'adresse suivante:","button_submit":"Envoyer la demande","header_multiple_allowed":"Vous pouvez spécifier plusieurs dates","header_slots":"A quelle heure êtes-vous disponible?","label_afternoon":"Après-midi","label_afternoon_time":"Entre 11h00 et 15h00","label_city":"Ville","label_comment":"Commentaires","label_country":"Pays","label_evening":"Soirée","label_evening_time":"Entre 17h00 et 20h00","label_moment_date":"Date:","label_moment_slots":"Heures du jour:","label_morning":"Matin","label_morning_time":"Entre 08h00 et 12h00","label_number":"Numéro","label_postalCode":"Code postal","label_street":"Rue","placeholder_city":"e.g. Namur","placeholder_comment":"Laisser un commentaire","placeholder_country":"e.g. France","placeholder_number":"e.g. 00a","placeholder_postalCode":"e.g. 1439","placeholder_street":"e.g. Rue de l'Église"},"experience":{"button_review":"Ajouter un avis","button_review_submit":"Envoyer","error":{"rating":"Veuillez sélectionner un score","review":"Veuillez entrer un avis","title":"Veuillez entrer un titre"},"header_main":"Ajouter un avis (review)","label_info":"Partagez vos expériences sur nos produits et services avec la communauté MINIMAX. Vos précieuses informations peuvent aider d'autres clients.","notify_failure":"L'enregistrement de l'avis a échoué","notify_success":"L'avis est enregistré","placeholder_review":"Ecrivez ici l'avis","placeholder_title":"Ecrivez ici le titre de l'avis"},"installation":{"appointment":{"address":"Adresse:"},"button_submit":"Planifier le rendez-vous","has_ordered_information":{"email_calendar":"Vous recevrez un e-mail de confirmation que vous pourrez ajouter à votre agenda.","email_mail":"Un jour (ou plus) avant la date choisie, vous recevrez un e-mail confirmant si nous passerons le matin ou l'après-midi.","location":"À la date convenue, nous viendrons installer votre appareil Minimax.","phone":"Si, pour quelque raison que ce soit, vous devez annuler ou modifier votre rendez-vous, veuillez appeler:","successfully_requested":"Votre rendez-vous d'installation a bien été planifié.","thank_you_time":"Merci pour votre temps!"},"label_info":"Veuillez sélectionner la date qui vous convient pour le rendez-vous d'installation.","notify_failure":"Le planification du rendez-vous d'installation a échoué","notify_success":"Rendez-vous d'installation planifié"},"order_salt":{"available_dates":"Dates disponibles:","button_submit":"Planifier votre demande de livraison","co2_saved":"Économie de CO2","error_fetching_available_contact_moments":"Nous ne trouvons pas de date pour vous en ce moment. Contactez le 0800 / 24 550 pour un rendez-vous.","has_ordered_information":{"email_calendar":"Vous recevrez une confirmation par e-mail avec un lien pour votre agenda.","email_mail":"Vous recevrez encore un e-mail indiquant le passage de notre technicien en matinée ou après 11h.","location":"Le jour choisi nous livrons les blocs de sel et nous faisons le contrôle du Minimax.","phone":"Si vous souhaitez annuler le rendez-vous, appelez le numéro ci-dessous:","successfully_requested":"Vous avez planifié avec succès une demande de livraison pour ","thank_you_time":"Merci pour votre temps!"},"header_main":"Blocs de sel","header_moments_picker":"Choisir une <span>date</span> et un <span>moment</span> pour la livraison de sel:","header_sub":"Planifier une livraison de sel","label_alternative":"Alternative","label_alternative_tooltip":"Le technicien pourra venir chez vous ce jour-là.","label_blocks":"{amount} blocs de sel","label_info":"Ci-dessous vous trouvez des dates disponibles pour une livraison de sel. Quand vous demandez la livraison, nous vous contacterons pour confirmer votre commande. Vous ne trouvez pas de date qui convient dans votre agenda? Prenez contact avec nous. ","label_suggested":"Suggestion","label_suggested_tooltip":"Le technicien sera dans votre voisinage.","no_available_dates_found":"Aucune date disponible n'a été trouvée. Contactez le 0800 / 24 550 pour un rendez-vous.","notify_failure":"Demande de livraison a échoué","notify_success":"Demande de livraison enregistrée","order_under_review_1":"La commande passée le ","order_under_review_2":"est en cours de traitement.","order_under_review_3":"Plus de détails sur votre commande seront envoyés quand elle est acceptée."},"password_forgotten":{"button_back_to_login":"Retour à l'écran de connexion","button_submit":"Réinitialiser le mot de passe","header_main":"Vous avez oublié votre mot de passe?","header_request_success":"Si votre mot de passe nous est connu, vous recevrez un e-mail pour modifier votre mot de passe.","message_failure":"Un problème est survenu","message_forgotten_password":"Entrez votre adresse e-mail et nous vous enverrons un e-mail pour réinitialiser votre mot de passe","message_success":"Un e-mail a été envoyé pour réinitialiser votre mot de passe à {email}.","placeholder_email":"Adresse électronique"},"referral":{"button_submit":"Envoyer un e-mail","error_email":"Renseigner svp une adresse e-mail valide","header_main":"Recommander Minimax à vos connaissances","label_info":"Parrainez vos amis, par e-mail, et recevez en cas de leur commande une réduction de 50 EUR sur votre prochaine livraison de sel.","notify_failure":"L'enregistrement a échoué","notify_success":"Votre ami est enregistré avec succès et a reçu un message de Minimax.","placeholder_email":"e.g. nom@example.com"}},"menu":{"auth":"Authentification","available_after_installation":"Options disponibles dès que le Minimax est installé","dashboard":"Dashboard","experiences":"Expériences","experiences_sub":"Ajouter des expériences","guidelines":"Directives","home":"Page de garde","info":"Votre compte","info_sub":"Vos informations personnelles","log_in_to_view_your_account_details":"Connectez-vous au portail pour consulter vos données, commander du sel, etc...","orders":"Commandes","orders_sub":"Voir vos commandes","referrals":"Recommander","referrals_sub":"Recevez une réduction de 50 EUR","saltblocks":"Blocs de sel","saltblocks_sub":"Commander des blocs de sel","signout":"Déconnexion","start":"Commencer avec Minimax","steps":[{"title":"Planifier l'installation","subtitle":"Planifiez votre rendez-vous d'installation Minimax"},{"title":"Installation planifiée","subtitle":"L'installation de l'appareil a été planifiée"},{"title":"Appareil installé","subtitle":"Vous pouvez désormais commander du sel via le portail"}],"styleguide":"Directives de design","support":"Aide","support_sub":"Demander une intervention","welcome_to_account":"Bienvenue sur votre compte Minimax"},"orders":{"header_date":"Date","header_id":"#","header_main":"Commandes","header_price":"Montant","header_type":"Type","label_download":"Télécharger le PDF","label_info":"Voici un aperçu de tous vos documents."},"proposal":{"called_appointment":"Appelé pour un rendez-vous","change_date":"Changer la date et l'heure","change_installation_date":"Changer la date et l'heure de l'installation","date_signed":"Date de la signature","expected_date":"Attendu le","expected_time_afternoon":"Dans l'après-midi","expected_time_evening":"Dans la soirée","expected_time_morning":"Dans la matinée","header":"Planifier l'installation","header_moments_picker":"Choisissez une <span> date </span> et un <span> moment </span> pour l'installation du Minimax","header_moments_picker_support":"Choisissez une <span> date </span> et un <span> moment </span> pour l'intervention sur le Minimax","installation_date":"Date d'installation","my_account":"Mon compte","no_date":"Pas de date","notify_change_failure":"La mise à jour de la proposition a échoué","notify_fetch_failure":"L'enregistrement de la proposition a échoué","notify_success":"La proposition a été mise à jour avec succès"},"referrals":{"header_date":"Date","header_email":"Adresse électronique","header_main":"Recommander","header_state":"Statut","header_table":"Amis à qui vous avez recommandé le Minimax","label_table_info":"Voici un aperçu de vos invitations envoyées. Vous pouvez également suivre le statut de l'invitation et voir quand vous recevez la réduction.","state_detail":{"completed":"Vous recevez une remise de 50 EUR!","in_progress":"La demande est en traitement","used":"Remise utilisée"}},"route":{"account":"Compte","activate":"Activer le compte","change-password":"Changer le mot de passe","dashboard":"Dashboard","edit-account":"Modifier","experiences":"Expériences","guidelines":"Directives CSS","home":"Première page","orders":"Commandes","page-not-found":"Page non trouvée","referrals":"Recommander","register":"Enregistrer","reset":"Mot de passe oublié","reset/token":"Réinitialiser le mot de passe","saltblocks":"Blocs de sel","sign-in":"Se connecter","styleguide":"Style de la maison","support":"Aide","welcome":"Bienvenue chez Minimax"},"support":{"wizard":{"button_continue":"Étape suivante","detail":{"header_custom":"Autre, à savoir...","header_hardness_too_high":"Dureté de l'eau trop élevée","header_hardness_too_low":"Dureté de l'eau trop faible","header_malfunction_broken":"Composant(s) cassé(s)","header_malfunction_leak":"Fuite","header_salt_block_doesnt_fit":"Les blocs de sel ne rentrent pas","header_salt_too_high":"Sel dans l'eau","header_salt_too_low":"Pas de consommation de sel","label_hardness_too_high":"La dureté de l'eau est supérieure à ce que le système devrait produire","label_hardness_too_low":"La dureté de l'eau est inférieure à ce que le système devrait produire","label_header_custom":"Décrivez le problème","label_malfunction_broken":"Un ou plusieurs composants de l'installation sont cassés","label_malfunction_leak":"Vous constatez une fuite","label_salt_block_doesnt_fit":"Si les blocs de sel ne rentrent pas dans la configuration Minimax, sélectionnez cette option","label_salt_too_high":"Si l'eau est salée, sélectionnez cette option","label_salt_too_low":"Si le bloc de sel ne descend plus, sélectionnez cette option"},"label_appointment_stage":"À quelles dates l'équipe Minimax pourrait-elle venir?","label_detail_stage":"Quel est votre problème?","label_posted_stage":"Votre demande d'assistance a été reçue et recevra une réponse rapidement","label_title_stage":"Choisissez la catégorie dans laquelle votre problème relève","notify_failure":"L'envoi de la demande a échoué","notify_success":"Demande envoyée avec succès","please_type_issue":"Décrivez brièvement le problème","state_send_request":"Envoyer une demande","state_send_request_sub":"Choisissez une date pour l'intervention","state_what":"Détails","state_what_sub":"Qu'est-ce qui ne marche pas?","state_where":"Où est le problème?","state_where_sub":"Quel composant du Minimax ne fonctionne pas?","title":{"header_custom":"Sinon","header_hardness":"Dureté de l'eau","header_malfunction":"Panne","header_salt_blocks":"Blocs de sel","label_custom":"Decrivez le problème à l'étape suivante","label_hardness":"Il y a un problème avec la dureté de l'eau après le passage dans le Minimax","label_malfunction":"Le système ne fonctionne pas","label_salt_blocks":"Il y a un problème avec les blocs de sel"}}}}

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports = {"account_info":{"address_information":"Is uw adres aangepast?","address_information_contact":"Contacteer ons","address_information_contact_url":"https://www.minimax.be/waterontharder/contact-wie-zijn-wij","button_change_password":"Wachtwoord wijzigen","button_edit":"Gegevens wijzigen","header_main":"Account info","guarantee":{"active_until":"Jouw Minimax garantie verloopt op: {date}","expired_on":"Je garantie is helaas verlopen op {date}","no-installation-moment-found":"Geen garantie-informatie beschikbaar","unavailable":"Je garantie is helaas verlopen"}},"app_advert":{"btn_download":"Download de app","do_you_know":"Kent u onze handige zout-app al?","easy_order":"Eenvoudig zoutblokken bestellen vanuit de app","reasons":{"0":"Krijg een herinnering als uw zoutblokken bijna op zijn","1":"Eenvoudig zoutblokken bestellen vanuit de app"},"the_app_is_free":"De app is gratis te downloaden voor android telefoons"},"auth":{"already_activated_account":"Het account is al geactiveerd. Klik hier om in te loggen.","button_activate_account":"Activeer account","button_cancel":"Annuleren","button_change_password":"Verander wachtwoord","button_reset_activate_account_link":"Je link is verlopen. We hebben een nieuwe link naar je e-mailadres gestuurd. Controleer je inbox om verder te gaan.","button_reset_password":"Wachtwoord resetten","button_send_reset_activate_account_link":"Opnieuw verzenden","button_signin":"Inloggen","desired_password":"Gekozen wachtwoord","error_email":"Vul alstublieft een geldig email adres in (bijv. iemand@example.com)","error_missing_email":"Vul alstublieft een e-mailadres in","error_password":"Vul alstublieft uw wachtwoord in.","header_activate_account":"Activeer uw account","header_forgotten_password":"Wachtwoord vergeten?","header_reset_password":"Verander je wachtwoord","header_signin":"Inloggen","header_sub_activate_account":"Maak uw account compleet door een wachtwoord in te stellen.","header_sub_activate_account_resend":"Vul hieronder uw e-mailadres in om een nieuwe link te verkrijgen.","header_sub_reset_password":"Om uw wachtwoord te veranderen, vult u hier twee keer uw gewenste wachtwoord in.","header_sub_signin":"Bestel zoutblokken, bekijk bestellingen en laat reviews achter, allemaal in één dashboard!","hint_email":"E-mailadres","hint_password":"Wachtwoord","invalid_email_password":"U heeft een ongeldige combinatie van uw gebruikersnaam en wachtwoord ingevoerd.","link_forgot_password":"Wachtwoord vergeten?","link_no_account":"Nog geen account?","new_password":"Nieuw wachtwoord","notify_failures":{"activate_account":{"general":"Account activeren mislukt","invalid_token":"Deze link is niet meer geldig","resend_activation_link":"Er is iets fout gegaan tijdens het versturen van een nieuwe email, probeer het over een paar minuten nog een keer."},"reset_password":{"general":"Wachtwoord resetten mislukt","invalid_token":"Deze link is niet meer geldig"}},"notify_login_failure":"Inloggen mislukt","notify_success_activate_account":"Uw account is succesvol geactiveerd","notify_success_resend_activation_link":"Uw nieuwe link is succesvol verzonden.","notify_success_reset_password":"Uw wachtwoord is succesvol opnieuw ingesteld","old_password":"Huidig wachtwoord","repeat_desired_password":"Herhaal gekozen wachtwoord","repeat_new_password":"Herhaal nieuw wachtwoord"},"common":{"account_title":{"F":"Mevr.","M":"Dhr."},"button":{"add":"Toevoegen","cancel":"Annuleren","edit":"Wijzigen","go_back":"Ga terug","remove":"Verwijderen"},"languages":{"fr":"Frans","nl":"Nederlands"},"notify_fetch_failure":"Ophalen gegevens mislukt","order_type":{"installations":"Installatie","maintenance":"Onderhoud","orders":"Bestelling","proposal":"Voorstel","repair":"Reparatie"},"question_unsaved_changes":"Er zijn onopgeslagen wijzigingen, weet u zeker dat u verder wilt gaan?","referral_state":{"completed":"Verkocht","error":"Foutmelding","in_progress":"In behandeling","send":"E-mail verzonden","used":"Verkocht"}},"cookies":{"confirm":"Ik snap het","cookies":"Cookies","description":"Deze website gebruikt cookies voor een betere gebruikerservaring.","more_information":"Meer informatie"},"datepicker":{"days":{"0":"zo","1":"ma","2":"di","3":"wo","4":"do","5":"vr","6":"za"},"months":{"0":"januari","1":"februari","2":"maart","3":"april","4":"mei","5":"juni","6":"juli","7":"augustus","8":"september","9":"oktober","10":"november","11":"december"},"months_short":{"0":"jan","1":"feb","2":"maa","3":"apr","4":"mei","5":"jun","6":"jul","7":"aug","8":"sep","9":"okt","10":"nov","11":"dec"}},"experiences":{"header_main":"Ervaringen en reviews","history":{"header_sub":"Jouw reviews","info":"Hier zie je de reviews en ervaringen die u hebt toegevoegd. Op het moment dat ze zijn geaccepteerd door onze web-administrators worden deze zichtbaar op de website.","status":"Status"},"no_reviews":"U heeft nog geen reviews.","status":{"approved":"Goedgekeurd","declined":"Afgekeurd","error":"Fout","pending":"In afwachting","unknown":"Onbekend"},"view_more":"Bekijk meer"},"footer":{"address":"Ons adres","call_us":"Bel ons","contact":"Contact","copyrights":"Minimax Waterontharders","mail_us":"Mail ons","more_contact_info":"Meer contactinformatie"},"form":{"account_info":{"button_submit":"Wijzigingen opslaan","label_address":"Straatnaam","label_address_number":"Huisnummer","label_city_name":"Woonplaats","label_country_name":"Land","label_email_address":"E-mailadres","label_first_name":"Voornaam","label_gender":"Aanhef","label_last_name":"Achternaam","label_mobile_number":"GSM","label_postal_code":"Postcode","label_telephone_number":"Telefoon","label_guarantee":"Garantie","notify_failure":"Opslaan mislukt","notify_failure_change_password":"Wachtwoord wijzigen mislukt","notify_success":"Wijzigingen opgeslagen","placeholder_address":"bijv. Weglaanstraat","placeholder_address_number":"bijv. 44a","placeholder_city_name":"bijv. Amsterdam","placeholder_country_name":"bijv. Nederland","placeholder_email_address":"bijv. iemand@example.com","placeholder_first_name":"Voornaam...","placeholder_gender":"Dhr, Mevr","placeholder_last_name":"Achternaam...","placeholder_mobile_number":"bijv. +0412 34 56 78","placeholder_postal_code":"bijv. 1234","placeholder_telephone_number":"bijv. 01 234 56 78"},"appointment":{"add_date":"Datum toevoegen","address":"De zoutblokken zullen naar het volgende adres verstuurd worden:","button_submit":"Opsturen verzoek","header_multiple_allowed":"U kunt meerdere datums opgeven","header_slots":"Op welke tijden bent u beschikbaar?","label_afternoon":"Middag","label_afternoon_time":"Tussen 12:00 en 15:00","label_city":"Stad","label_comment":"Opmerkingen","label_country":"Land","label_evening":"Avond","label_evening_time":"Tussen 17:00 en 20:00","label_moment_date":"Datum:","label_moment_slots":"Momenten:","label_morning":"Ochtend","label_morning_time":"Tussen 08:00 en 12:00","label_number":"Huisnummer","label_postalCode":"Postcode","label_street":"Straat","placeholder_city":"bijv. Antwerpen","placeholder_comment":"Laat een opmerking achter voor het team","placeholder_country":"bijv. Nederland","placeholder_number":"bijv. 00a","placeholder_postalCode":"bijv. 0000","placeholder_street":"bijv. Weglaanstraat"},"installation":{"appointment":{"address":"Adres:"},"button_submit":"Afspraak plannen","has_ordered_information":{"email_calendar":"U ontvangt een e-mailbevestiging die u aan uw agenda kunt toevoegen.","email_mail":"Een dag (of meer) vóór de gekozen datum ontvangt u een e-mail met de bevestiging of we 's ochtends of 's middags langskomen.","location":"Op de afgesproken datum komen we langs om uw Minimax-toestel te installeren.","phone":"Moet u om welke reden dan ook uw afspraak annuleren of wijzigen? Bel dan:","successfully_requested":"Uw installatieafspraak is succesvol ingepland.","thank_you_time":"Bedankt voor uw tijd!"},"label_info":"Kies uw voorkeursdatum voor de installatieafspraak.","notify_failure":"Het plannen van de installatieafspraak is mislukt","notify_success":"Installatieafspraak gepland"},"experience":{"button_review":"Review toevoegen","button_review_submit":"Versturen","error":{"rating":"Selecteer alstublieft een score","review":"Vul alstublieft een review in","title":"Vul alstublieft een titel in"},"header_main":"Een review toevoegen","label_info":"Deel uw ervaringen over onze producten en services met de MINIMAX community. Uw waardevolle inzichten kunnen andere klanten helpen.","notify_failure":"Review aanmelding mislukt","notify_success":"Review succesvol aangemeld","placeholder_review":"Typ hier de review","placeholder_title":"Typ hier de titel van de review"},"order_salt":{"available_dates":"Beschikbare datums:","button_submit":"Leveringsverzoek plaatsen","co2_saved":"Besparing van CO2","error_fetching_available_contact_moments":"We vinden voor u geen datum op dit moment. Neem contact op met 0800 / 24 550 voor een afspraak.","has_ordered_information":{"email_calendar":"U ontvangt een email confirmatie die je aan uw calendar kan toevoegen.","email_mail":"U ontvangt nog een email die aangeeft of we in de ochtend ofwel na 11h langskomen.","location":"Op de gekozen dag brengen we de zoutblokken en doen we het nazicht van de Minimax.","phone":"Als u voor welke reden dan ook de afspraak wilt afzeggen, bel dan het onderstaande nummer:","successfully_requested":"Je hebt succesvol een leveringsverzoek aangevraagd voor ","thank_you_time":"Bedankt voor uw tijd!"},"header_main":"Zoutblokken","header_moments_picker":"Kies een <span>datum</span> en <span>tijd</span> waarop het zout geleverd kan worden:","header_sub":"Plan een zoutlevering in","label_alternative":"Alternatief","label_alternative_tooltip":"De technieker kan die dag komen aanrijden.","label_blocks":"{amount} zoutblokken","label_info":"Hieronder ziet u mogelijke data voor een levering van zoutblokken. Wanneer u de levering heeft aangevraagd zullen we contact met u opnemen om de bestelling definitief te maken. Komen de data suggesties niet uit met uw planning? Neem dan contact met ons op.","label_suggested":"Suggestie","label_suggested_tooltip":"De technieker is dan in uw buurt.","no_available_dates_found":"Er zijn geen beschikbare data gevonden. Neem contact op met 0800 / 24 550 voor een afspraak.","notify_failure":"Leveringsverzoek mislukt","notify_success":"Leveringsverzoek geplaatst","order_under_review_1":"De bestelling die is geplaatst op ","order_under_review_2":"wordt momenteel verwerkt.","order_under_review_3":"Meer details over de bestelling zal met u worden gedeeld als deze is goedgekeurd."},"password_forgotten":{"button_back_to_login":"Terug naar inlogscherm","button_submit":"Wachtwoord opnieuw instellen","header_main":"Wachtwoord vergeten?","header_request_success":"Als uw wachtwoord bij ons bekend is krijgt u een e-mail om uw wachtwoord aan te passen.","message_failure":"Er is een probleem opgetreden","message_forgotten_password":"Vul uw e-mailadres in en we sturen u een e-mail om uw wachtwoord te resetten","message_success":"Er is een e-mail verstuurd om uw wachtwoord te resetten naar {email}.","placeholder_email":"E-mailadres"},"referral":{"button_submit":"Verstuur e-mail","error_email":"Geef een geldig e-mailadres op","header_main":"Raad Minimax aan bij bekenden","label_info":"Verwijs uw vrienden naar Minimax, via e-mail, en ontvang bij hun bestelling 50 EUR korting op uw volgende zoutbloklevering.","notify_failure":"E-mail aanmelding mislukt","notify_success":"Je vriend is succesvol aangemeld en heeft van Minimax een bericht gekregen.","placeholder_email":"bijv. iemand@example.com"}},"menu":{"auth":"Authenticatie","available_after_installation":"Opties beschikbaar wanneer de Minimax is geïnstalleerd","dashboard":"Dashboard","experiences":"Ervaringen","experiences_sub":"Ervaringen toevoegen","guidelines":"Richtlijnen","home":"Voorpagina","info":"Jouw account","info_sub":"Jouw persoonlijke informatie","log_in_to_view_your_account_details":"Log in in de portal voor inzage in uw gegevens, het bestellen van zout, etc...","orders":"Bestellingen","orders_sub":"Bekijk je bestellingen","referrals":"Aanraden","referrals_sub":"Krijg 50 EUR korting","saltblocks":"Zoutblokken","saltblocks_sub":"Koop zoutblokken","signout":"Uitloggen","start":"Begin met Minimax","steps":[{"title":"Installatie plannen","subtitle":"Plan je Minimax-installatieafspraak"},{"title":"Installatie gepland","subtitle":"De installatie van het apparaat is ingepland"},{"title":"Apparaat geïnstalleerd","subtitle":"Je kunt nu zout bestellen via het portaal"}],"styleguide":"Ontwerp richtlijnen","support":"Hulp","support_sub":"Vraag om hulp","welcome_to_account":"Welkom bij jouw Minimax account"},"orders":{"header_date":"Datum","header_id":"#","header_main":"Bestellingen","header_price":"Bedrag","header_type":"Type","label_download":"Download pdf","label_info":"Hier is een overzicht met alle bestellingen gemaakt met uw account."},"proposal":{"called_appointment":"Gebeld voor een afspraak","change_date":"Wijzig datum en tijd","change_installation_date":"Wijzig de datum en tijd van de installatie","date_signed":"Datum van ondertekenen","expected_date":"Verwacht op","expected_time_afternoon":"In de middag","expected_time_evening":"In de avond","expected_time_morning":"In de ochtend","header":"Installatie plannen","header_moments_picker":"Kies een <span>datum</span> en <span>tijd</span> waarop het Minimax-team langs kan komen voor de installatie","header_moments_picker_support":"Kies een <span>datum</span> en <span>tijd</span> waarop het Minimax-team langs kan komen voor de interventie","installation_date":"Datum van installatie","my_account":"Mijn account","no_date":"Geen datum","notify_change_failure":"Voorstel bijwerken mislukt","notify_fetch_failure":"Ophalen voorstel mislukt","notify_success":"Voorstel succesvol bijgewerkt"},"referrals":{"header_date":"Datum","header_email":"E-mailadres","header_main":"Aanraden","header_state":"Status","header_table":"Vrienden die u de Minimax heeft aangeraden","label_table_info":"Hier is een overzicht van de verzonden uitnodigingen. Ook kunt u hier de status van de uitnodiging volgen en zien wanneer u korting ontvangt.","state_detail":{"completed":"U krijgt 50 EUR korting!","in_progress":"Aanvraag is in behandeling","used":"Korting gebruikt"}},"route":{"account":"Account","activate":"Account activeren","change-password":"Wachtwoord wijzigen","dashboard":"Dashboard","edit-account":"Bewerken","experiences":"Ervaringen","guidelines":"Richtlijnen CSS","home":"Hoofdpagina","orders":"Bestellingen","page-not-found":"Pagina niet gevonden","referrals":"Aanraden","register":"Registreren","reset":"Wachtwoord vergeten","reset/token":"Wachtwoord opnieuw instellen","saltblocks":"Zoutblokken","sign-in":"Inloggen","styleguide":"Huisstijl","support":"Hulp","welcome":"Welkmon bij Minimax"},"support":{"wizard":{"button_continue":"Volgende stap","detail":{"header_custom":"Anders, namelijk...","header_hardness_too_high":"Waterhardheid te hoog","header_hardness_too_low":"Waterhardheid te laag","header_malfunction_broken":"Kapotte component(en)","header_malfunction_leak":"Lekkage","header_salt_block_doesnt_fit":"Zoutblokken passen niet","header_salt_too_high":"Zout in het water","header_salt_too_low":"Geen zoutverbruik","label_hardness_too_high":"De hardheid van het water is hoger dan het systeem hoort te produceren","label_hardness_too_low":"De hardheid van het water is lager dan het systeem hoort te produceren","label_header_custom":"Beschrijf het probleem","label_malfunction_broken":"Eén of meerdere componenten van de installatie zijn kapot","label_malfunction_leak":"U merkt een lek op","label_salt_block_doesnt_fit":"Als de zoutblokken niet in de minimax opstelling passen, kies deze optie","label_salt_too_high":"Als het water zout smaakt, kies deze optie","label_salt_too_low":"Als de zoutblok niet meer zakt, kies deze optie"},"label_appointment_stage":"Op welke datums zou het Minimax team langs kunnen komen?","label_detail_stage":"Wat is uw probleem?","label_posted_stage":"Uw support verzoek is ontvangen en wordt binnenkort beantwoord","label_title_stage":"Kies de categorie waar uw probleem onder valt","notify_failure":"Verzoek indienen mislukt","notify_success":"Verzoek succesvol ingediend","please_type_issue":"Beschrijf kort het probleem","state_send_request":"Verstuur verzoek","state_send_request_sub":"Kies een datum voor de interventie","state_what":"Details","state_what_sub":"Wat werkt er niet?","state_where":"Waar zit het probleem?","state_where_sub":"Welk onderdeel van de Minimax werkt niet?","title":{"header_custom":"Anders","header_hardness":"Waterhardheid","header_malfunction":"Storing","header_salt_blocks":"Zoutblokken","label_custom":"Beschrijf het probleem in de volgende stap","label_hardness":"Er is een probleem met de hardheid van het water nadat Minimax het gefilterd heeft","label_malfunction":"Het systeem functioneert niet","label_salt_blocks":"Er is een probleem met de zoutblokken"}}}}

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export nl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return numberFormats; });
var nl = {
    money: {
        style: 'currency',
        currency: 'EUR'
    },
    whole: {
        style: 'number',
        maximumFractionDigits: 0
    },
    percentage: {
        style: 'percent',
        maximumFractionDigits: 0
    }
};

var numberFormats = {
    nl: nl
};

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:{'is-active': _vm.active},on:{"click":function($event){$event.stopPropagation();_vm.click($event)}}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"separator"}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-6 col-lg-12"},[_c('h2',[_vm._v(_vm._s(_vm.$t('footer.contact')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-6 col-md-3"},[_c('div',{staticClass:"footer__block"},[_vm._m(0,false,false),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('footer.address')))])]),_vm._v(" "),_c('p',[_vm._v("12, Rue Préixhe")]),_vm._v(" "),_c('p',[_vm._v("B-4681 Oupeye")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 col-md-3"},[_c('div',{staticClass:"footer__block"},[_vm._m(1,false,false),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('footer.call_us')))])]),_vm._v(" "),_vm._m(2,false,false),_vm._v(" "),_vm._m(3,false,false)])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 col-md-3"},[_c('div',{staticClass:"footer__block"},[_vm._m(4,false,false),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('footer.mail_us')))])]),_vm._v(" "),_vm._m(5,false,false)])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 col-md-3"},[_c('div',{staticClass:"footer__block"},[_vm._m(6,false,false),_vm._v(" "),_c('p',[_c('strong',[_c('a',{attrs:{"target":"_blank","href":_vm.contactPageUrl}},[_vm._v(_vm._s(_vm.$t('footer.more_contact_info')))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"footer__text"},[_vm._m(7,false,false),_vm._v(" "),_c('div',{staticClass:"footer__text-right"},[_vm._v("\n                © "+_vm._s(new Date().getFullYear())+" "+_vm._s(_vm.$t('footer.copyrights'))+"\n            ")])]),_vm._v(" "),(!_vm.localeHidden)?_c('div',{staticClass:"locale_block hidden-xs hidden-sm hidden-md"},[_c('locale-button',{staticClass:"locale_block__button--first",attrs:{"language":"nl"}}),_vm._v(" "),_c('locale-button',{staticClass:"locale_block__button",attrs:{"language":"fr"}}),_vm._v(" "),(_vm.authenticated)?_c('button',{staticClass:"locale_block__logout",on:{"click":_vm.signOut}},[_vm._v("\n            "+_vm._s(_vm.$t('menu.signout'))+"\n        ")]):_vm._e()],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrapper"},[_c('i',{staticClass:"mdi mdi-map-marker-outline"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrapper"},[_c('i',{staticClass:"mdi mdi-phone"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('a',{attrs:{"href":"tel:080024550"}},[_vm._v("+32 (0)800 / 24 550")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('a',{attrs:{"href":"tel:+3243805510"}},[_vm._v("+32 4 380 55 10")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrapper"},[_c('i',{staticClass:"mdi mdi-email-outline"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('a',{attrs:{"href":"mailto:info@minimax.be","target":"_top"}},[_vm._v("info@minimax.be")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrapper"},[_c('a',{attrs:{"href":"https://www.facebook.com/MinimaxBelgium/","target":"_blank"}},[_c('span',{staticClass:"footer__icon"},[_c('i',{staticClass:"mdi mdi-facebook"})])]),_vm._v(" "),_c('a',{attrs:{"href":"https://be.linkedin.com/company/halutec","target":"_blank"}},[_c('span',{staticClass:"footer__icon"},[_c('i',{staticClass:"mdi mdi-linkedin"})])]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.youtube.com/user/HaLuTec","target":"_blank"}},[_c('span',{staticClass:"footer__icon"},[_c('i',{staticClass:"mdi mdi-youtube"})])]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.instagram.com/minimax_be/","target":"_blank"}},[_c('span',{staticClass:"footer__icon"},[_c('i',{staticClass:"mdi mdi-instagram"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer__text-left"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/logo_minimax.png","alt":"Minimax Client Dashboard","title":"Minimax Client Dashboard","height":"32px"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheHeader_vue__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4175f55b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheHeader_vue__ = __webpack_require__(347);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4175f55b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TheHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_modules_auth__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LocaleButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SetupSteps__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_modules_account_details__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_modules_proposal_progress__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants_breakpoints__ = __webpack_require__(77);







var _dec, _dec2, _dec3, _class, _desc, _value, _class2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}










var TheHeader = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])({
    components: { LocaleButton: __WEBPACK_IMPORTED_MODULE_9__LocaleButton__["a" /* default */], SetupSteps: __WEBPACK_IMPORTED_MODULE_10__SetupSteps__["a" /* default */] }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Watch"])('showMobileMenu'), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Watch"])('$mq.resize'), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TheHeader, _Vue);

    function TheHeader() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TheHeader);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = TheHeader.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(TheHeader)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'the-header', _this.showMobileMenu = false, _this.scrollPosition = 0, _this.scrollThreshold = 64, _this.scrollPositionBeforeMenu = 0, _this.samePage = false, _this.headerButtonVisible = false, _this.thresholdVisibileHeaderButton = 620, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TheHeader, [{
        key: 'hideElementsBehindMenu',
        value: function hideElementsBehindMenu() {
            if (this.showMobileMenu) {
                window.scrollTo(0, this.scrollPositionBeforeMenu);
                document.body.classList.add('disable-scrolling');

                this.headerButtonVisible = true;
            } else {
                document.body.classList.remove('disable-scrolling');
                this.$el.querySelector('nav').scrollTop = 0;
                if (this.samePage) {
                    window.scrollTo(0, this.scrollPositionBeforeMenu);
                } else {
                    window.scrollTo(0, 0);

                    if (window.innerHeight < this.thresholdVisibileHeaderButton) {
                        this.headerButtonVisible = false;
                    }
                }
            }
        }
    }, {
        key: 'mounted',
        value: function mounted() {
            window.addEventListener('scroll', this.onScroll);
            if (this.$refs.top.clientHeight != 0) {
                this.scrollThreshold = this.$refs.top.clientHeight;
            }
        }
    }, {
        key: 'beforeDestroy',
        value: function beforeDestroy() {
            window.removeEventListener('scroll', this.onScroll);
        }
    }, {
        key: 'created',
        value: function created() {
            this.currentPage = this.$route.name;

            if (window.innerHeight > this.thresholdVisibileHeaderButton) {
                this.headerButtonVisible = true;
            }
        }
    }, {
        key: 'toggleMobileMenu',
        value: function toggleMobileMenu(page) {
            this.samePage = !page;
            this.scrollPositionBeforeMenu = window.scrollY;

            if (page == 'referrals') {
                this.headerButtonVisible = false;
                this.showMobileMenu = false;
            } else if (this.$mq.below(__WEBPACK_IMPORTED_MODULE_13__constants_breakpoints__["a" /* SCREEN_MD */])) {
                this.showMobileMenu = !this.showMobileMenu;
            } else {
                this.showMobileMenu = false;
            }
        }
    }, {
        key: 'hideMobileMenu',
        value: function hideMobileMenu() {
            if (this.$mq.above(__WEBPACK_IMPORTED_MODULE_13__constants_breakpoints__["a" /* SCREEN_MD */])) {
                this.showMobileMenu = false;
            }
        }
    }, {
        key: 'signOut',
        value: function signOut() {
            var _this2 = this;

            this.hideMobileMenu();
            document.body.classList.remove('disable-scrolling');
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_8__store_modules_auth__["f" /* LOGOUT */]).then(function () {
                _this2.$router.replace({
                    name: 'sign-in'
                });
            });
        }
    }, {
        key: 'onScroll',
        value: function onScroll() {
            this.scrollPosition = window.scrollY;

            if (this.scrollPosition >= this.scrollThreshold && !this.$route.path.startsWith('/referrals')) {
                this.headerButtonVisible = true;
            }
        }
    }, {
        key: 'disabled',
        get: function get() {
            return !this.$store.getters[__WEBPACK_IMPORTED_MODULE_12__store_modules_proposal_progress__["c" /* GET_INSTALLATION_PLACED */]];
        }
    }, {
        key: 'showNavigation',
        get: function get() {
            return !this.$route.path.startsWith('/auth');
        }
    }, {
        key: 'authenticated',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_8__store_modules_auth__["d" /* IS_AUTHENTICATED */]];
        }
    }, {
        key: 'username',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_11__store_modules_account_details__["d" /* GET_USERNAME */]];
        }
    }]);

    return TheHeader;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_applyDecoratedDescriptor(_class2.prototype, 'hideElementsBehindMenu', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'hideElementsBehindMenu'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hideMobileMenu', [_dec3], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'hideMobileMenu'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 343 */,
/* 344 */,
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SetupSteps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__languages__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_modules_proposal_progress__ = __webpack_require__(27);






var _class;






var SetupSteps = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SetupSteps, _Vue);

    function SetupSteps() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SetupSteps);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = SetupSteps.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SetupSteps)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'setup-steps', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SetupSteps, [{
        key: 'steps',
        get: function get() {
            return __WEBPACK_IMPORTED_MODULE_7__languages__["b" /* default */].t('menu.steps');
        }
    }, {
        key: 'installationProgress',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_8__store_modules_proposal_progress__["d" /* GET_INSTALLATION_PROGRESS */]];
        }
    }, {
        key: 'currentIndex',
        get: function get() {
            if (this.$store.getters[__WEBPACK_IMPORTED_MODULE_8__store_modules_proposal_progress__["c" /* GET_INSTALLATION_PLACED */]]) return 3;

            if (this.installationProgress.requested.completed) return 1;
            if (this.installationProgress.signed.completed) return 0;
        }
    }]);

    return SetupSteps;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;



/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"setup__steps"},_vm._l((_vm.steps),function(s,i){return _c('div',{staticClass:"setup__step",class:{ done: i < _vm.currentIndex, locked: i > _vm.currentIndex }},[_c('div',{staticClass:"step__progress"},[_c('div',{staticClass:"progress__icon"},[(i < _vm.currentIndex)?_c('img',{attrs:{"src":"static/img/icons/checkmark.svg","alt":"checkmark"}}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(i + 1))])]),_vm._v(" "),_c('div',{staticClass:"progress__stepper"})]),_vm._v(" "),_c('div',{staticClass:"step__info"},[_c('h5',[_vm._v(_vm._s(s.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(s.subtitle))])])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.scrollPosition >= _vm.scrollThreshold)?_c('div',{staticClass:"header__placeholder"}):_vm._e(),_vm._v(" "),_c('header',{staticClass:"header",class:[_vm.disabled ? 'disabled' : '', _vm.scrollPosition >= _vm.scrollThreshold ? 'sticky' : '']},[_c('div',{ref:"top",staticClass:"header__top",class:{'header__top--not_auth' : _vm.authenticated === false}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-7 col-sm-5"},[_c('router-link',{staticClass:"header__logo",attrs:{"to":{ name: 'home' }}},[_c('img',{attrs:{"src":"/static/img/logo_minimax.png","alt":"Minimax Client Dashboard","title":"Minimax Client Dashboard","height":"32px"}})])],1),_vm._v(" "),(_vm.authenticated)?_c('div',{staticClass:"hidden-xs col-sm-5"},[_c('div',{staticClass:"header__intro"},[_c('p',[_vm._v(_vm._s(_vm.$t('menu.welcome_to_account')))]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.username))])])]):_vm._e(),_vm._v(" "),(_vm.authenticated)?_c('div',{staticClass:"hidden-xs col-sm-2"},[_c('button',{staticClass:"header__logout",on:{"click":_vm.signOut}},[_vm._v("\n                            "+_vm._s(_vm.$t('menu.signout'))+"\n                        ")])]):_c('div',{staticClass:"visible-xs visible-sm col-5 col-sm-7"},[_c('div',{staticClass:"locale_block"},[_c('locale-button',{staticClass:"locale_block__button--first",attrs:{"language":"nl"}}),_vm._v(" "),_c('locale-button',{staticClass:"locale_block__button",attrs:{"language":"fr"}})],1)])])])]),_vm._v(" "),(_vm.showNavigation)?_c('div',{staticClass:"header__content"},[[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('a',{staticClass:"nav__toggle_mobile",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleMobileMenu()}}},[_c('span',{staticClass:"nav__toggle_mobile__icon"},[_c('transition',{attrs:{"name":"fade"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showMobileMenu),expression:"!showMobileMenu"}],staticClass:"mdi mdi-menu nav-icon-dark"})]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMobileMenu),expression:"showMobileMenu"}],staticClass:"mdi mdi-close nav-icon-dark"})])],1),_vm._v(" "),_c('span',{staticClass:"nav__toggle_mobile__text"},[_vm._v("\n                                Menu\n                            ")])])]),_vm._v(" "),(!_vm.headerButtonVisible)?_c('div',{staticClass:"col-6"},[_c('router-link',{staticClass:"header__button hidden",attrs:{"to":{ name: 'referrals' }}},[_vm._v("\n                                "+_vm._s(_vm.$t('menu.referrals'))+"\n                                "),_c('span',{staticClass:"header__button__sub_text"},[_vm._v(_vm._s(_vm.$t('menu.referrals_sub')))])])],1):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide-right"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.headerButtonVisible),expression:"headerButtonVisible"}],staticClass:"col-6"},[_c('router-link',{staticClass:"header__button",attrs:{"to":{ name: 'referrals' }},nativeOn:{"click":function($event){_vm.toggleMobileMenu('referrals')}}},[_vm._v("\n                                    "+_vm._s(_vm.$t('menu.referrals'))+"\n                                    "),_c('span',{staticClass:"header__button__sub_text"},[_vm._v(_vm._s(_vm.$t('menu.referrals_sub')))])])],1)])],1)]),_vm._v(" "),_c('nav',{staticClass:"nav",class:{ 'is-active': _vm.showMobileMenu }},[_c('div',{staticClass:"container nav__setup"},[_c('h4',[_vm._v(_vm._s(_vm.$t('menu.start')))]),_vm._v(" "),_c('setup-steps')],1),_vm._v(" "),_c('div',{staticClass:"disabled__message"},[_c('p',[_vm._v(_vm._s(_vm.$t('menu.available_after_installation')))])]),_vm._v(" "),_c('div',{staticClass:"container has-margin-bottom"},[_c('ul',[_c('li',{staticClass:"nav__item",on:{"click":function($event){_vm.toggleMobileMenu('saltblocks')}}},[_c('router-link',{staticClass:"nav__link",attrs:{"to":{ name: 'saltblocks' }}},[_vm._v(_vm._s(_vm.$t('menu.saltblocks'))+"\n                                    "),_c('p',{staticClass:"nav__item__sub"},[_vm._v(_vm._s(_vm.$t('menu.saltblocks_sub')))])])],1),_vm._v(" "),_c('li',{staticClass:"nav__item",on:{"click":function($event){_vm.toggleMobileMenu('orders')}}},[_c('router-link',{staticClass:"nav__link",attrs:{"to":{ name: 'orders' }}},[_vm._v(_vm._s(_vm.$t('menu.orders'))+"\n                                    "),_c('p',{staticClass:"nav__item__sub"},[_vm._v(_vm._s(_vm.$t('menu.orders_sub')))])])],1),_vm._v(" "),_c('li',{staticClass:"nav__item",on:{"click":function($event){_vm.toggleMobileMenu('info')}}},[_c('router-link',{staticClass:"nav__link",attrs:{"to":{ name: 'account' }}},[_vm._v(_vm._s(_vm.$t('menu.info'))+"\n                                    "),_c('p',{staticClass:"nav__item__sub"},[_vm._v(_vm._s(_vm.$t('menu.info_sub')))])])],1),_vm._v(" "),_c('li',{staticClass:"nav__item locale_block"},[_c('locale-button',{staticClass:"locale_block__button--first",attrs:{"language":"nl"}}),_vm._v(" "),_c('locale-button',{staticClass:"locale_block__button",attrs:{"language":"fr"}}),_vm._v(" "),(_vm.authenticated)?_c('button',{staticClass:"locale_block__logout",on:{"click":_vm.signOut}},[_vm._v("\n                                    "+_vm._s(_vm.$t('menu.signout'))+"\n                                ")]):_vm._e()],1)])])])]],2):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheSidebar_vue__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34991e7a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheSidebar_vue__ = __webpack_require__(350);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34991e7a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TheSidebar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_modules_auth__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LocaleButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SetupSteps__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_modules_account_details__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_modules_proposal_progress__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants_breakpoints__ = __webpack_require__(77);







var _dec, _dec2, _class, _desc, _value, _class2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}










var MOBILE_CSS_CLASS = 'nav__mobile_open';
var MOBILE_CSS_TARGET = document.body.classList;

var TheSidebar = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])({
    components: {
        LocaleButton: __WEBPACK_IMPORTED_MODULE_9__LocaleButton__["a" /* default */],
        SetupSteps: __WEBPACK_IMPORTED_MODULE_10__SetupSteps__["a" /* default */]
    },
    watch: {
        '$mq.resize': 'hideMobileMenu'
    }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Watch"])('$mq.resize'), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TheSidebar, _Vue);

    function TheSidebar() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TheSidebar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = TheSidebar.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(TheSidebar)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'the-sidebar', _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TheSidebar, [{
        key: 'created',
        value: function created() {
            this.showMobileMenu = false;
            this.currentPage = this.$route.name;
        }
    }, {
        key: 'toggleMobileMenu',
        value: function toggleMobileMenu() {
            if (this.$mq.below(__WEBPACK_IMPORTED_MODULE_13__constants_breakpoints__["b" /* SCREEN_SM */] + 1)) {
                this.showMobileMenu = !this.showMobileMenu;
            } else {
                this.showMobileMenu = false;
            }
        }
    }, {
        key: 'hideMobileMenu',
        value: function hideMobileMenu() {
            if (this.$mq.above(__WEBPACK_IMPORTED_MODULE_13__constants_breakpoints__["b" /* SCREEN_SM */])) {
                this.showMobileMenu = false;
            }
        }
    }, {
        key: 'signOut',
        value: function signOut() {
            var _this2 = this;

            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_8__store_modules_auth__["f" /* LOGOUT */]).then(function () {
                _this2.$router.replace({
                    name: 'sign-in'
                });
            });
        }
    }, {
        key: 'disabled',
        get: function get() {
            return !this.$store.getters[__WEBPACK_IMPORTED_MODULE_12__store_modules_proposal_progress__["c" /* GET_INSTALLATION_PLACED */]];
        }
    }, {
        key: 'showMobileMenu',
        get: function get() {
            return MOBILE_CSS_TARGET.contains(MOBILE_CSS_CLASS);
        },
        set: function set(value) {
            if (value) {
                MOBILE_CSS_TARGET.add(MOBILE_CSS_CLASS);
            } else {
                MOBILE_CSS_TARGET.remove(MOBILE_CSS_CLASS);
            }
        }
    }, {
        key: 'showNavigation',
        get: function get() {
            return !this.$route.path.startsWith('/auth');
        }
    }, {
        key: 'authenticated',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_8__store_modules_auth__["d" /* IS_AUTHENTICATED */]];
        }
    }, {
        key: 'username',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_11__store_modules_account_details__["d" /* GET_USERNAME */]];
        }
    }]);

    return TheSidebar;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_applyDecoratedDescriptor(_class2.prototype, 'hideMobileMenu', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'hideMobileMenu'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sidebar",class:{ disabled: _vm.disabled }},[_c('router-link',{staticClass:"sidebar__logo",attrs:{"to":{ name: 'home' }}},[_c('img',{attrs:{"src":"/static/img/logo_minimax.png","alt":"Minimax Client Dashboard","title":"Minimax Client Dashboard","height":"32px"}})]),_vm._v(" "),(!_vm.showNavigation)?[_c('div',{staticClass:"sidebar__intro"},[_vm._v("\n                "+_vm._s(_vm.$t('menu.log_in_to_view_your_account_details'))+"\n            ")])]:_vm._e(),_vm._v(" "),(_vm.showNavigation)?[_c('a',{staticClass:"nav__toggle_mobile",attrs:{"href":"#"},on:{"click":_vm.toggleMobileMenu}},[_c('span',{staticClass:"nav__toggle_mobile__icon"},[_c('transition',{attrs:{"name":"fade"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showMobileMenu),expression:"!showMobileMenu"}],staticClass:"mdi mdi-menu"})]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMobileMenu),expression:"showMobileMenu"}],staticClass:"mdi mdi-close"})])],1),_vm._v("\n                Menu\n            ")]),_vm._v(" "),(_vm.authenticated)?_c('div',{staticClass:"sidebar__intro"},[_c('p',[_vm._v(_vm._s(_vm.$t('menu.welcome_to_account')))]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.username))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"nav__setup"},[_c('h4',[_vm._v(_vm._s(_vm.$t('menu.start')))]),_vm._v(" "),_c('setup-steps')],1),_vm._v(" "),_c('div',{staticClass:"disabled__message"},[_c('p',[_vm._v(_vm._s(_vm.$t('menu.available_after_installation')))])]),_vm._v(" "),_c('nav',{staticClass:"nav",class:{ 'is-active': _vm.showMobileMenu },attrs:{"id":"nav"}},[_c('ul',[_c('li',{staticClass:"nav__item"},[_c('router-link',{staticClass:"nav__link",attrs:{"to":{ name: 'saltblocks' }},on:{"click":_vm.toggleMobileMenu}},[_vm._v(_vm._s(_vm.$t('menu.saltblocks'))+"\n                            "),_c('p',{staticClass:"nav__item__sub"},[_vm._v(_vm._s(_vm.$t('menu.saltblocks_sub')))])])],1),_vm._v(" "),_c('li',{staticClass:"nav__item"},[_c('router-link',{staticClass:"nav__link",attrs:{"to":{ name: 'orders' }},on:{"click":_vm.toggleMobileMenu}},[_vm._v(_vm._s(_vm.$t('menu.orders'))+"\n                            "),_c('p',{staticClass:"nav__item__sub"},[_vm._v(_vm._s(_vm.$t('menu.orders_sub')))])])],1),_vm._v(" "),_c('li',{staticClass:"nav__item"},[_c('router-link',{staticClass:"nav__link",attrs:{"to":{ name: 'account' }},on:{"click":_vm.toggleMobileMenu}},[_vm._v(_vm._s(_vm.$t('menu.info'))+"\n                            "),_c('p',{staticClass:"nav__item__sub"},[_vm._v(_vm._s(_vm.$t('menu.info_sub')))])])],1)])])]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CookieNotification_vue__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ae6b6b4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CookieNotification_vue__ = __webpack_require__(361);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CookieNotification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ae6b6b4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CookieNotification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CookieNotification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CookieModal_vue__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CookieBanner_vue__ = __webpack_require__(358);






var _dec, _class;






var CookieNotification = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])({
    components: {
        CookieModal: __WEBPACK_IMPORTED_MODULE_7__CookieModal_vue__["a" /* default */],
        CookieBanner: __WEBPACK_IMPORTED_MODULE_8__CookieBanner_vue__["a" /* default */]
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CookieNotification, _Vue);

    function CookieNotification() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CookieNotification);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = CookieNotification.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CookieNotification)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'cookie-notification', _this.show = false, _this.type = 'banner', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CookieNotification, [{
        key: 'created',
        value: function created() {
            var local = this.getLocalStorage();
            if (this.$config.cookies.enabled && !local) {
                this.show = true;
                this.type = this.$config.cookies.type;
            }
        }
    }, {
        key: 'getLocalStorage',
        value: function getLocalStorage() {
            var item = localStorage.getItem('cookies');
            if (!item) {
                return false;
            } else {
                return JSON.parse(item);
            }
        }
    }, {
        key: 'mounted',
        value: function mounted() {
            if (this.type === 'modal') {
                this.$modal.show('cookie-modal');
            }
        }
    }, {
        key: 'confirm',
        value: function confirm() {
            localStorage.setItem('cookies', true);
            this.show = false;
        }
    }]);

    return CookieNotification;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CookieModal_vue__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ec238c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CookieModal_vue__ = __webpack_require__(357);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CookieModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ec238c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CookieModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CookieModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_ModalWrapper__ = __webpack_require__(78);






var _dec, _class;





var CookieModal = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])({
    components: {
        ModalWrapper: __WEBPACK_IMPORTED_MODULE_7__components_general_ModalWrapper__["a" /* default */]
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CookieModal, _Vue);

    function CookieModal() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CookieModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = CookieModal.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CookieModal)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'cookie-modal', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CookieModal, [{
        key: 'confirm',
        value: function confirm() {
            this.$emit('confirm');
            this.$modal.hide(this.name);
        }
    }]);

    return CookieModal;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_js_modal__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_js_modal__);






var _dec, _class;





__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_js_modal___default.a);

var ModalWrapper = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])({
    props: {
        modalName: String,
        modalClass: String
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalWrapper, _Vue);

    function ModalWrapper() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ModalWrapper);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ModalWrapper.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ModalWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'modal-wrapper', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ModalWrapper, [{
        key: 'beforeOpen',
        value: function beforeOpen(event) {
            document.getElementsByTagName('body')[0].className += ' modal__open';
            this.$emit('before-open', event);
        }
    }, {
        key: 'opened',
        value: function opened(event) {
            this.modalOpen = true;
            this.$emit('modalIsOpen', this.modalOpen);
        }
    }, {
        key: 'closed',
        value: function closed(event) {
            document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className.replace('modal__open', '');
            this.modalOpen = false;
            this.$emit('modalWasClosed', this.modalOpen);
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.$modal.hide(this.modalName);
        }
    }]);

    return ModalWrapper;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{class:_vm.modalClass,attrs:{"name":_vm.modalName},on:{"before-open":_vm.beforeOpen,"opened":_vm.opened,"closed":_vm.closed}},[_c('a',{staticClass:"modal__close",attrs:{"type":"button"},on:{"click":_vm.closeModal}},[_c('i',{staticClass:"mdi mdi-close"})]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-wrapper',{attrs:{"modalClass":"modal--small","modalName":_vm.name}},[_c('div',{staticClass:"modal__header"},[_c('h3',[_vm._v(_vm._s(_vm.$t('cookies.cookies')))])]),_vm._v(" "),_c('div',{staticClass:"modal__content"},[_vm._v("\n        "+_vm._s(_vm.$t('cookies.description'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"modal__footer"},[_c('button',{staticClass:"button--cta",attrs:{"type":"submit"},on:{"click":_vm.confirm}},[_vm._v(_vm._s(_vm.$t('cookies.confirm')))]),_vm._v(" "),_c('button',{staticClass:"button--link"},[_vm._v(_vm._s(_vm.$t('cookies.more_information')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CookieBanner_vue__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f537214_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CookieBanner_vue__ = __webpack_require__(360);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CookieBanner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f537214_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CookieBanner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CookieBanner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);






var _class;




var CookieBanner = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CookieBanner, _Vue);

    function CookieBanner() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CookieBanner);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = CookieBanner.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CookieBanner)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'cookie-banner', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CookieBanner, [{
        key: 'confirm',
        value: function confirm() {
            this.$emit('confirm');
        }
    }]);

    return CookieBanner;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;



/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"cookie_bar__text"},[_vm._v(_vm._s(_vm.$t('cookies.description')))]),_vm._v(" "),_c('button',{staticClass:"button--cta has-margin-bottom",on:{"click":_vm.confirm}},[_vm._v(_vm._s(_vm.$t('cookies.confirm')))]),_vm._v(" "),_c('button',{staticClass:"button has-smaller-horizontal-padding"},[_vm._v(_vm._s(_vm.$t('cookies.more_information')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"cookie_bar"},[(_vm.type === 'modal')?_c('cookie-modal',{on:{"confirm":_vm.confirm}}):_c('cookie-banner',{on:{"confirm":_vm.confirm}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RouterBreadcrumb_vue__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fb5b4a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RouterBreadcrumb_vue__ = __webpack_require__(368);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RouterBreadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fb5b4a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RouterBreadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RouterBreadcrumb; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__);








var _class;




var RouterBreadcrumb = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Component"])(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(RouterBreadcrumb, _Vue);

    function RouterBreadcrumb() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, RouterBreadcrumb);

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RouterBreadcrumb.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(RouterBreadcrumb)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(RouterBreadcrumb, [{
        key: 'buildLink',
        value: function buildLink(crumb) {
            if ((typeof crumb === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(crumb)) === 'object') {
                return crumb;
            } else {
                return {
                    name: crumb
                };
            }
        }
    }, {
        key: 'localize',
        value: function localize(crumb) {
            var name = (typeof crumb === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(crumb)) === 'object' ? crumb.name : crumb;
            return this.$t('route.' + name);
        }
    }, {
        key: 'crumbs',
        get: function get() {
            var topCrumb = this.$route.name;
            var meta = this.$route.meta;
            if (meta && meta.crumbs) {
                return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(meta.crumbs), [topCrumb]);
            } else {
                return [topCrumb];
            }
        }
    }]);

    return RouterBreadcrumb;
}(__WEBPACK_IMPORTED_MODULE_7_vue__["default"])) || _class;



/***/ }),
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"breadcrumb"},_vm._l((_vm.crumbs),function(crumb){return _c('li',[_c('router-link',{attrs:{"to":_vm.buildLink(crumb)}},[_vm._v(_vm._s(_vm.localize(crumb)))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[(!_vm.componentHiddenOnRoute)?_c('the-header',{staticClass:"hidden-lg"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wrapper__content"},[(!_vm.componentHiddenOnRoute)?_c('div',{staticClass:"sidebar__background"}):_vm._e(),_vm._v(" "),(!_vm.componentHiddenOnRoute)?_c('the-sidebar',{staticClass:"visible-lg"}):_vm._e(),_vm._v(" "),_c('main',{class:{no_padding : !_vm.showNavigation, main :!_vm.componentHiddenOnRoute }},[_c('div',{staticClass:"main__inner"},[_c('div',{staticClass:"container"},[(_vm.showNavigation)?_c('router-breadcrumb'):_vm._e(),_vm._v(" "),_c('router-view')],1)])])],1),_vm._v(" "),_c('the-footer',{attrs:{"localeHidden":_vm.componentHiddenOnRoute}}),_vm._v(" "),_c('cookie-notification')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orders_vue__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c01617a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orders_vue__ = __webpack_require__(383);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c01617a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Orders; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_modules_orders__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_general_Loader__ = __webpack_require__(31);








var _dec, _class;







var Orders = (_dec = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Component"])({
    components: { Loader: __WEBPACK_IMPORTED_MODULE_11__components_general_Loader__["a" /* default */] }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Orders, _Vue);

    function Orders() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Orders);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Orders.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Orders)).call.apply(_ref, [this].concat(args))), _this), _this.loading = false, _this.error = false, _this.loadingLastOrder = false, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Orders, [{
        key: 'openUrl',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(url) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__store_modules_orders__["c" /* FETCH_PDF */], url);

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function openUrl(_x) {
                return _ref2.apply(this, arguments);
            }

            return openUrl;
        }()
    }, {
        key: 'created',
        value: function created() {
            this.loadingLastOrder = true;
            this.loading = true;
            this.error = false;
            this.fetchLastOrder();
            this.fetchOrders();
        }
    }, {
        key: 'formatDate',
        value: function formatDate(date) {
            return __WEBPACK_IMPORTED_MODULE_10_moment___default()(date).calendar();
        }
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__store_modules_orders__["b" /* FETCH_ORDERS */]);

                            case 3:
                                _context2.next = 9;
                                break;

                            case 5:
                                _context2.prev = 5;
                                _context2.t0 = _context2['catch'](0);

                                this.error = this.$t('common.notify_fetch_failure');
                                this.$notify.error(this.error);

                            case 9:
                                _context2.prev = 9;

                                this.loading = false;
                                return _context2.finish(9);

                            case 12:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[0, 5, 9, 12]]);
            }));

            function fetchOrders() {
                return _ref3.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchLastOrder',
        value: function () {
            var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;
                                _context3.next = 3;
                                return this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__store_modules_orders__["a" /* FETCH_LAST_ORDER */]);

                            case 3:
                                _context3.next = 7;
                                break;

                            case 5:
                                _context3.prev = 5;
                                _context3.t0 = _context3['catch'](0);

                            case 7:
                                _context3.prev = 7;

                                this.loadingLastOrder = false;
                                return _context3.finish(7);

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[0, 5, 7, 10]]);
            }));

            function fetchLastOrder() {
                return _ref4.apply(this, arguments);
            }

            return fetchLastOrder;
        }()
    }, {
        key: 'orders',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_9__store_modules_orders__["f" /* GET_ORDERS */]];
        }
    }, {
        key: 'lastOrder',
        get: function get() {
            if (this.$store.getters[__WEBPACK_IMPORTED_MODULE_9__store_modules_orders__["e" /* GET_LAST_ORDER */]].hasOwnProperty('completed') && this.$store.getters[__WEBPACK_IMPORTED_MODULE_9__store_modules_orders__["e" /* GET_LAST_ORDER */]].hasOwnProperty('created')) {
                if (this.$store.getters[__WEBPACK_IMPORTED_MODULE_9__store_modules_orders__["e" /* GET_LAST_ORDER */]].completed === false) {
                    return this.$store.getters[__WEBPACK_IMPORTED_MODULE_9__store_modules_orders__["e" /* GET_LAST_ORDER */]];
                } else return false;
            } else {
                return false;
            }
        }
    }]);

    return Orders;
}(__WEBPACK_IMPORTED_MODULE_7_vue__["default"])) || _class);


/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Loader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);







var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




var Loader = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: Boolean, default: false }), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: Boolean, default: false }), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: [Boolean, String], default: null }), Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Loader, _Vue);

    function Loader() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Loader);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Loader.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Loader)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'loading', _descriptor, _this), _initDefineProp(_this, 'small', _descriptor2, _this), _initDefineProp(_this, 'error', _descriptor3, _this), _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Loader, [{
        key: 'css',
        get: function get() {
            return this.small ? 'spinner--small' : 'spinner';
        }
    }]);

    return Loader;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'loading', [_dec], {
    enumerable: true,
    initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'small', [_dec2], {
    enumerable: true,
    initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'error', [_dec3], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{class:_vm.css}):(_vm.error)?_vm._t("error",[_c('div',{staticClass:"alert--error"},[_vm._v(_vm._s(_vm.error))])]):_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h1',[_vm._v(_vm._s(_vm.$t('orders.header_main')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('orders.label_info'))+".")]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[(!_vm.loadingLastOrder)?_c('div',[(_vm.lastOrder)?_c('div',{staticClass:"alert--info"},[_vm._v("\n                    "+_vm._s(_vm.$t('form.order_salt.order_under_review_1'))+"\n                    "+_vm._s(_vm.lastOrder.created)+"\n                    "+_vm._s(_vm.$t('form.order_salt.order_under_review_2'))+"\n                    "+_vm._s(_vm.$t('form.order_salt.order_under_review_3'))+"\n                ")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('loader',{staticClass:"table__responsive",attrs:{"loading":_vm.loading,"error":_vm.error}},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_c('strong',[_vm._v(_vm._s(_vm.$t('orders.header_id')))])]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('orders.header_date')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('orders.header_price')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('orders.header_type')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('orders.header_download')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.orders),function(order){return _c('tr',[_c('td',[_c('strong',[_vm._v(_vm._s(order.id))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatDate(order.date)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$n(order.price, 'money')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('common.order_type.' + order.type)))]),_vm._v(" "),_c('td',[(order.download_url)?_c('a',{attrs:{"target":"_blank"},on:{"click":function($event){_vm.openUrl(order.download_url)}}},[_c('i',{staticClass:"mdi mdi-download"}),_vm._v("\n                            "+_vm._s(_vm.$t('orders.label_download'))+"\n                        ")]):_vm._e()])])}))])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Support_vue__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2048c04e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Support_vue__ = __webpack_require__(412);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Support_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2048c04e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Support_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Support; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_support_WizardTitleSelect__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_support_WizardDetailSelect__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_forms_AppointmentForm__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_modules_support_wizard__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_modules_account_details__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_support_WizardStateTracker__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_support_stages__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_forms_MomentsForm__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_modules_moments__ = __webpack_require__(80);








var _dec, _class;













var Support = (_dec = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Component"])({
    components: { MomentsForm: __WEBPACK_IMPORTED_MODULE_16__components_forms_MomentsForm__["a" /* default */], WizardStateTracker: __WEBPACK_IMPORTED_MODULE_14__components_support_WizardStateTracker__["a" /* default */], AppointmentForm: __WEBPACK_IMPORTED_MODULE_11__components_forms_AppointmentForm__["a" /* default */], WizardDetailSelect: __WEBPACK_IMPORTED_MODULE_10__components_support_WizardDetailSelect__["a" /* default */], WizardTitleSelect: __WEBPACK_IMPORTED_MODULE_9__components_support_WizardTitleSelect__["a" /* default */] }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Support, _Vue);

    function Support() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Support);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Support.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Support)).call.apply(_ref, [this].concat(args))), _this), _this.stage = __WEBPACK_IMPORTED_MODULE_15__components_support_stages__["d" /* STAGE_TITLE */], _this.appointment = null, _this.posting = false, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Support, [{
        key: 'created',
        value: function created() {
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_12__store_modules_support_wizard__["g" /* RESET_WIZARD */]);
            this.appointment = this.$store.getters[__WEBPACK_IMPORTED_MODULE_12__store_modules_support_wizard__["b" /* GET_APPOINTMENT */]];
            this.setAddress();
        }
    }, {
        key: 'setAddress',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(this.getFieldValue('address') === 'address')) {
                                    _context.next = 3;
                                    break;
                                }

                                _context.next = 3;
                                return this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__store_modules_account_details__["a" /* FETCH_ACCOUNT_DETAILS */]);

                            case 3:
                                this.appointment.address.street = this.getFieldValue('address');
                                this.appointment.address.number = this.getFieldValue('address_number');
                                this.appointment.address.postalCode = this.getFieldValue('postal_code');
                                this.appointment.address.city = this.getFieldValue('city_name');
                                this.appointment.address.country = this.getFieldValue('country_name');

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function setAddress() {
                return _ref2.apply(this, arguments);
            }

            return setAddress;
        }()
    }, {
        key: 'getFieldValue',
        value: function getFieldValue(field) {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_13__store_modules_account_details__["c" /* GET_FIELD */]](field);
        }
    }, {
        key: 'gotoTitleStage',
        value: function gotoTitleStage() {
            this.stage = __WEBPACK_IMPORTED_MODULE_15__components_support_stages__["d" /* STAGE_TITLE */];
        }
    }, {
        key: 'gotoDetailStage',
        value: function gotoDetailStage() {
            this.stage = __WEBPACK_IMPORTED_MODULE_15__components_support_stages__["b" /* STAGE_DETAIL */];
        }
    }, {
        key: 'gotoAppointmentStage',
        value: function gotoAppointmentStage() {
            this.stage = __WEBPACK_IMPORTED_MODULE_15__components_support_stages__["a" /* STAGE_APPOINTMENT */];
        }
    }, {
        key: 'gotoPostedStage',
        value: function gotoPostedStage() {
            this.stage = __WEBPACK_IMPORTED_MODULE_15__components_support_stages__["c" /* STAGE_POSTED */];
        }
    }, {
        key: 'submitTicket',
        value: function submitTicket(comment) {
            var _this2 = this;

            this.posting = true;
            var appointment = {
                moments: this.$store.getters[__WEBPACK_IMPORTED_MODULE_17__store_modules_moments__["c" /* GET_MOMENTS */]],
                comment: comment,
                address: this.appointment.address,
                using_client_dashboard: true
            };
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_12__store_modules_support_wizard__["h" /* SET_APPOINTMENT */], appointment);
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_12__store_modules_support_wizard__["k" /* SUBMIT_SUPPORT_ISSUE */]).then(function () {
                _this2.$notify.success(_this2.$t('support.wizard.notify_success'));
                _this2.gotoPostedStage();
                window.scrollTo(0, 0);
            }, function (error) {
                _this2.$notify.error(_this2.$t('support.wizard.notify_failure'));
            }).finally(function () {
                _this2.posting = false;
            });
        }
    }, {
        key: 'isTitleStage',
        get: function get() {
            return this.stage === __WEBPACK_IMPORTED_MODULE_15__components_support_stages__["d" /* STAGE_TITLE */];
        }
    }, {
        key: 'isDetailStage',
        get: function get() {
            return this.stage === __WEBPACK_IMPORTED_MODULE_15__components_support_stages__["b" /* STAGE_DETAIL */];
        }
    }, {
        key: 'isAppointmentStage',
        get: function get() {
            return this.stage === __WEBPACK_IMPORTED_MODULE_15__components_support_stages__["a" /* STAGE_APPOINTMENT */];
        }
    }, {
        key: 'isPostedStage',
        get: function get() {
            return this.stage === __WEBPACK_IMPORTED_MODULE_15__components_support_stages__["c" /* STAGE_POSTED */];
        }
    }]);

    return Support;
}(__WEBPACK_IMPORTED_MODULE_7_vue__["default"])) || _class);


/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WizardTitleSelect_vue__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8549de92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WizardTitleSelect_vue__ = __webpack_require__(388);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WizardTitleSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8549de92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WizardTitleSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WizardTitleSelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_modules_support_wizard__ = __webpack_require__(53);






var _class;





var WizardTitleSelect = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(WizardTitleSelect, _Vue);

    function WizardTitleSelect() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WizardTitleSelect);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WizardTitleSelect.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(WizardTitleSelect)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(WizardTitleSelect, [{
        key: 'created',
        value: function created() {
            window.scrollTo(0, 0);
        }
    }, {
        key: 'getTitleText',
        value: function getTitleText(code) {
            return this.$t('support.wizard.title.header_' + code);
        }
    }, {
        key: 'options',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_7__store_modules_support_wizard__["f" /* GET_TITLE_OPTIONS */]];
        }
    }, {
        key: 'selectedTitle',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_7__store_modules_support_wizard__["e" /* GET_TITLE */]].code;
        },
        set: function set(code) {
            var text = this.getTitleText(code);
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__store_modules_support_wizard__["j" /* SET_TITLE */], { code: code, text: text });
        }
    }, {
        key: 'canSubmit',
        get: function get() {
            return !!this.selectedTitle;
        }
    }]);

    return WizardTitleSelect;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;



/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"clas":"form"},on:{"submit":function($event){$event.preventDefault();_vm.$emit('submit')}}},[_c('h4',[_vm._v(_vm._s(_vm.$t('support.wizard.label_title_stage')))]),_vm._v(" "),_c('ul',{staticClass:"list--radio"},_vm._l((_vm.options),function(option){return _c('li',{key:option,staticClass:"radio"},[_c('input',{directives:[{name:"gen",rawName:"v-gen.id",value:(option),expression:"option",modifiers:{"id":true}},{name:"gen",rawName:"v-gen.name",value:('title'),expression:"'title'",modifiers:{"name":true}},{name:"model",rawName:"v-model",value:(_vm.selectedTitle),expression:"selectedTitle"}],staticClass:"radio__rb",attrs:{"type":"radio","required":""},domProps:{"value":option,"checked":_vm._q(_vm.selectedTitle,option)},on:{"change":function($event){_vm.selectedTitle=option}}}),_vm._v(" "),_c('label',{directives:[{name:"gen",rawName:"v-gen.for",value:(option),expression:"option",modifiers:{"for":true}}],staticClass:"radio__label"},[_c('p',{staticClass:"radio__text"},[_vm._v("\n                    "+_vm._s(_vm.$t('support.wizard.title.header_' + option))+"\n                    "),_c('span',[_vm._v("\n                        "+_vm._s(_vm.$t('support.wizard.title.label_' + option))+"\n                    ")])])])])})),_vm._v(" "),_c('button',{staticClass:"button--cta",attrs:{"type":"submit","disabled":!_vm.canSubmit}},[_vm._v("\n        "+_vm._s(_vm.$t('support.wizard.button_continue'))+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WizardDetailSelect_vue__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fa3449d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WizardDetailSelect_vue__ = __webpack_require__(391);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WizardDetailSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fa3449d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WizardDetailSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WizardDetailSelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_modules_support_wizard__ = __webpack_require__(53);






var _class;





var WizardDetailSelect = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(WizardDetailSelect, _Vue);

    function WizardDetailSelect() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WizardDetailSelect);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = WizardDetailSelect.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(WizardDetailSelect)).call.apply(_ref, [this].concat(args))), _this), _this.customTextValue = _this.selectedDetail === __WEBPACK_IMPORTED_MODULE_7__store_modules_support_wizard__["a" /* DETAIL_CUSTOM */] ? _this.$store.getters[__WEBPACK_IMPORTED_MODULE_7__store_modules_support_wizard__["c" /* GET_DETAIL */]].text : '', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(WizardDetailSelect, [{
        key: 'created',
        value: function created() {
            window.scrollTo(0, 0);
        }
    }, {
        key: 'getDetailText',
        value: function getDetailText(code) {
            return this.$t('support.wizard.detail.header_' + code);
        }
    }, {
        key: 'options',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_7__store_modules_support_wizard__["d" /* GET_DETAIL_OPTIONS */]];
        }
    }, {
        key: 'isCustomProblem',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_7__store_modules_support_wizard__["e" /* GET_TITLE */]].code === __WEBPACK_IMPORTED_MODULE_7__store_modules_support_wizard__["l" /* TITLE_CUSTOM */];
        }
    }, {
        key: 'selectedDetail',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_7__store_modules_support_wizard__["c" /* GET_DETAIL */]].code;
        },
        set: function set(code) {
            var text = code === __WEBPACK_IMPORTED_MODULE_7__store_modules_support_wizard__["a" /* DETAIL_CUSTOM */] ? this.customTextValue : this.getDetailText(code);

            if (code != __WEBPACK_IMPORTED_MODULE_7__store_modules_support_wizard__["a" /* DETAIL_CUSTOM */]) {
                this.customTextValue = '';
            }
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__store_modules_support_wizard__["i" /* SET_DETAIL */], { code: code, text: text });
        }
    }, {
        key: 'customText',
        get: function get() {
            return this.customTextValue;
        },
        set: function set(value) {
            this.customTextValue = value;
            this.selectedDetail = __WEBPACK_IMPORTED_MODULE_7__store_modules_support_wizard__["a" /* DETAIL_CUSTOM */];
        }
    }, {
        key: 'canSubmit',
        get: function get() {
            return !!this.selectedDetail;
        }
    }]);

    return WizardDetailSelect;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;



/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();_vm.$emit('submit')},"reset":function($event){_vm.$emit('reset')}}},[_c('h4',[_vm._v(_vm._s(_vm.$t('support.wizard.label_detail_stage')))]),_vm._v(" "),(!_vm.isCustomProblem)?_c('ul',{staticClass:"list--radio"},[_vm._l((_vm.options),function(option){return _c('li',{key:option,staticClass:"radio"},[_c('input',{directives:[{name:"gen",rawName:"v-gen.id",value:(option),expression:"option",modifiers:{"id":true}},{name:"gen",rawName:"v-gen.name",value:('title'),expression:"'title'",modifiers:{"name":true}},{name:"model",rawName:"v-model",value:(_vm.selectedDetail),expression:"selectedDetail"}],staticClass:"radio__rb",attrs:{"type":"radio","required":""},domProps:{"value":option,"checked":_vm._q(_vm.selectedDetail,option)},on:{"change":function($event){_vm.selectedDetail=option}}}),_vm._v(" "),_c('label',{directives:[{name:"gen",rawName:"v-gen.for",value:(option),expression:"option",modifiers:{"for":true}}],staticClass:"radio__label"},[_c('p',{staticClass:"radio__text"},[_vm._v("\n                    "+_vm._s(_vm.$t('support.wizard.detail.header_' + option))+"\n                    "),_c('span',[_vm._v("\n                        "+_vm._s(_vm.$t('support.wizard.detail.label_' + option))+"\n                    ")])])])])}),_vm._v(" "),_c('li',{staticClass:"radio"},[_c('input',{directives:[{name:"gen",rawName:"v-gen.id",value:('custom'),expression:"'custom'",modifiers:{"id":true}},{name:"gen",rawName:"v-gen.name",value:('title'),expression:"'title'",modifiers:{"name":true}},{name:"model",rawName:"v-model",value:(_vm.selectedDetail),expression:"selectedDetail"}],staticClass:"radio__rb",attrs:{"type":"radio","value":"custom","required":""},domProps:{"checked":_vm._q(_vm.selectedDetail,"custom")},on:{"change":function($event){_vm.selectedDetail="custom"}}}),_vm._v(" "),_c('label',{directives:[{name:"gen",rawName:"v-gen.for",value:('custom'),expression:"'custom'",modifiers:{"for":true}}],staticClass:"radio__label"},[_c('p',[_vm._v("\n                    "+_vm._s(_vm.$t('support.wizard.detail.header_custom'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customText),expression:"customText"}],staticClass:"form__input--text transparent",attrs:{"type":"text","placeholder":_vm.$t('support.wizard.detail.label_header_custom'),"required":_vm.selectedDetail === 'custom'},domProps:{"value":(_vm.customText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.customText=$event.target.value}}})])])])])],2):_vm._e(),_vm._v(" "),(_vm.isCustomProblem)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-l-12 col-xl-12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.customText),expression:"customText"}],staticClass:"block__textarea form__input--textarea border_dark",attrs:{"placeholder":_vm.$t('support.wizard.detail.label_header_custom'),"required":_vm.selectedDetail === 'custom'},domProps:{"value":(_vm.customText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.customText=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-l-12 col-xl-12"},[_c('div',{staticClass:"form__buttons"},[_c('button',{staticClass:"button--cta",attrs:{"type":"submit","disabled":!_vm.canSubmit}},[_vm._v("\n                    "+_vm._s(_vm.$t('support.wizard.button_continue'))+"\n                ")]),_vm._v(" "),_c('button',{staticClass:"button pull-left has-smaller-horizontal-padding",attrs:{"type":"reset"}},[_vm._v("\n                    "+_vm._s(_vm.$t('common.button.go_back'))+"\n                ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppointmentForm_vue__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21616622_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppointmentForm_vue__ = __webpack_require__(395);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppointmentForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21616622_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppointmentForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SLOT_MORNING */
/* unused harmony export SLOT_AFTERNOON */
/* unused harmony export SLOT_EVENING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppointmentForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__general_Datepicker__ = __webpack_require__(238);








var _dec, _dec2, _dec3, _dec4, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}







var SLOT_MORNING = 'morning';
var SLOT_AFTERNOON = 'afternoon';
var SLOT_EVENING = 'evening';

var AppointmentForm = (_dec = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Component"])({
    components: { Datepicker: __WEBPACK_IMPORTED_MODULE_11__general_Datepicker__["a" /* default */] }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])({ type: String }), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])({ type: Boolean, default: false }), _dec4 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])({ type: Object, default: function _default() {
        return {};
    } }), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(AppointmentForm, _Vue);

    function AppointmentForm() {
        var _ref, _slots;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, AppointmentForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AppointmentForm.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(AppointmentForm)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'title', _descriptor, _this), _initDefineProp(_this, 'busy', _descriptor2, _this), _initDefineProp(_this, 'appointment', _descriptor3, _this), _this.editorMoment = {
            date: __WEBPACK_IMPORTED_MODULE_9_moment___default()().add(1, 'days').toDate(),
            slots: (_slots = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_slots, SLOT_MORNING, true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_slots, SLOT_AFTERNOON, true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_slots, SLOT_EVENING, false), _slots)
        }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(AppointmentForm, [{
        key: 'addMoment',
        value: function addMoment() {
            if (!this.canAdd) return;
            var date = this.editorMoment.date;
            var slots = __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(this.editorMoment.slots, function (value, key) {
                return value ? key : false;
            }).filter(function (item) {
                return item;
            });
            var key = __WEBPACK_IMPORTED_MODULE_9_moment___default()(date).format('YYYY-MM-DD');
            if (this.appointment.moments.hasOwnProperty(key)) {
                this.appointment.moments[key] = slots;
            } else {
                __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(this.appointment.moments, key, slots);
            }
        }
    }, {
        key: 'removeMoment',
        value: function removeMoment(_ref2) {
            var date = _ref2.date;

            var key = __WEBPACK_IMPORTED_MODULE_9_moment___default()(date).format('YYYY-MM-DD');
            __WEBPACK_IMPORTED_MODULE_7_vue__["default"].delete(this.appointment.moments, key);
        }
    }, {
        key: 'formatDate',
        value: function formatDate(item) {
            if (!item || !item.date) return undefined;
            return __WEBPACK_IMPORTED_MODULE_9_moment___default()(item.date).format('dddd LL');
        }
    }, {
        key: 'formatSlots',
        value: function formatSlots(item) {
            var _this2 = this;

            if (!item || !item.slots) return undefined;
            return item.slots.map(function (slot) {
                return _this2.$t('form.appointment.label_' + slot);
            }).join(', ');
        }
    }, {
        key: 'moments',
        get: function get() {
            if (!this.appointment) return [];
            if (!this.appointment.moments) {
                this.appointment.moments = {};
            }
            return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(this.appointment.moments, function (value, key) {
                return { date: new Date(key), slots: value };
            });
        }
    }, {
        key: 'address',
        get: function get() {
            if (!this.appointment) return {};
            if (!this.appointment.address) {
                this.appointment.address = {
                    street: '',
                    number: '',
                    postalCode: '',
                    city: '',
                    country: ''
                };
            }
            return this.appointment.address;
        }
    }, {
        key: 'comment',
        get: function get() {
            if (!this.appointment) return '';
            return this.appointment.comment;
        },
        set: function set(value) {
            this.appointment.comment = value;
        }
    }, {
        key: 'slots',
        get: function get() {
            return [SLOT_MORNING, SLOT_AFTERNOON, SLOT_EVENING];
        }
    }, {
        key: 'highlightDates',
        get: function get() {
            return {
                dates: this.moments.map(function (moment) {
                    return moment.date;
                })
            };
        }
    }, {
        key: 'canAdd',
        get: function get() {
            var date = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.editorMoment.date);
            var slots = __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(this.editorMoment.slots, function (value, key) {
                return value ? key : false;
            }).filter(function (item) {
                return item;
            });
            return date.isAfter(__WEBPACK_IMPORTED_MODULE_9_moment___default()()) && slots.length;
        }
    }, {
        key: 'canSubmit',
        get: function get() {
            return !this.busy && this.moments.length;
        }
    }]);

    return AppointmentForm;
}(__WEBPACK_IMPORTED_MODULE_7_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'title', [_dec2], {
    enumerable: true,
    initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'busy', [_dec3], {
    enumerable: true,
    initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'appointment', [_dec4], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),
/* 394 */,
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();_vm.$emit('submit')},"reset":function($event){_vm.$emit('reset')}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-9"},[_c('div',{staticClass:"block has-no-bottom-margin"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"has-no-margin",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('span',{staticClass:"text-italic"},[_vm._v(_vm._s(_vm.$t('form.appointment.header_multiple_allowed')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xxl-7"},[_c('datepicker',{staticClass:"datepicker",attrs:{"inline":true,"highlighted":_vm.highlightDates,"disabled-dates":{to: new Date()}},model:{value:(_vm.editorMoment.date),callback:function ($$v) {_vm.$set(_vm.editorMoment, "date", $$v)},expression:"editorMoment.date"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-xxl-5"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('form.appointment.header_slots')))])]),_vm._v(" "),_vm._l((_vm.slots),function(slot){return _c('div',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editorMoment.slots[slot]),expression:"editorMoment.slots[slot]"}],staticClass:"checkbox__cb",attrs:{"id":slot,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.editorMoment.slots[slot])?_vm._i(_vm.editorMoment.slots[slot],null)>-1:(_vm.editorMoment.slots[slot])},on:{"change":function($event){var $$a=_vm.editorMoment.slots[slot],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.editorMoment.slots[slot]=$$a.concat([$$v]))}else{$$i>-1&&(_vm.editorMoment.slots[slot]=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.editorMoment.slots, slot, $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"checkbox__label--emph",attrs:{"for":slot}},[_vm._v("\n                                    "+_vm._s(_vm.$t('form.appointment.label_' + slot))+"\n                                    "),_c('span',[_vm._v(_vm._s(_vm.$t('form.appointment.label_' + slot + '_time')))])])])})],2)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"button--cta",attrs:{"type":"button","disabled":!_vm.canAdd},on:{"click":_vm.addMoment}},[_vm._v("\n                                "+_vm._s(_vm.$t('form.appointment.add_date'))+"\n                            ")])])])])]),_vm._v(" "),_c('table',{staticClass:"table--list"},[_c('tbody',_vm._l((_vm.moments),function(moment){return _c('tr',[_c('td',{staticClass:"table__cell--date"},[_c('p',[_vm._v(_vm._s(_vm.$t('form.appointment.label_moment_date')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatDate(moment)))]),_vm._v(" "),_c('div',{staticClass:"table__row visible-xs"},[_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('form.appointment.label_moment_slots')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatSlots(moment)))])])]),_vm._v(" "),_c('td',{staticClass:"hidden-xs"},[_c('p',[_vm._v(_vm._s(_vm.$t('form.appointment.label_moment_slots')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatSlots(moment)))])]),_vm._v(" "),_c('td',[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t('common.button.remove')),expression:"$t('common.button.remove')"}],staticClass:"button--icon",on:{"click":function($event){$event.stopPropagation();_vm.removeMoment(moment)}}},[_c('i',{staticClass:"mdi mdi-trash-can"})])])])}))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-9 col-xxl-5 align-items-stretch flex"},[_c('div',{staticClass:"block has-no-top-margin"},[_c('h4',[_vm._v(_vm._s(_vm.$t('form.appointment.address')))]),_vm._v(" "),_vm._l((_vm.address),function(value,field){return _c('div',{staticClass:"form__group"},[_c('i',{staticClass:"form__input__icon mdi mdi-account"}),_vm._v(" "),_c('input',{directives:[{name:"gen",rawName:"v-gen.id",value:(field),expression:"field",modifiers:{"id":true}},{name:"model",rawName:"v-model",value:(_vm.address[field]),expression:"address[field]"}],staticClass:"form__input--text underline has-icon",attrs:{"placeholder":_vm.$t('form.appointment.label_' + field)},domProps:{"value":(_vm.address[field])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, field, $event.target.value)}}})])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-9 col-xxl-4 align-items-stretch flex"},[_c('div',{staticClass:"block has-no-top-margin"},[_c('h4',{directives:[{name:"gen",rawName:"v-gen:comment.for",arg:"comment",modifiers:{"for":true}}]},[_vm._v(_vm._s(_vm.$t('form.appointment.label_comment')))]),_vm._v(" "),_c('textarea',{directives:[{name:"gen",rawName:"v-gen:comment.id",arg:"comment",modifiers:{"id":true}},{name:"model",rawName:"v-model",value:(_vm.comment),expression:"comment"}],staticClass:"block__textarea form__input--textarea",attrs:{"placeholder":_vm.$t('form.appointment.placeholder_comment')},domProps:{"value":(_vm.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comment=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form__buttons"},[_c('button',{staticClass:"button--cta",class:{'is-loading': _vm.busy},attrs:{"type":"submit","disabled":!_vm.canSubmit}},[_vm._v("\n                    "+_vm._s(_vm.$t('form.appointment.button_submit'))+"\n                ")]),_vm._v(" "),_c('button',{staticClass:"button",attrs:{"type":"reset","disabled":_vm.busy}},[_vm._v("\n                    "+_vm._s(_vm.$t('common.button.go_back'))+"\n                ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WizardStateTracker_vue__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46901fde_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WizardStateTracker_vue__ = __webpack_require__(398);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WizardStateTracker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46901fde_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WizardStateTracker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WizardStateTracker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__stages__ = __webpack_require__(239);







var _dec, _class, _desc, _value, _class2, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}





var WizardStateTracker = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: Number, default: __WEBPACK_IMPORTED_MODULE_8__stages__["d" /* STAGE_TITLE */] }), Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(WizardStateTracker, _Vue);

    function WizardStateTracker() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, WizardStateTracker);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = WizardStateTracker.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(WizardStateTracker)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'stage', _descriptor, _this), _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(WizardStateTracker, [{
        key: 'atTitle',
        get: function get() {
            return this.stage === __WEBPACK_IMPORTED_MODULE_8__stages__["d" /* STAGE_TITLE */];
        }
    }, {
        key: 'atDetail',
        get: function get() {
            return this.stage === __WEBPACK_IMPORTED_MODULE_8__stages__["b" /* STAGE_DETAIL */];
        }
    }, {
        key: 'atAppointment',
        get: function get() {
            return this.stage === __WEBPACK_IMPORTED_MODULE_8__stages__["a" /* STAGE_APPOINTMENT */];
        }
    }, {
        key: 'atPosted',
        get: function get() {
            return this.stage === __WEBPACK_IMPORTED_MODULE_8__stages__["c" /* STAGE_POSTED */];
        }
    }]);

    return WizardStateTracker;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'stage', [_dec], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-9"},[_c('div',{staticClass:"state_tracker--simple"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4 col-sm-4 col-md-3"},[_c('div',{staticClass:"state_tracker__item",class:{'active': _vm.atTitle}},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"state_tracker__item__info"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('support.wizard.state_where')))])]),_vm._v(" "),_c('p',{staticClass:"state_tracker__item__info__description"},[_vm._v("\n                                "+_vm._s(_vm.$t('support.wizard.state_where_sub'))+"\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 hidden-xs"}),_vm._v(" "),_c('div',{staticClass:"col-4 col-sm-4 col-md-4"},[_c('div',{staticClass:"state_tracker__item",class:{'active': _vm.atDetail}},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"state_tracker__item__info"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('support.wizard.state_what')))])]),_vm._v(" "),_c('p',{staticClass:"state_tracker__item__info__description"},[_vm._v("\n                                "+_vm._s(_vm.$t('support.wizard.state_what_sub'))+"\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 hidden-xs"}),_vm._v(" "),_c('div',{staticClass:"col-4 col-sm-4 col-md-3"},[_c('div',{staticClass:"state_tracker__item",class:{'active': _vm.atAppointment || _vm.atPosted}},[_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"state_tracker__item__info"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('support.wizard.state_send_request')))])]),_vm._v(" "),_c('p',{staticClass:"state_tracker__item__info__description"},[_vm._v("\n                                "+_vm._s(_vm.$t('support.wizard.state_send_request_sub'))+"\n                            ")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"state_tracker__indicator"},[_c('div',{staticClass:"state_tracker__indicator--number"},[_vm._v("\n                                1\n                            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"state_tracker__indicator"},[_c('div',{staticClass:"state_tracker__indicator--number"},[_vm._v("\n                                2\n                            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"state_tracker__indicator"},[_c('div',{staticClass:"state_tracker__indicator--number"},[_vm._v("\n                                3\n                            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MomentsForm_vue__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d842df1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MomentsForm_vue__ = __webpack_require__(411);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MomentsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d842df1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MomentsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SLOT_MORNING */
/* unused harmony export SLOT_AFTERNOON */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MomentsForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__general_Datepicker__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_modules_moments__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_modules_account_details__ = __webpack_require__(19);














var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _descriptor, _descriptor2;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}








var SLOT_MORNING = 'morning';
var SLOT_AFTERNOON = 'afternoon';

var MomentsForm = (_dec = Object(__WEBPACK_IMPORTED_MODULE_14_vue_property_decorator__["Component"])({
    components: { Datepicker: __WEBPACK_IMPORTED_MODULE_16__general_Datepicker__["a" /* default */] }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_14_vue_property_decorator__["Prop"])({ type: String }), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_14_vue_property_decorator__["Prop"])({ type: Boolean, default: false }), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_inherits___default()(MomentsForm, _Vue);

    function MomentsForm() {
        var _ref, _slots;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_classCallCheck___default()(this, MomentsForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = MomentsForm.__proto__ || __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_prototype_of___default()(MomentsForm)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'title', _descriptor, _this), _initDefineProp(_this, 'busy', _descriptor2, _this), _this.editorMoment = {
            date: __WEBPACK_IMPORTED_MODULE_15_moment___default()().add(1, 'days').toDate(),
            slots: (_slots = {}, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_slots, SLOT_MORNING, true), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_slots, SLOT_AFTERNOON, true), _slots)
        }, _this.comment = '', _this.slots = [SLOT_MORNING, SLOT_AFTERNOON], _this.address = {
            street: '',
            number: '',
            postalCode: '',
            city: '',
            country: ''
        }, _temp), __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_createClass___default()(MomentsForm, [{
        key: 'created',
        value: function created() {
            window.scrollTo(0, 0);
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_17__store_modules_moments__["b" /* CLEAR_MOMENTS */]);
            this.setAddress();
        }
    }, {
        key: 'setAddress',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(this.getFieldValue('address') === 'address')) {
                                    _context.next = 3;
                                    break;
                                }

                                _context.next = 3;
                                return this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_18__store_modules_account_details__["a" /* FETCH_ACCOUNT_DETAILS */]);

                            case 3:
                                this.address.street = this.getFieldValue('address');
                                this.address.number = this.getFieldValue('address_number');
                                this.address.postalCode = this.getFieldValue('postal_code');
                                this.address.city = this.getFieldValue('city_name');
                                this.address.country = this.getFieldValue('country_name');

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function setAddress() {
                return _ref2.apply(this, arguments);
            }

            return setAddress;
        }()
    }, {
        key: 'getFieldValue',
        value: function getFieldValue(field) {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_18__store_modules_account_details__["c" /* GET_FIELD */]](field);
        }
    }, {
        key: 'addMoment',
        value: function addMoment() {
            if (!this.canAdd) return;
            var date = this.editorMoment.date;
            var times = [];

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.editorMoment.slots)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _ref3 = _step.value;

                    var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                    var _key2 = _ref4[0];
                    var value = _ref4[1];

                    if (value === true) {
                        times.push(_key2);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var key = __WEBPACK_IMPORTED_MODULE_15_moment___default()(date).format('YYYY-MM-DD');
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_17__store_modules_moments__["a" /* ADD_MOMENT */], { key: key, times: times });
            this.$forceUpdate();
        }
    }, {
        key: 'removeMoment',
        value: function removeMoment(key) {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_17__store_modules_moments__["d" /* REMOVE_MOMENT */], key);
            this.$forceUpdate();
        }
    }, {
        key: 'formatDate',
        value: function formatDate(key) {
            return __WEBPACK_IMPORTED_MODULE_15_moment___default()(key).format('dddd LL');
        }
    }, {
        key: 'formatSlots',
        value: function formatSlots(items) {
            var translation = '';
            if (!items) return undefined;
            for (var i = 0; i < items.length; i++) {
                translation = translation + this.$t('form.appointment.label_' + items[i]) + ', ';
            }
            translation = translation.substr(0, translation.length - 2);
            return translation;
        }
    }, {
        key: 'moments',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_17__store_modules_moments__["c" /* GET_MOMENTS */]];
        }
    }, {
        key: 'highlightedDates',
        get: function get() {
            var hightlightedDates = {
                dates: []
            };
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.moments).length > 0) {
                var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.moments);
                for (var i = 0; i < keys.length; i++) {
                    hightlightedDates.dates.push(new Date(keys[i]));
                }
            }
            return hightlightedDates;
        }
    }, {
        key: 'canAdd',
        get: function get() {
            if (!this.busy) {
                return this.editorMoment.slots[SLOT_AFTERNOON] === true || this.editorMoment.slots[SLOT_MORNING] === true;
            }return false;
        }
    }, {
        key: 'canSubmit',
        get: function get() {
            if (!this.busy && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.moments).length > 0) {
                return true;
            }
            return false;
        }
    }]);

    return MomentsForm;
}(__WEBPACK_IMPORTED_MODULE_13_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'title', [_dec2], {
    enumerable: true,
    initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'busy', [_dec3], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-l-12 col-xl-10"},[_c('div',{staticClass:"block has-no-bottom-margin"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"has-no-margin",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('span',{staticClass:"text-italic"},[_vm._v(_vm._s(_vm.$t('form.appointment.header_multiple_allowed')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xxl-7",staticStyle:{"text-align":"center"}},[_c('datepicker',{staticClass:"datepicker",attrs:{"inline":true,"highlighted":_vm.highlightedDates,"disabled-dates":{to: new Date()}},model:{value:(_vm.editorMoment.date),callback:function ($$v) {_vm.$set(_vm.editorMoment, "date", $$v)},expression:"editorMoment.date"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-xxl-5"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('form.appointment.header_slots')))])]),_vm._v(" "),_vm._l((_vm.slots),function(slot){return _c('div',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editorMoment.slots[slot]),expression:"editorMoment.slots[slot]"}],staticClass:"checkbox__cb",attrs:{"id":slot,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.editorMoment.slots[slot])?_vm._i(_vm.editorMoment.slots[slot],null)>-1:(_vm.editorMoment.slots[slot])},on:{"change":function($event){var $$a=_vm.editorMoment.slots[slot],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.editorMoment.slots[slot]=$$a.concat([$$v]))}else{$$i>-1&&(_vm.editorMoment.slots[slot]=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.editorMoment.slots, slot, $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"checkbox__label--emph",attrs:{"for":slot}},[_vm._v("\n                                    "+_vm._s(_vm.$t('form.appointment.label_' + slot))+"\n                                    "),_c('span',[_vm._v(_vm._s(_vm.$t('form.appointment.label_' + slot + '_time')))])])])}),_vm._v(" "),_c('button',{staticClass:"button--cta",attrs:{"type":"button","disabled":!_vm.canAdd},on:{"click":_vm.addMoment}},[_vm._v("\n                                "+_vm._s(_vm.$t('form.appointment.add_date'))+"\n                            ")])],2)])])]),_vm._v(" "),_c('table',{staticClass:"table--list"},[_c('tbody',_vm._l((_vm.moments),function(value,key,index){return _c('tr',[_c('td',{staticClass:"table__cell--date"},[_c('p',[_vm._v(_vm._s(_vm.$t('form.appointment.label_moment_date')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatDate(key)))]),_vm._v(" "),_c('div',{staticClass:"table__row visible-xs"},[_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('form.appointment.label_moment_slots')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatSlots(value)))])])]),_vm._v(" "),_c('td',{staticClass:"hidden-xs"},[_c('p',[_vm._v(_vm._s(_vm.$t('form.appointment.label_moment_slots')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatSlots(value)))])]),_vm._v(" "),_c('td',[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t('common.button.remove')),expression:"$t('common.button.remove')"}],staticClass:"button--icon",on:{"click":function($event){$event.stopPropagation();_vm.removeMoment(key)}}},[_c('i',{staticClass:"mdi mdi-trash-can"})])])])}))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-l-12 col-xl-5"},[_c('div',{staticClass:"block has-no-top-margin"},[_c('h4',[_vm._v(_vm._s(_vm.$t('form.appointment.address')))]),_vm._v(" "),_vm._l((_vm.address),function(value,key){return _c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('form.appointment.label_' + key))+" : ")]),_vm._v(" "+_vm._s(value)+"\n                ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-12 col-l-12 col-xl-5"},[_c('div',{staticClass:"block has-no-top-margin"},[_c('h4',[_vm._v(_vm._s(_vm.$t('form.appointment.label_comment')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.comment),expression:"comment"}],staticClass:"block__textarea form__input--textarea border_dark",attrs:{"placeholder":_vm.$t('form.appointment.placeholder_comment')},domProps:{"value":(_vm.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comment=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-l-12 col-xl-10"},[_c('div',{staticClass:"form__buttons pull-right"},[_c('button',{staticClass:"button--cta has-no-margin-right",attrs:{"type":"submit","disabled":!_vm.canSubmit},on:{"click":function($event){$event.preventDefault();_vm.$emit('submit', _vm.comment)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('form.appointment.button_submit'))+"\n                ")]),_vm._v(" "),_c('button',{staticClass:"button pull-left has-smaller-horizontal-padding",attrs:{"disabled":_vm.busy},on:{"click":function($event){$event.preventDefault();_vm.$emit('back')}}},[_vm._v("\n                    "+_vm._s(_vm.$t('common.button.go_back'))+"\n                ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h1',[_vm._v("Support")]),_vm._v(" "),_c('wizard-state-tracker',{attrs:{"stage":_vm.stage}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 ",class:{'col-xl-9': !_vm.isAppointmentStage}},[_c('div',{class:{'block': !_vm.isAppointmentStage}},[(_vm.isTitleStage)?_c('wizard-title-select',{on:{"submit":_vm.gotoDetailStage}}):(_vm.isDetailStage)?_c('wizard-detail-select',{on:{"submit":_vm.gotoAppointmentStage,"reset":_vm.gotoTitleStage}}):(_vm.isAppointmentStage)?_c('moments-form',{attrs:{"title":_vm.$t('proposal.header_moments_picker_support'),"busy":_vm.posting},on:{"submit":_vm.submitTicket,"back":_vm.gotoDetailStage}}):(_vm.isPostedStage)?_c('div',[_c('p',[_vm._v(_vm._s(_vm.$t('support.wizard.label_posted_stage')))])]):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5188242_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__ = __webpack_require__(415);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5188242_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Account; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_modules_account_details__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_Loader__ = __webpack_require__(31);






var _dec, _class;






var Account = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])({
    components: { Loader: __WEBPACK_IMPORTED_MODULE_8__components_general_Loader__["a" /* default */] }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Account, _Vue);

    function Account() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Account);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Account.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Account)).call.apply(_ref, [this].concat(args))), _this), _this.fetch = {
            loading: false,
            error: false
        }, _this.transitionName = '', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Account, [{
        key: 'created',
        value: function created() {
            var _this2 = this;

            this.fetch.loading = true;
            this.fetch.error = false;
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_7__store_modules_account_details__["a" /* FETCH_ACCOUNT_DETAILS */]).catch(function (error) {
                _this2.fetch.error = _this2.$t('common.notify_fetch_failure');
                _this2.$notify.error(_this2.fetch.error);
            }).finally(function () {
                return _this2.fetch.loading = false;
            });
        }
    }, {
        key: 'beforeRouteUpdate',
        value: function beforeRouteUpdate(to, from, next) {
            var isSubPage = to.path.includes(from.path);
            this.transitionName = isSubPage ? '' : '';

            next();
        }
    }]);

    return Account;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-12 col-xxl-12"},[_c('h1',[_vm._v(_vm._s(_vm.$t('account_info.header_main')))]),_vm._v(" "),_c('loader',_vm._b({},'loader',_vm.fetch,false),[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c('router-view')],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewAccount_vue__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_549cb7bd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewAccount_vue__ = __webpack_require__(418);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewAccount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_549cb7bd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewAccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewAccount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_modules_account_details__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_dateformat__ = __webpack_require__(230);






var _class;






var ViewAccount = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ViewAccount, _Vue);

    function ViewAccount() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ViewAccount);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ViewAccount.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ViewAccount)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ViewAccount, [{
        key: 'created',
        value: function created() {
            window.scrollTo(0, 0);
        }
    }, {
        key: 'localizeFieldName',
        value: function localizeFieldName(field) {
            return this.$t('form.account_info.label_' + field);
        }
    }, {
        key: 'getFieldValue',
        value: function getFieldValue(field) {
            if (field === 'gender') {
                switch (this.$store.getters[__WEBPACK_IMPORTED_MODULE_7__store_modules_account_details__["c" /* GET_FIELD */]](field)) {
                    case 'M':
                        return this.$t('common.account_title.M');
                    case 'F':
                        return this.$t('common.account_title.F');
                    default:
                        return '';
                }
            }
            if (field === 'guarantee') {
                var value = this.$store.getters[__WEBPACK_IMPORTED_MODULE_7__store_modules_account_details__["c" /* GET_FIELD */]](field);
                if (value === false) {
                    return this.$t('account_info.guarantee.unavailable');
                }
                if (value === null) {
                    return this.$t('account_info.guarantee.no-installation-moment-found');
                }
                var now = new Date();
                if (value > now) {
                    return this.$t('account_info.guarantee.active_until', { date: Object(__WEBPACK_IMPORTED_MODULE_8__api_dateformat__["a" /* exportDateShort */])(value) });
                }
                return this.$t('account_info.guarantee.expired_on', { date: Object(__WEBPACK_IMPORTED_MODULE_8__api_dateformat__["a" /* exportDateShort */])(value) });
            }
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_7__store_modules_account_details__["c" /* GET_FIELD */]](field);
        }
    }, {
        key: 'sections',
        get: function get() {
            return [['gender', 'first_name', 'last_name'], ['address', 'address_number', 'postal_code', 'city_name', 'country_name'], ['telephone_number', 'mobile_number', 'email_address'], ['guarantee']];
        }
    }, {
        key: 'contactUrl',
        get: function get() {
            return this.$t('account_info.address_information_contact_url');
        }
    }]);

    return ViewAccount;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;



/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"block--mobile"},[_c('table',{staticClass:"table--simple hidden-xs"},_vm._l((_vm.sections),function(section){return _c('tbody',_vm._l((section),function(field){return _c('tr',[_c('td',{staticClass:"td--large"},[_c('strong',[_vm._v(_vm._s(_vm.localizeFieldName(field)))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getFieldValue(field)))])])}))})),_vm._v(" "),_vm._l((_vm.sections),function(section){return _c('div',{staticClass:"visible-xs"},_vm._l((section),function(field){return _c('p',[_c('strong',[_vm._v(_vm._s(_vm.localizeFieldName(field)))]),_vm._v(": "+_vm._s(_vm.getFieldValue(field))+"\n            ")])}))})],2),_vm._v(" "),_c('div',{staticClass:"alert--info adapted-width"},[_vm._v("\n            "+_vm._s(_vm.$t('account_info.address_information'))+"\n            "),_c('a',{attrs:{"target":"_blank","href":_vm.contactUrl}},[_vm._v(_vm._s(_vm.$t('account_info.address_information_contact')))])]),_vm._v(" "),_c('router-link',{staticClass:"button--cta",attrs:{"to":{name: 'edit-account'}}},[_vm._v("\n        "+_vm._s(_vm.$t('account_info.button_edit'))+"\n    ")]),_vm._v(" "),_c('router-link',{staticClass:"button",attrs:{"to":{name: 'change-password'}}},[_vm._v("\n        "+_vm._s(_vm.$t('account_info.button_change_password'))+"\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountInfoForm_vue__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0227cf4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountInfoForm_vue__ = __webpack_require__(422);
function injectStyle (ssrContext) {
  __webpack_require__(420)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountInfoForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0227cf4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountInfoForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountInfoForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_select__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_modules_account_details__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);








var _dec, _class;







var AccountInfoForm = (_dec = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Component"])({
    components: {
        vSelect: __WEBPACK_IMPORTED_MODULE_9_vue_select___default.a
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(AccountInfoForm, _Vue);

    function AccountInfoForm() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, AccountInfoForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AccountInfoForm.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(AccountInfoForm)).call.apply(_ref, [this].concat(args))), _this), _this.simpleFields = [{ name: 'first_name', required: true, type: 'text' }, { name: 'last_name', required: true, type: 'text' }, { name: 'telephone_number', required: false, type: 'tel', icon: 'mdi mdi-phone' }, { name: 'mobile_number', required: false, type: 'tel', icon: 'mdi mdi-cellphone' }, { name: 'email_address', required: true, type: 'email', icon: 'mdi mdi-email-outline' }], _this.submitting = false, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(AccountInfoForm, [{
        key: 'created',
        value: function created() {
            var _this2 = this;

            window.scrollTo(0, 0);
            this.account = __WEBPACK_IMPORTED_MODULE_11_lodash___default.a.mapValues(__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.mapKeys(__WEBPACK_IMPORTED_MODULE_10__store_modules_account_details__["b" /* FIELDS */]), function (field) {
                return _this2.$store.getters[__WEBPACK_IMPORTED_MODULE_10__store_modules_account_details__["c" /* GET_FIELD */]](field);
            });
        }
    }, {
        key: 'localizeTitle',
        value: function localizeTitle(title) {
            return this.$t('common.account_title.' + title);
        }
    }, {
        key: 'getFieldLabel',
        value: function getFieldLabel(field) {
            var label = this.$t('form.account_info.label_' + field.name);
            return field.required ? label + ' *' : label;
        }
    }, {
        key: 'submit',
        value: function submit() {
            var _this3 = this;

            this.submitting = true;
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__store_modules_account_details__["h" /* SUBMIT_ACCOUNT_DETAILS */]).then(function () {
                _this3.$notify.success(_this3.$t('form.account_info.notify_success'));
                _this3.$router.replace({
                    name: 'account'
                });
            }).catch(function (error) {
                _this3.$notify.error(_this3.$t('form.account_info.notify_failure'));
            }).finally(function () {
                return _this3.submitting = false;
            });
        }
    }, {
        key: 'beforeRouteLeave',
        value: function beforeRouteLeave(to, from, next) {
            if (!this.$store.getters[__WEBPACK_IMPORTED_MODULE_10__store_modules_account_details__["e" /* IS_DIRTY */]]) {
                next();
                return;
            }
            if (window.confirm(this.$t('common.question_unsaved_changes'))) {
                this.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_modules_account_details__["f" /* RESET_FIELDS */]);
                next();
            } else {
                next(false);
            }
        }
    }, {
        key: 'contactUrl',
        get: function get() {
            return this.$t('account_info.address_information_contact_url');
        }
    }, {
        key: 'proxy',
        get: function get() {
            var store = this.$store;
            var names = ['gender'].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.simpleFields.map(function (field) {
                return field.name;
            })));
            return names.reduce(function (obj, field) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(obj, field, {
                    get: function get() {
                        return store.getters[__WEBPACK_IMPORTED_MODULE_10__store_modules_account_details__["c" /* GET_FIELD */]](field);
                    },
                    set: function set(value) {
                        return store.commit(__WEBPACK_IMPORTED_MODULE_10__store_modules_account_details__["g" /* SET_FIELD */], { field: field, value: value });
                    }
                });
                return obj;
            }, {});
        }
    }, {
        key: 'titles',
        get: function get() {
            return ['M', 'F'];
        }
    }, {
        key: 'canSubmit',
        get: function get() {
            return !this.submitting && this.$store.getters[__WEBPACK_IMPORTED_MODULE_10__store_modules_account_details__["e" /* IS_DIRTY */]];
        }
    }]);

    return AccountInfoForm;
}(__WEBPACK_IMPORTED_MODULE_7_vue__["default"])) || _class);


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();_vm.submit($event)}}},[_c('div',{staticClass:"block"},[_c('div',{staticClass:"form__group"},_vm._l((_vm.titles),function(gender){return _c('div',{staticClass:"radio is-inline"},[_c('input',{directives:[{name:"gen",rawName:"v-gen.id",value:(gender),expression:"gender",modifiers:{"id":true}},{name:"model",rawName:"v-model",value:(_vm.proxy.gender),expression:"proxy.gender"}],staticClass:"radio__rb",attrs:{"type":"radio","name":"radio","required":""},domProps:{"value":gender,"checked":_vm._q(_vm.proxy.gender,gender)},on:{"change":function($event){_vm.$set(_vm.proxy, "gender", gender)}}}),_vm._v(" "),_c('label',{directives:[{name:"gen",rawName:"v-gen.for",value:(gender),expression:"gender",modifiers:{"for":true}}],staticClass:"radio__label"},[_vm._v("\n                    "+_vm._s(_vm.localizeTitle(gender))+"\n                ")])])})),_vm._v(" "),_vm._l((_vm.simpleFields),function(field){return _c('div',{key:field.name,staticClass:"form__group"},[_c('transition',{attrs:{"name":"fade"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.proxy[field.name]),expression:"proxy[field.name]"}],staticClass:"floating-label"},[_vm._v(_vm._s(_vm.getFieldLabel(field)))])]),_vm._v(" "),(field.icon)?_c('i',{staticClass:"form__input__icon",class:field.icon}):_vm._e(),_vm._v(" "),((field.type)==='checkbox')?_c('input',{directives:[{name:"gen",rawName:"v-gen.id",value:(field.name),expression:"field.name",modifiers:{"id":true}},{name:"model",rawName:"v-model",value:(_vm.proxy[field.name]),expression:"proxy[field.name]"}],staticClass:"form__input--text underline",class:field.icon && 'has-icon',attrs:{"required":field.required,"placeholder":_vm.getFieldLabel(field),"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.proxy[field.name])?_vm._i(_vm.proxy[field.name],null)>-1:(_vm.proxy[field.name])},on:{"change":function($event){var $$a=_vm.proxy[field.name],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.proxy[field.name]=$$a.concat([$$v]))}else{$$i>-1&&(_vm.proxy[field.name]=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.proxy, field.name, $$c)}}}}):((field.type)==='radio')?_c('input',{directives:[{name:"gen",rawName:"v-gen.id",value:(field.name),expression:"field.name",modifiers:{"id":true}},{name:"model",rawName:"v-model",value:(_vm.proxy[field.name]),expression:"proxy[field.name]"}],staticClass:"form__input--text underline",class:field.icon && 'has-icon',attrs:{"required":field.required,"placeholder":_vm.getFieldLabel(field),"type":"radio"},domProps:{"checked":_vm._q(_vm.proxy[field.name],null)},on:{"change":function($event){_vm.$set(_vm.proxy, field.name, null)}}}):_c('input',{directives:[{name:"gen",rawName:"v-gen.id",value:(field.name),expression:"field.name",modifiers:{"id":true}},{name:"model",rawName:"v-model",value:(_vm.proxy[field.name]),expression:"proxy[field.name]"}],staticClass:"form__input--text underline",class:field.icon && 'has-icon',attrs:{"required":field.required,"placeholder":_vm.getFieldLabel(field),"type":field.type},domProps:{"value":(_vm.proxy[field.name])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.proxy, field.name, $event.target.value)}}})],1)})],2),_vm._v(" "),_c('div',{staticClass:"alert--info has-bottom-margin"},[_vm._v("\n        "+_vm._s(_vm.$t('account_info.address_information'))+"\n        "),_c('a',{attrs:{"target":"_blank","href":_vm.contactUrl}},[_vm._v(_vm._s(_vm.$t('account_info.address_information_contact')))])]),_vm._v(" "),_c('button',{staticClass:"button--cta",class:{loading: _vm.submitting},attrs:{"type":"submit","disabled":!_vm.canSubmit}},[_vm._v("\n        "+_vm._s(_vm.$t('form.account_info.button_submit'))+"\n    ")]),_vm._v(" "),_c('router-link',{staticClass:"button pull-left",attrs:{"to":{name: 'account'},"tag":"button"}},[_vm._v("\n        "+_vm._s(_vm.$t('common.button.go_back'))+"\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f1fa454_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__ = __webpack_require__(425);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f1fa454_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChangePassword; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_modules_auth__ = __webpack_require__(13);








var _class;





var ChangePassword = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Component"])(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ChangePassword, _Vue);

    function ChangePassword() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ChangePassword);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ChangePassword.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ChangePassword)).call.apply(_ref, [this].concat(args))), _this), _this.oldPassword = '', _this.password = '', _this.repeatPassword = '', _this.submitting = false, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ChangePassword, [{
        key: 'created',
        value: function created() {
            window.scrollTo(0, 0);
        }
    }, {
        key: 'sumbit',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var payload;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.submitting = true;
                                _context.prev = 1;
                                payload = { old_password: this.oldPassword, password: this.password, repeat_password: this.repeatPassword };
                                _context.next = 5;
                                return this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__store_modules_auth__["i" /* SUBMIT_PASSWORD_CHANGE */], payload);

                            case 5:
                                this.$notify.success(this.$t('form.account_info.notify_success'));
                                _context.next = 11;
                                break;

                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context['catch'](1);

                                this.$notify.error(this.$t('form.account_info.notify_failure_change_password'));

                            case 11:
                                _context.prev = 11;

                                this.submitting = false;
                                this.oldPassword = '';
                                this.password = '';
                                this.repeatPassword = '';
                                return _context.finish(11);

                            case 17:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[1, 8, 11, 17]]);
            }));

            function sumbit() {
                return _ref2.apply(this, arguments);
            }

            return sumbit;
        }()
    }, {
        key: 'canSubmit',
        get: function get() {
            return !this.submitting && this.oldPassword.trim() != '' && this.password == this.repeatPassword && this.password.trim() != '';
        }
    }]);

    return ChangePassword;
}(__WEBPACK_IMPORTED_MODULE_7_vue__["default"])) || _class;



/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"block has-no-top-margin"},[_c('h2',[_vm._v(_vm._s(_vm.$t('auth.header_reset_password')))]),_vm._v(" "),_c('form',{staticClass:"form"},[_c('transition',{attrs:{"name":"fade"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.oldPassword),expression:"oldPassword"}],staticClass:"floating-label"},[_vm._v(_vm._s(_vm.$t('auth.old_password')))])]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('i',{staticClass:"form__input__icon mdi mdi-account-key"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.oldPassword),expression:"oldPassword"}],staticClass:"form__input--text underline has-icon",attrs:{"type":"password","autocomplete":"password","name":"password","placeholder":_vm.$t('auth.old_password')},domProps:{"value":(_vm.oldPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.oldPassword=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('transition',{attrs:{"name":"fade"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.password),expression:"password"}],staticClass:"floating-label"},[_vm._v(_vm._s(_vm.$t('auth.new_password')))])]),_vm._v(" "),_c('i',{staticClass:"form__input__icon mdi mdi-account-key"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form__input--text underline has-icon",attrs:{"type":"password","autocomplete":"password","name":"password","placeholder":_vm.$t('auth.new_password')},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})],1),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('transition',{attrs:{"name":"fade"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.repeatPassword),expression:"repeatPassword"}],staticClass:"floating-label"},[_vm._v(_vm._s(_vm.$t('auth.repeat_new_password')))])]),_vm._v(" "),_c('i',{staticClass:"form__input__icon mdi mdi-account-key"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.repeatPassword),expression:"repeatPassword"}],staticClass:"form__input--text underline has-icon",attrs:{"type":"password","autocomplete":"password","name":"password","placeholder":_vm.$t('auth.repeat_new_password')},domProps:{"value":(_vm.repeatPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.repeatPassword=$event.target.value}}})],1),_vm._v(" "),_c('div',{staticClass:"form__buttons"},[_c('button',{staticClass:"button--cta",class:{loading: _vm.submitting},attrs:{"type":"submit","disabled":!_vm.canSubmit},on:{"click":function($event){$event.preventDefault();_vm.sumbit($event)}}},[_vm._v("\n                            "+_vm._s(_vm.$t('auth.button_change_password'))+"\n                        ")]),_vm._v(" "),_c('router-link',{staticClass:"button pull-left",attrs:{"to":{ name: 'account'},"type":"button","tag":"button"}},[_vm._v(_vm._s(_vm.$t('auth.button_cancel')))])],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Referrals_vue__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e0d608c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Referrals_vue__ = __webpack_require__(431);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Referrals_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e0d608c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Referrals_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Referrals; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_forms_ReferralForm__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_modules_referrals__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_general_Loader__ = __webpack_require__(31);








var _dec, _class;








var Referrals = (_dec = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Component"])({
    components: { Loader: __WEBPACK_IMPORTED_MODULE_12__components_general_Loader__["a" /* default */], ReferralForm: __WEBPACK_IMPORTED_MODULE_9__components_forms_ReferralForm__["a" /* default */] }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Referrals, _Vue);

    function Referrals() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Referrals);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Referrals.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Referrals)).call.apply(_ref, [this].concat(args))), _this), _this.email = null, _this.fetch = { loading: false }, _this.submit = { loading: false }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Referrals, [{
        key: 'created',
        value: function created() {
            this.fetch.loading = true;
            this.fetchReferrals();
        }
    }, {
        key: 'fetchReferrals',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;

                                this.fetch.loading = true;
                                _context.next = 4;
                                return this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__store_modules_referrals__["a" /* FETCH_REFERRALS */]);

                            case 4:
                                _context.next = 9;
                                break;

                            case 6:
                                _context.prev = 6;
                                _context.t0 = _context['catch'](0);

                                this.$notify.error(this.$t('common.notify_fetch_failure'));

                            case 9:
                                _context.prev = 9;

                                this.fetch.loading = false;
                                return _context.finish(9);

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 6, 9, 12]]);
            }));

            function fetchReferrals() {
                return _ref2.apply(this, arguments);
            }

            return fetchReferrals;
        }()
    }, {
        key: 'submitReferral',
        value: function () {
            var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.submit.loading = true;
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__store_modules_referrals__["f" /* SUBMIT_REFERRAL */], this.email);

                            case 4:
                                _context2.next = 9;
                                break;

                            case 6:
                                _context2.prev = 6;
                                _context2.t0 = _context2['catch'](1);

                                this.$notify.error(this.$t('form.referral.notify_failure'));

                            case 9:
                                _context2.prev = 9;

                                this.submit.loading = false;
                                this.email = '';
                                return _context2.finish(9);

                            case 13:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[1, 6, 9, 13]]);
            }));

            function submitReferral() {
                return _ref3.apply(this, arguments);
            }

            return submitReferral;
        }()
    }, {
        key: 'formatDate',
        value: function formatDate(date) {
            if (typeof date === 'string') {
                var dateTimeArray = date.split(' ');
                var timeArray = dateTimeArray[1].split(':');
                var dateArray = dateTimeArray[0].split('-');
                return __WEBPACK_IMPORTED_MODULE_11_moment___default()(new Date(dateArray[2], dateArray[1] - 1, dateArray[0], timeArray[0], timeArray[1])).lang(this.$i18n.locale).format('LLLL');
            } else if (typeof date === 'number') {
                var d = new Date(0);
                d.setUTCSeconds(date);
                return __WEBPACK_IMPORTED_MODULE_11_moment___default()(d).lang(this.$i18n.locale).format('LLLL');
            }
        }
    }, {
        key: 'stateIconClass',
        value: function stateIconClass(state) {
            switch (state) {
                case __WEBPACK_IMPORTED_MODULE_10__store_modules_referrals__["e" /* REFERRAL_PENDING */]:
                    return 'mdi mdi-email';
                case __WEBPACK_IMPORTED_MODULE_10__store_modules_referrals__["c" /* REFERRAL_ACCEPTED */]:
                    return 'mdi mdi-currency-eur';
                case __WEBPACK_IMPORTED_MODULE_10__store_modules_referrals__["d" /* REFERRAL_DISCOUNT_RECEIVED */]:
                    return 'mdi mdi-check';
            }
        }
    }, {
        key: 'stateTranslationLabel',
        value: function stateTranslationLabel(state) {
            switch (state) {
                case __WEBPACK_IMPORTED_MODULE_10__store_modules_referrals__["e" /* REFERRAL_PENDING */]:
                    return 'in_progress';
                case __WEBPACK_IMPORTED_MODULE_10__store_modules_referrals__["c" /* REFERRAL_ACCEPTED */]:
                    return 'completed';
                case __WEBPACK_IMPORTED_MODULE_10__store_modules_referrals__["d" /* REFERRAL_DISCOUNT_RECEIVED */]:
                    return 'used';
            }
        }
    }, {
        key: 'referrals',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_10__store_modules_referrals__["b" /* GET_REFERRALS */]];
        }
    }, {
        key: 'canSumbit',
        get: function get() {
            return this.email && this.email.length && this.email.includes('@');
        }
    }]);

    return Referrals;
}(__WEBPACK_IMPORTED_MODULE_7_vue__["default"])) || _class);


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReferralForm_vue__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a959c94e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReferralForm_vue__ = __webpack_require__(430);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReferralForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a959c94e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReferralForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReferralForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);







var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




var MODEL_EVENT = 'input';

var ReferralForm = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Model"])(MODEL_EVENT, { type: String }), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: Boolean, default: false }), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])(), Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ReferralForm, _Vue);

    function ReferralForm() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ReferralForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ReferralForm.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ReferralForm)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'value', _descriptor, _this), _initDefineProp(_this, 'busy', _descriptor2, _this), _initDefineProp(_this, 'disabled', _descriptor3, _this), _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ReferralForm, [{
        key: 'created',
        value: function created() {
            window.scrollTo(0, 0);
        }
    }, {
        key: 'email',
        get: function get() {
            return this.value;
        },
        set: function set(value) {
            this.$emit(MODEL_EVENT, value);
        }
    }]);

    return ReferralForm;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'value', [_dec], {
    enumerable: true,
    initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'busy', [_dec2], {
    enumerable: true,
    initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'disabled', [_dec3], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();_vm.$emit('submit')}}},[_c('div',{staticClass:"block--mobile"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h2',[_vm._v(_vm._s(_vm.$t('form.referral.header_main')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('form.referral.label_info')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-6 col-xxl-7"},[_c('div',{staticClass:"form__group"},[_c('i',{staticClass:"form__input__icon mdi mdi-email-outline"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form__input--text has-icon",attrs:{"type":"email","required":"","placeholder":_vm.$t('form.referral.placeholder_email')},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-6 col-xxl-5"},[_c('div',{staticClass:"form__buttons"},[_c('button',{staticClass:"button--cta no-margin",class:{'is-loading': _vm.busy},attrs:{"type":"submit","disabled":_vm.disabled}},[_vm._v("\n                        "+_vm._s(_vm.$t('form.referral.button_submit'))+"\n                    ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"has-no-margin-bottom"},[_vm._v(_vm._s(_vm.$t('referrals.header_main')))]),_vm._v(" "),_c('referral-form',{attrs:{"disabled":!_vm.canSumbit,"busy":_vm.submit.loading},on:{"submit":_vm.submitReferral},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('div',{staticClass:"hr--dotted"}),_vm._v(" "),_c('div',{staticClass:"block--mobile"},[_c('h2',[_vm._v(_vm._s(_vm.$t('referrals.header_table')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('referrals.label_table_info')))]),_vm._v(" "),_c('loader',_vm._b({staticClass:"table__responsive"},'loader',_vm.fetch,false),[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('referrals.header_email')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('referrals.header_date')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('referrals.header_state')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.referrals),function(referral){return _c('tr',[_c('td',[_vm._v(_vm._s(referral.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatDate(referral.date)))]),_vm._v(" "),_c('td',[_c('i',{class:_vm.stateIconClass(referral.state)}),_vm._v("\n                        "+_vm._s(_vm.$t('referrals.state_detail.' + _vm.stateTranslationLabel(referral.state)))+"\n                    ")])])}))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Experiences_vue__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29805609_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Experiences_vue__ = __webpack_require__(439);
function injectStyle (ssrContext) {
  __webpack_require__(433)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Experiences_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29805609_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Experiences_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Experiences; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_forms_ExperienceForm__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_star_rating__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_modules_experiences__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_general_Loader__ = __webpack_require__(31);








var _dec, _class;









var Experiences = (_dec = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Component"])({
    components: { Loader: __WEBPACK_IMPORTED_MODULE_13__components_general_Loader__["a" /* default */], ExperienceFrom: __WEBPACK_IMPORTED_MODULE_9__components_forms_ExperienceForm__["a" /* default */], StarRating: __WEBPACK_IMPORTED_MODULE_10_vue_star_rating___default.a }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Experiences, _Vue);

    function Experiences() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Experiences);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Experiences.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Experiences)).call.apply(_ref, [this].concat(args))), _this), _this.fetch = { loading: false, error: false }, _this.amountToShow = null, _this.startingValue = 3, _this.incrementValue = 3, _this.moreAvailable = false, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Experiences, [{
        key: 'created',
        value: function created() {
            this.fetch.loading = true;
            this.fetch.error = false;
            this.initExperiences();
        }
    }, {
        key: 'initExperiences',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var firstTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.fetch.loading = true;
                                _context.prev = 1;
                                _context.next = 4;
                                return this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_11__store_modules_experiences__["a" /* FETCH_EXPERIENCES */]);

                            case 4:
                                _context.next = 9;
                                break;

                            case 6:
                                _context.prev = 6;
                                _context.t0 = _context['catch'](1);

                                this.fetch.error = this.$t('common.notify_fetch_failure');

                            case 9:
                                _context.prev = 9;

                                this.fetch.loading = false;
                                return _context.finish(9);

                            case 12:
                                if (firstTime) {
                                    this.initAmount();
                                }

                            case 13:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[1, 6, 9, 12]]);
            }));

            function initExperiences() {
                return _ref2.apply(this, arguments);
            }

            return initExperiences;
        }()
    }, {
        key: 'initAmount',
        value: function initAmount() {
            if (this.experiecesCount <= this.startingValue) {
                this.amountToShow = this.experiecesCount;
                this.moreAvailable = false;
            } else {
                this.amountToShow = this.startingValue;
                this.moreAvailable = true;
            }
        }
    }, {
        key: 'incrementAmount',
        value: function incrementAmount() {
            var oldAmount = this.amountToShow;
            var newAmount = null;
            if (this.experiecesCount <= oldAmount + this.incrementValue) {
                newAmount = this.experiecesCount;
                this.moreAvailable = false;
            } else {
                newAmount = oldAmount + this.incrementValue;
                this.moreAvailable = true;
            }
            this.amountToShow = newAmount;
        }
    }, {
        key: 'formatDate',
        value: function formatDate(date) {
            return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date, 'DD-MM-YYYY h:mm').calendar();
        }
    }, {
        key: 'experiences',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_11__store_modules_experiences__["b" /* GET_EXPERIENCES */]];
        }
    }, {
        key: 'experiecesCount',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_11__store_modules_experiences__["c" /* GET_EXPERIENCES_COUNT */]];
        }
    }]);

    return Experiences;
}(__WEBPACK_IMPORTED_MODULE_7_vue__["default"])) || _class);


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExperienceForm_vue__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30f3d976_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExperienceForm_vue__ = __webpack_require__(438);
function injectStyle (ssrContext) {
  __webpack_require__(436)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExperienceForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30f3d976_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExperienceForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 436 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExperienceFrom; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_star_rating__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_modules_experiences__ = __webpack_require__(52);








var _dec, _class;






var ExperienceFrom = (_dec = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Component"])({
    components: { StarRating: __WEBPACK_IMPORTED_MODULE_9_vue_star_rating___default.a }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ExperienceFrom, _Vue);

    function ExperienceFrom() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ExperienceFrom);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ExperienceFrom.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ExperienceFrom)).call.apply(_ref, [this].concat(args))), _this), _this.hidden = null, _this.title = null, _this.review = null, _this.rating = null, _this.submit = { busy: false, error: false }, _this.error = {
            title: false,
            review: false,
            rating: false
        }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ExperienceFrom, [{
        key: 'created',
        value: function created() {
            this.hidden = true;
        }
    }, {
        key: 'validate',
        value: function validate() {
            this.error.title = false;
            this.error.review = false;
            this.error.rating = false;
            if (this.title && this.review && this.rating) {
                return true;
            } else {
                if (!this.title) {
                    this.error.title = true;
                }
                if (!this.review) {
                    this.error.review = true;
                }
                if (!this.rating) {
                    this.error.rating = true;
                }
            }
        }
    }, {
        key: 'submitExperience',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var payload;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!this.validate()) {
                                    _context.next = 20;
                                    break;
                                }

                                this.submit.busy = true;
                                _context.prev = 2;
                                payload = {
                                    title: this.title,
                                    rating: this.rating * 2,
                                    text: this.review
                                };
                                _context.next = 6;
                                return this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__store_modules_experiences__["d" /* SUBMIT_EXPERIENCE */], payload);

                            case 6:
                                this.$notify.success(this.$t('form.experience.notify_success'));
                                this.hidden = true;
                                this.title = null;
                                this.review = null;
                                this.rating = null;
                                this.$emit('update');
                                _context.next = 17;
                                break;

                            case 14:
                                _context.prev = 14;
                                _context.t0 = _context['catch'](2);

                                this.$notify.error(this.$t('form.experience.notify_failure'));

                            case 17:
                                _context.prev = 17;

                                this.submit.busy = false;
                                return _context.finish(17);

                            case 20:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[2, 14, 17, 20]]);
            }));

            function submitExperience() {
                return _ref2.apply(this, arguments);
            }

            return submitExperience;
        }()
    }]);

    return ExperienceFrom;
}(__WEBPACK_IMPORTED_MODULE_7_vue__["default"])) || _class);


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h2',[_vm._v(_vm._s(_vm.$t('form.experience.header_main')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('form.experience.label_info')))])])]),_vm._v(" "),(_vm.hidden)?_c('button',{staticClass:"button--cta margin-bottom",class:{'loading': _vm.submit.busy},attrs:{"type":"button"},on:{"click":function($event){_vm.hidden = !_vm.hidden}}},[_vm._v("\n                     "+_vm._s(_vm.$t('form.experience.button_review'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.hidden)?_c('div',{staticClass:"block",attrs:{"transition":"expand"}},[_c('div',{staticClass:"form__group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"form__input--text",attrs:{"type":"text","required":"","placeholder":_vm.$t('form.experience.placeholder_title')},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_vm._v(" "),(_vm.error.title)?_c('div',{staticClass:"alert--error"},[_vm._v(" "+_vm._s(_vm.$t('form.experience.error.title')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.review),expression:"review"}],staticClass:"form__input--textarea border_dark",attrs:{"type":"text","required":"","id":"review_form","placeholder":_vm.$t('form.experience.placeholder_review')},domProps:{"value":(_vm.review)},on:{"input":function($event){if($event.target.composing){ return; }_vm.review=$event.target.value}}}),_vm._v(" "),(_vm.error.review)?_c('div',{staticClass:"alert--error"},[_vm._v(" "+_vm._s(_vm.$t('form.experience.error.review')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('star-rating',{attrs:{"increment":0.5,"star-size":30,"active-color":"#6d9ee1","show-rating":false},model:{value:(_vm.rating),callback:function ($$v) {_vm.rating=$$v},expression:"rating"}}),_vm._v(" "),(_vm.error.rating)?_c('div',{staticClass:"alert--error"},[_vm._v(" "+_vm._s(_vm.$t('form.experience.error.rating')))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form__buttons"},[_c('button',{staticClass:"button--cta",class:{'loading': _vm.submit.busy},attrs:{"type":"button"},on:{"click":_vm.submitExperience}},[_vm._v("\n                     "+_vm._s(_vm.$t('form.experience.button_review_submit'))+"\n            ")])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"has-no-margin-bottom"},[_vm._v(_vm._s(_vm.$t('experiences.header_main')))]),_vm._v(" "),_c('experience-from',{on:{"update":function($event){_vm.initExperiences(true)}}}),_vm._v(" "),_c('div',{staticClass:"hr--dotted"}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.$t('experiences.history.header_sub')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('experiences.history.info')))]),_vm._v(" "),_c('loader',{attrs:{"loading":_vm.fetch.loading,"error":_vm.fetch.error}},[(_vm.experiecesCount > 0)?_c('div',_vm._l((_vm.experiences.slice(0, _vm.amountToShow)),function(experience,index){return _c('div',{key:index,staticClass:"col-12"},[_c('div',{staticClass:"row experience",class:{'odd': index % 2 === 0, 'even': index % 2 !== 0 }},[_c('div',{staticClass:"col-md-10 col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8"},[_c('div',{staticClass:"row"},[_c('p',[_c('strong',[_vm._v(_vm._s(experience.title))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[(index % 2 === 0)?_c('star-rating',{attrs:{"star-size":15,"active-color":"#5a5a5a","show-rating":false,"rating":experience.rating/2,"read-only":true,"increment":0.5,"inactive-color":"#dedede","border-color":"#5a5a5a","border-width":2}}):_c('star-rating',{attrs:{"star-size":15,"active-color":"#5a5a5a","show-rating":false,"rating":experience.rating/2,"read-only":true,"increment":0.5,"inactive-color":"#ffffff","border-color":"#5a5a5a","border-width":2}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-4 align-right"},[_c('p',[_vm._v(_vm._s(_vm.formatDate(experience.created)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',[_vm._v(_vm._s(experience.text))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2  col-sm-12 align-center"},[_c('p',{staticClass:"status"},[_vm._v(_vm._s(_vm.$t('experiences.history.status')))]),_vm._v(" "),_c('p',{class:experience.status},[_vm._v("\n                              "+_vm._s(_vm.$t('experiences.status.' + experience.status))+"\n                          ")])]),_vm._v(" "),(_vm.moreAvailable && index === _vm.amountToShow - 1)?_c('p',{staticClass:"read-more status",on:{"click":_vm.incrementAmount}},[_vm._v("\n                          "+_vm._s(_vm.$t('experiences.view_more'))+"\n                      ")]):_vm._e()])])})):_c('div',[_c('p',[_vm._v(_vm._s(_vm.$t('experiences.no_reviews')))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Styleguide_vue__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18470198_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Styleguide_vue__ = __webpack_require__(448);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Styleguide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18470198_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Styleguide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Styleguide; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_select__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_StyleguideModal__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_StyleguideModalSmall__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_general_Loader__ = __webpack_require__(31);






var _dec, _class;









var Styleguide = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])({
    data: function data() {
        return {
            tooltip: 0,
            spinner: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        setInterval(function () {
            _this.tooltip += 1;
        }, 1000);
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_10__components_general_Loader__["a" /* default */],
        vSelect: __WEBPACK_IMPORTED_MODULE_7_vue_select___default.a,
        StyleguideModal: __WEBPACK_IMPORTED_MODULE_8__components_modals_StyleguideModal__["a" /* default */],
        StyleguideModalSmall: __WEBPACK_IMPORTED_MODULE_9__components_modals_StyleguideModalSmall__["a" /* default */]
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Styleguide, _Vue);

    function Styleguide() {
        var _ref;

        var _temp, _this2, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Styleguide);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Styleguide.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Styleguide)).call.apply(_ref, [this].concat(args))), _this2), _this2.name = 'styleguide', _this2.selected = null, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this2, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Styleguide, [{
        key: 'showStyleguideModal',
        value: function showStyleguideModal() {
            this.$modal.show('styleguide-modal');
        }
    }, {
        key: 'showStyleguideModalSmall',
        value: function showStyleguideModalSmall() {
            this.$modal.show('styleguide-modal-small');
        }
    }]);

    return Styleguide;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StyleguideModal_vue__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fc82a88_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleguideModal_vue__ = __webpack_require__(444);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StyleguideModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fc82a88_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleguideModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleguideModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_ModalWrapper__ = __webpack_require__(78);





var _dec, _class;





var StyleguideModal = (_dec = Object(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__["Component"])({
    components: {
        ModalWrapper: __WEBPACK_IMPORTED_MODULE_6__components_general_ModalWrapper__["a" /* default */]
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(StyleguideModal, _Vue);

    function StyleguideModal() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, StyleguideModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = StyleguideModal.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(StyleguideModal)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'styleguide-modal', _this.selected1 = null, _this.selected2 = null, _this.selected3 = null, _this.selected4 = null, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return StyleguideModal;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class);


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-wrapper',{attrs:{"modalClass":"modal","modalName":_vm.name}},[_c('form',{staticClass:"form"},[_c('div',{staticClass:"modal__header"},[_c('h3',[_vm._v("Styleguide modal")])]),_vm._v(" "),_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is a dropdown")]),_vm._v(" "),_c('v-select',{attrs:{"options":['Dropdown Item 1','Dropdown Item 2','Dropdown Item 3'],"value":"Item 1","placeholder":"Choose an item..."},model:{value:(_vm.selected1),callback:function ($$v) {_vm.selected1=$$v},expression:"selected1"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("Extra header")]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is another dropdown")]),_vm._v(" "),_c('v-select',{attrs:{"options":['Dropdown Item 1','Dropdown Item 2','Dropdown Item 3'],"placeholder":"Choose an item..."},model:{value:(_vm.selected2),callback:function ($$v) {_vm.selected2=$$v},expression:"selected2"}})],1),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is one more dropdown")]),_vm._v(" "),_c('v-select',{attrs:{"options":['Dropdown Item 1','Dropdown Item 2','Dropdown Item 3'],"placeholder":"Choose an item..."},model:{value:(_vm.selected3),callback:function ($$v) {_vm.selected3=$$v},expression:"selected3"}})],1),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is a dropdown to select multiple items")]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":['Multiple dropdown Item 1','Multiple dropdown Item 2','Multiple dropdown Item 3'],"placeholder":"Add item"},model:{value:(_vm.selected4),callback:function ($$v) {_vm.selected4=$$v},expression:"selected4"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("Another header")]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('div',{staticClass:"form__label"},[_vm._v("Description text input")]),_vm._v(" "),_c('input',{staticClass:"form__input--text",attrs:{"type":"text","placeholder":"Enter description (optional)..."}})]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Description textarea")]),_vm._v(" "),_c('textarea',{staticClass:"form__input--textarea",attrs:{"placeholder":"Enter remarks (optional)..."}})])]),_vm._v(" "),_c('div',{staticClass:"modal__footer"},[_c('button',{staticClass:"button--cta",attrs:{"type":"submit"}},[_vm._v("Add / Save")]),_vm._v(" "),_c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":function($event){_vm.$modal.hide(_vm.name)}}},[_vm._v("Cancel")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StyleguideModalSmall_vue__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74ad8898_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleguideModalSmall_vue__ = __webpack_require__(447);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StyleguideModalSmall_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74ad8898_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleguideModalSmall_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleguideModalSmall; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_ModalWrapper__ = __webpack_require__(78);





var _dec, _class;





var StyleguideModalSmall = (_dec = Object(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__["Component"])({
    components: {
        ModalWrapper: __WEBPACK_IMPORTED_MODULE_6__components_general_ModalWrapper__["a" /* default */]
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(StyleguideModalSmall, _Vue);

    function StyleguideModalSmall() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, StyleguideModalSmall);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = StyleguideModalSmall.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(StyleguideModalSmall)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'styleguide-modal-small', _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return StyleguideModalSmall;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class);


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-wrapper',{attrs:{"modalClass":"modal--small","modalName":_vm.name}},[_c('div',{staticClass:"modal__header"},[_c('h3',[_vm._v("Styleguide modal small")])]),_vm._v(" "),_c('div',{staticClass:"modal__content"},[_vm._v("\n        Modal for for example a confirmation or simple question.\n    ")]),_vm._v(" "),_c('div',{staticClass:"modal__footer"},[_c('button',{staticClass:"button--cta",attrs:{"type":"submit"}},[_vm._v("Ok")]),_vm._v(" "),_c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":function($event){_vm.$modal.hide(_vm.name)}}},[_vm._v("Cancel")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"styleguide"},[_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_vm._m(3,false,false),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_vm._m(4,false,false),_vm._v(" "),_vm._m(5,false,false),_vm._v(" "),_c('div',{staticClass:"styleguide__item"},[_c('loader',{attrs:{"loading":_vm.spinner}},[_vm._v("\n                            Hello world (big spinner)\n                        ")])],1),_vm._v(" "),_c('div',{staticClass:"styleguide__item"},[_c('loader',{attrs:{"loading":_vm.spinner,"small":true}},[_vm._v("\n                            Hello world (small spinner)\n                        ")])],1),_vm._v(" "),_c('div',{staticClass:"styleguide__item"},[_c('button',{staticClass:"button--cta",on:{"click":function($event){_vm.spinner = !_vm.spinner}}},[_vm._v("Toggle spinner")])])])])])]),_vm._v(" "),_vm._m(6,false,false),_vm._v(" "),_vm._m(7,false,false),_vm._v(" "),_vm._m(8,false,false),_vm._v(" "),_vm._m(9,false,false),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_vm._m(10,false,false),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('form',{staticClass:"form"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-8 col-md-6"},[_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is a dropdown")]),_vm._v(" "),_c('v-select',{attrs:{"options":['Dropdown Item 1','Dropdown Item 2','Dropdown Item 3'],"value":"Item 1","placeholder":"Choose an item..."},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is a multiple select dropdown")]),_vm._v(" "),_c('v-select',{staticClass:"dropdown",attrs:{"multiple":"","options":['First item','Second item','Third item'],"placeholder":"Choose an item..."}})],1)])])])])])])]),_vm._v(" "),_vm._m(11,false,false),_vm._v(" "),_vm._m(12,false,false),_vm._v(" "),_vm._m(13,false,false),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_vm._m(14,false,false),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('button',{staticClass:"button--cta",on:{"click":_vm.showStyleguideModal}},[_vm._v("Open modal")]),_vm._v(" "),_c('button',{staticClass:"button--cta",on:{"click":_vm.showStyleguideModalSmall}},[_vm._v("Open small modal")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_vm._m(15,false,false),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('span',{attrs:{"data-tooltip":("You've been on this page " + _vm.tooltip + " seconds"),"data-tooltip-pos":"up"}},[_c('i',{staticClass:"mdi mdi-cursor-pointer"}),_vm._v(" Reactive tooltip")]),_c('br'),_vm._v(" "),_vm._m(16,false,false),_c('br'),_vm._v(" "),_vm._m(17,false,false),_c('br'),_vm._v(" "),_vm._m(18,false,false),_c('br'),_vm._v(" "),_vm._m(19,false,false)]),_vm._v(" "),_vm._m(20,false,false)])])])])]),_vm._v(" "),_c('styleguide-modal'),_vm._v(" "),_c('styleguide-modal-small')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h1',[_vm._v("Styled elements according to Minimax Design")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Buttons")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('a',{staticClass:"button",attrs:{"href":"#"}},[_vm._v("Button")]),_vm._v(" "),_c('a',{staticClass:"button is-loading",attrs:{"href":"#"}},[_vm._v("Loading Button")]),_vm._v(" "),_c('a',{staticClass:"button is-disabled",attrs:{"href":"#"}},[_vm._v("Button Disabled")]),_vm._v(" "),_c('a',{staticClass:"button--cta",attrs:{"href":"#"}},[_vm._v("Button CTA")]),_vm._v(" "),_c('a',{staticClass:"button--cta is-disabled",attrs:{"href":"#","disabled":""}},[_vm._v("Button CTA Disabled")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticClass:"button--link",attrs:{"href":"#"}},[_vm._v("Button Link")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticClass:"button--icon",attrs:{"href":"#"}},[_vm._v("Button with icon "),_c('i',{staticClass:"mdi mdi-pencil"})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Teksten")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('h1',[_vm._v("This is an H1 text")]),_vm._v(" "),_c('h2',[_vm._v("This is an H2 text")]),_vm._v(" "),_c('h3',[_vm._v("This is an H3 text")]),_vm._v(" "),_c('p',[_vm._v("This is a short text to present what some standard, "),_c('strong',[_vm._v("bold")]),_vm._v(" and "),_c('i',[_vm._v("italic")]),_vm._v(" text and "),_c('a',{attrs:{"href":"#"}},[_vm._v("a link")]),_vm._v(" would look like.")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Spinner")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"spinner"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"spinner--small"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Breadcrumb")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('ul',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Category")])]),_vm._v(" "),_c('li',[_vm._v("Security Design Tool")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Forms")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('form',{staticClass:"form"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-8 col-md-6"},[_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("These are your options:")]),_vm._v(" "),_c('div',{staticClass:"checkbox is-inline"},[_c('input',{staticClass:"checkbox__cb",attrs:{"type":"checkbox","id":"cb"}}),_vm._v(" "),_c('label',{staticClass:"checkbox__label",attrs:{"for":"cb"}},[_vm._v("Optie 1")])]),_vm._v(" "),_c('div',{staticClass:"checkbox is-inline"},[_c('input',{staticClass:"checkbox__cb",attrs:{"type":"checkbox","id":"cb_2"}}),_vm._v(" "),_c('label',{staticClass:"checkbox__label",attrs:{"for":"cb_2"}},[_vm._v("Optie 2")])])]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Choose an option:")]),_vm._v(" "),_c('div',{staticClass:"radio is-inline"},[_c('input',{staticClass:"radio__rb",attrs:{"type":"radio","name":"radio","id":"radio"}}),_vm._v(" "),_c('label',{staticClass:"radio__label",attrs:{"for":"radio"}},[_vm._v("Radio button 1")])]),_vm._v(" "),_c('div',{staticClass:"radio is-inline"},[_c('input',{staticClass:"radio__rb",attrs:{"type":"radio","name":"radio","id":"radio_1"}}),_vm._v(" "),_c('label',{staticClass:"radio__label",attrs:{"for":"radio_1"}},[_vm._v("Radio button 2")])])]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Text field without icon")]),_vm._v(" "),_c('input',{staticClass:"form__input--text",attrs:{"type":"text","placeholder":"This is an input field"}})]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Text field with icon")]),_vm._v(" "),_c('i',{staticClass:"form__input__icon mdi mdi-email-outline"}),_vm._v(" "),_c('input',{staticClass:"form__input--text has-icon",attrs:{"type":"text","placeholder":"Type email here"}})]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Text field with an error")]),_vm._v(" "),_c('input',{staticClass:"form__input--text has-error",attrs:{"type":"text","placeholder":"Dit is an input field with an error","value":"test"}})]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Textarea")]),_vm._v(" "),_c('textarea',{staticClass:"form__input--textarea",attrs:{"placeholder":"Start typing here..."}})])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Table")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"table__responsive"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Email")]),_vm._v(" "),_c('th',{staticClass:"table__wrap"},[_vm._v("Data")]),_vm._v(" "),_c('th',[_vm._v("State")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("test@elnino.tech")]),_vm._v(" "),_c('td',[_vm._v("Wed. 10-10-2018")]),_vm._v(" "),_c('td',{staticClass:"success"},[_c('i',{staticClass:"mdi mdi-check"}),_vm._v("Bought")]),_vm._v(" "),_c('td',{staticClass:"success"},[_vm._v("You got the 50 euro discount!")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("test@elnino.tech")]),_vm._v(" "),_c('td',[_vm._v("Wed. 10-10-2018")]),_vm._v(" "),_c('td',[_c('i',{staticClass:"mdi mdi-email-outline"}),_vm._v("Email received")]),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("test@elnino.tech")]),_vm._v(" "),_c('td',[_vm._v("Wed. 10-10-2018")]),_vm._v(" "),_c('td',[_c('i',{staticClass:"mdi mdi-sync"}),_vm._v("In progress")]),_vm._v(" "),_c('td')])])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h1',[_vm._v("Elements to be styled")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Dropdowns")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Search")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('div',{staticClass:"styleguide__item"},[_c('form',{staticClass:"search"},[_c('input',{staticClass:"search__input",attrs:{"type":"search","placeholder":"Search.."}}),_vm._v(" "),_c('button',{staticClass:"search__button button--cta",attrs:{"type":"submit"}},[_vm._v("Search")])])]),_vm._v(" "),_c('div',{staticClass:"styleguide__item"},[_c('form',{staticClass:"search"},[_c('input',{staticClass:"search__input",attrs:{"type":"search","placeholder":"Search.."}}),_vm._v(" "),_c('button',{staticClass:"search__button button",attrs:{"type":"submit"}},[_vm._v("Search")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Alerts")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6"},[_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"alert"},[_vm._v("This is a normal information alert!")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"alert--success"},[_vm._v("This is a success alert!")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"alert--warning"},[_vm._v("This is a warning alert")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"alert--error"},[_vm._v("This is an error alert")])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Pagination")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_c('ul',{staticClass:"pagination"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#"}},[_vm._v("1")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("2")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("3")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Modal")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v("Tooltips")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"data-tooltip":"This tooltip is positioned at the top!","data-tooltip-pos":"up"}},[_c('i',{staticClass:"mdi mdi-cursor-pointer"}),_vm._v(" Top tooltip")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"data-tooltip":"This one's on right!","data-tooltip-pos":"right"}},[_c('i',{staticClass:"mdi mdi-cursor-pointer"}),_vm._v(" Right tooltip")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"data-tooltip":"And on left!","data-tooltip-pos":"left"}},[_c('i',{staticClass:"mdi mdi-cursor-pointer"}),_vm._v(" Left tooltip")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"data-tooltip":"This tooltip is positioned at the bottom!","data-tooltip-pos":"down"}},[_c('i',{staticClass:"mdi mdi-cursor-pointer"}),_vm._v(" Bottom tooltip")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-6"},[_c('span',{attrs:{"data-tooltip":"NL/EN","data-tooltip-length":"small","data-tooltip-pos":"up"}},[_c('i',{staticClass:"mdi mdi-cursor-pointer"}),_vm._v(" Small tooltip")]),_c('br'),_vm._v(" "),_c('span',{attrs:{"data-tooltip":"Now that's a super big text we have over here right? Lorem ipsum dolor sit I'm done.","data-tooltip-length":"medium","data-tooltip-pos":"up"}},[_c('i',{staticClass:"mdi mdi-cursor-pointer"}),_vm._v(" Medium tooltip")]),_c('br'),_vm._v(" "),_c('span',{attrs:{"data-tooltip":"What about something really big? This may surpass your window dimensions. Imagine you're on that boring class with that boring teacher and you didn't slept so well last night. Suddenly you're sleeping in class. Can you believe it?!","data-tooltip-length":"large","data-tooltip-pos":"up"}},[_c('i',{staticClass:"mdi mdi-cursor-pointer"}),_vm._v(" Large tooltip")]),_c('br'),_vm._v(" "),_c('span',{attrs:{"data-tooltip":"What about something really big? This may surpass your window dimensions. Imagine you're on that boring class with that boring teacher and you didn't slept so well last night. Suddenly you're sleeping in class. Can you believe it?!","data-tooltip-length":"xlarge","data-tooltip-pos":"up"}},[_c('i',{staticClass:"mdi mdi-cursor-pointer"}),_vm._v(" Extra large tooltip")]),_c('br'),_vm._v(" "),_c('span',{attrs:{"data-tooltip-visible":"","data-tooltip":"I'll stick around 😉","data-tooltip-pos":"right"}},[_c('i',{staticClass:"mdi mdi-cursor-pointer"}),_vm._v(" Always visible tooltip")]),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c7eebb5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__ = __webpack_require__(451);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c7eebb5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageNotFound; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__);





var _class;




var PageNotFound = Object(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__["Component"])(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PageNotFound, _Vue);

    function PageNotFound() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PageNotFound);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = PageNotFound.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PageNotFound)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'page-not-found', _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return PageNotFound;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class;



/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block--small"},[_c('h2',[_vm._v("Sorry, deze pagina bestaat niet...")]),_vm._v(" "),_c('p',[_c('router-link',{staticClass:"button--cta",attrs:{"to":{ name: 'home' }}},[_vm._v("Ga terug")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthenticationPage_vue__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7146a04_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthenticationPage_vue__ = __webpack_require__(457);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthenticationPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7146a04_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthenticationPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthenticationPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_auth_Authentication__ = __webpack_require__(454);





var _dec, _class;





var AuthenticationPage = (_dec = Object(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__["Component"])({
    components: {
        Authentication: __WEBPACK_IMPORTED_MODULE_6__components_auth_Authentication__["a" /* default */]
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AuthenticationPage, _Vue);

    function AuthenticationPage() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AuthenticationPage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AuthenticationPage.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AuthenticationPage)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'authentication-page', _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return AuthenticationPage;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class);


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Authentication_vue__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8705b984_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authentication_vue__ = __webpack_require__(456);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Authentication_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8705b984_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authentication_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Authentication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_modules_auth__ = __webpack_require__(13);






var _class;





var Authentication = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Authentication, _Vue);

    function Authentication() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Authentication);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Authentication.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Authentication)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'authentication', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Authentication, [{
        key: 'created',
        value: function created() {
            if (this.$store.getters[__WEBPACK_IMPORTED_MODULE_7__store_modules_auth__["d" /* IS_AUTHENTICATED */]]) {
                var redirect = this.$route.query.redirect;
                if (redirect) {
                    this.$router.replace(redirect);
                } else {
                    this.$router.replace({
                        name: 'home'
                    });
                }
            }
        }
    }]);

    return Authentication;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;



/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('authentication')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Guidelines_vue__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5bd3b50_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Guidelines_vue__ = __webpack_require__(460);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Guidelines_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5bd3b50_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Guidelines_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageNotFound; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__);





var _class;




var PageNotFound = Object(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__["Component"])(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PageNotFound, _Vue);

    function PageNotFound() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PageNotFound);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = PageNotFound.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PageNotFound)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'page-not-found', _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return PageNotFound;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class;



/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guidelines"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h1',[_vm._v("Guidelines")])])]),_vm._v(" "),_c('div',{staticClass:"block"},[_c('h2',[_vm._v("CSS naming convention")]),_vm._v(" "),_c('p',[_vm._v("\n            For our CSS naming convention we basically make use of "),_c('i',[_vm._v("BEM")]),_vm._v(". I could rewrite the entire documentation, but you can just as easily find a lot of information about it on this website: "),_c('a',{attrs:{"href":"http://getbem.com/","target":"_blank"}},[_vm._v("BEM naming convention")]),_vm._v(".\n            For a quick overview of the syntax, check out this link: "),_c('a',{attrs:{"href":"https://csswizardry.com/2013/01/mindbemding-getting-your-head-round-bem-syntax/","target":"_blank"}},[_vm._v("CSS Wizardry's BEM approach")]),_vm._v(".\n        ")]),_vm._v(" "),_c('h4',[_vm._v("In short")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Components ("),_c('code',[_vm._v(".component { }")]),_vm._v(") are isolated/stand alone pieces of the design, for example sidebars, headers, thumbnails, cards, etc. It's possible for components to be placed in other components.")]),_vm._v(" "),_c('li',[_vm._v("\n                An element ("),_c('code',[_vm._v(".component__element { }")]),_vm._v(") is part of a component that cannot exist on its own. It's not always necessary to add a class to an element (for example a span in a button), but for readability reasons it does help a lot.\n                When an element also occurs in other components you might want to consider if it wouldn't be more appropriate to make it a component.\n            ")]),_vm._v(" "),_c('li',[_vm._v("\n                A modifier ("),_c('code',[_vm._v(".component--modifier { }")]),_vm._v(") is a different state of a component, for example with a different background color, more or less padding, mirrored, etc. Usually the modifier will inherit a lot of the styling of the component (you can\n                do so with scss's "),_c('i',[_vm._v("@extend")]),_vm._v(", after which you can add the modifier specific styling). Sometimes you have a component you would consider to be a modifier (for example "),_c('i',[_vm._v(".button--delete")]),_vm._v(" consisting of only an icon with a hover color),\n                but it's actually easier to not inherit. That's fine too, just decide for yourself if it makes sense.\n            ")])]),_vm._v(" "),_c('h4',[_vm._v("Component, Element, Modifier")]),_vm._v(" "),_c('p',[_vm._v("BEM stands for \"Block, Element, Modifier\". We did start out with the (almost) complete implementation of BEM, but it has since (2013) changed a little bit, adopting to our own preferences: ")]),_vm._v(" "),_c('ul',{staticClass:"guidelines__list--bullets"},[_c('li',[_vm._v("Since we consider "),_c('i',[_vm._v("component")]),_vm._v(" to be a better suitable name for blocks, we could (or should?) call our version "),_c('strong',[_vm._v("CEM")]),_vm._v(" (Component, Element, Modifier)")]),_vm._v(" "),_c('li',[_vm._v("\n                Instead of using a dash for component names consisting of more than 1 word, we use an underscore, e.g.:\n                "),_c('ul',{staticClass:"guidelines__list--bullets"},[_c('li',[_vm._v("cookie_bar")]),_vm._v(" "),_c('li',[_vm._v("cookie_bar--text_link")]),_vm._v(" "),_c('li',[_vm._v("link_block")]),_vm._v(" "),_c('li',[_vm._v("link_block__cta_button")])])]),_vm._v(" "),_c('li',[_vm._v("\n                Contrary to what BEM says about not having to use BEM for everything (for example for a logo inside a header), we do consider everything to be a component. How you choose to define this is up to the design/project and your own choices. In the case of a header with a\n                logo you could:\n\n                "),_c('ol',{staticClass:"guidelines__list--numbers"},[_c('li',[_vm._v("\n                        Split them up in 2 components:\n\n                        "),_c('pre',[_vm._v("                            .header\n                            {\n                                margin: 0 0 $indent-3;\n                                padding: $indent-2;\n                                background: $color-theme;\n                                color: $color-default;\n\n                                //positioning of a component inside another component belongs in the parent component =>\n                                .logo\n                                {\n                                    float: left;\n                                    margin: $indent-1 $indent-3 0 0;\n                                }\n                            }\n\n                            .logo\n                            {\n                                max-width: 100%;\n                                border: 1px solid $color-border;\n                            }\n                        ")]),_vm._v("\n\n                        Logo would probably be a very small component, but even if it needs just 1 line of styling, it's still a component. The advantage of this approach is that you can easily use the logo component somewhere else if needed. If this is not needed, it's\n                        fine to define the logo as an element of the header:\n                    ")]),_vm._v(" "),_c('li',[_vm._v("\n                        Make logo an "),_c('i',[_vm._v("element")]),_vm._v(" of header:\n                    "),_c('pre',[_vm._v("                        .header\n                        {\n                            margin: 0 0 $indent-3;\n                            padding: $indent-2;\n                            background: $color-theme;\n                            color: $color-default;\n\n                            .header__logo\n                            {\n                                float: left;\n                                max-width: 100%;\n                                margin: $indent-1 $indent-3 0 0;\n                                border: 1px solid $color-border;\n                            }\n                        }\n                    ")])])])]),_vm._v(" "),_c('li',[_vm._v("In case you need a class to set a state on a component or element you can do so in the "),_c('i',[_vm._v("states.scss")]),_vm._v(" file by adding "),_c('i',[_vm._v("has-")]),_vm._v(" or "),_c('i',[_vm._v("is-")]),_vm._v(" before whatever state you want to define. For example, if you need a class to set uppercase\n                you can add it to the states.scss file.\n                "),_c('pre',[_vm._v("                    .is-uppercase\n                    {\n                        text-transform: uppercase;\n                    }\n\n                    .has-text-right\n                    {\n                        text-align: right;\n                    }\n                ")])]),_vm._v(" "),_c('li',[_vm._v("\n                Except for some cases where you need to override styling it is not necessary to nest elements within the component. However, doing this does help a lot with readability and findability, so we chose to do it anyway. It's usually not necessary to\n                nest more than 3 levels deep though.\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"block"},[_c('h2',[_vm._v("General CSS rules")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("If the design calls for it (and it usually does) it's possible to use a grid for the layout. We made a custom made version of the Boostrap 4 flexbox grid to accomodate our needs. If necessary this can be changed by changing the settings in the file (grid.scss in the general folder)")]),_vm._v(" "),_c('li',[_vm._v("Components need to be build in a way that you can easily drop them in another (grid) container and they would still look okay (-ish, in case of very small or large containers)")]),_vm._v(" "),_c('li',[_vm._v("Fixed component heights (ideally based on content) and widths (ideally based on grid) should be avoided if possible. Sometimes the design does call for it, in these cases carefully decide what the best approach would be.")]),_vm._v(" "),_c('li',[_vm._v("Use "),_c('i',[_vm._v("rem")]),_vm._v(" for font-sizes. 1.6rem = 16px (make sure font-size = 62.5% on the html tag)")]),_vm._v(" "),_c('li',[_vm._v("Positioning of child components inside parent components should be handled in the parent component (see header / logo example above)")]),_vm._v(" "),_c('li',[_vm._v("Divs, sections, articles, main etc. get a standard "),_c('code',[_vm._v("position: relative;")]),_vm._v(".")]),_vm._v(" "),_c('li',[_vm._v("Absolute positioning is only a good solution if you want to place elements in the padding, pull them out of the standard flow, etc. ")]),_vm._v(" "),_c('li',[_vm._v("Only use margins for spacing between components or elements (outside the (imaginary) border). Padding is used for adding spacing inside the component/element (inside the (imaginary) border).")]),_vm._v(" "),_c('li',[_vm._v("\n                Clearfix is usually not necessary, certainly not as an empty div. You can use a clearfix mixin if necessary, but it's just as effective to add 'overflow: hidden' to the container. Obviously, if there are elements that do need to be visible outside the container,\n                clearfix is still the better choice.\n            ")]),_vm._v(" "),_c('li',[_vm._v("We do not use ID's for styling! Use classes instead.")]),_vm._v(" "),_c('li',[_vm._v("Indents in the code have 4 spaces, the opening curly brace goes on the next line")]),_vm._v(" "),_c('li',[_vm._v("It's almost never necessary to specify what kind of element you're working with ("),_c('code',[_vm._v("div.header")]),_vm._v("), "),_c('code',[_vm._v(".header")]),_vm._v(" will usually do.")]),_vm._v(" "),_c('li',[_vm._v("Do not use tables for layout! If really necessary you can define "),_c('code',[_vm._v("display: table;")]),_vm._v(" and "),_c('code',[_vm._v("display: table-cell;")]),_vm._v(", but if it can be avoided (for example by using flexbox), then that's always better.")]),_vm._v(" "),_c('li',[_vm._v("You don't need to comment out styling that's no longer used. You can just remove it.")]),_vm._v(" "),_c('li',[_vm._v("If you choose to do something that doesn't follow these rules, please add a comment with the reasons")]),_vm._v(" "),_c('li',[_vm._v("\n                Please add the styling for the component directly below the tag, further elements/components below that:\n                "),_c('pre',[_vm._v("                    .component\n                    {\n                        display: block;\n                        margin: $indent-2 0;\n                        padding: $indent-2;\n                        border: 1px solid $color-border;\n\n                        .component__element\n                        {\n                            //Styling here\n                        }\n\n                        .other_component\n                        {\n                            float: right;\n                            margin: $indent-2 0 0;\n                        }\n                    }\n                ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WelcomePage_vue__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c26b1fb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WelcomePage_vue__ = __webpack_require__(468);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WelcomePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c26b1fb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WelcomePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WelcomePage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_modules_plan_installation__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_modules_proposal_progress__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_modules_account_details__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_modules_available_contact_moments__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_general_Loader_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_raven_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_raven_js__);









var _dec, _dec2, _class, _desc, _value, _class2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}











var WelcomePage = (_dec = Object(__WEBPACK_IMPORTED_MODULE_12_vue_property_decorator__["Component"])({
    components: { Loader: __WEBPACK_IMPORTED_MODULE_14__components_general_Loader_vue__["a" /* default */] }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_12_vue_property_decorator__["Watch"])('accountFields', { deep: true }), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(WelcomePage, _Vue);

    function WelcomePage() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, WelcomePage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = WelcomePage.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(WelcomePage)).call.apply(_ref, [this].concat(args))), _this), _this.address = {
            full_name: '',
            street: '',
            number: '',
            postalCode: '',
            city: '',
            country: ''
        }, _temp), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(WelcomePage, [{
        key: 'created',
        value: function created() {
            this.fetchAvailableOptions();
            this.setAddress();
        }
    }, {
        key: 'onAccountFieldsChange',
        value: function onAccountFieldsChange() {
            this.setAddress();
        }
    }, {
        key: 'fetchAvailableOptions',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__store_modules_available_contact_moments__["a" /* FETCH_AVAILABLE_CONTACT_MOMENTS */], { type: 'installation' });

                            case 3:
                                _context.next = 8;
                                break;

                            case 5:
                                _context.prev = 5;
                                _context.t0 = _context['catch'](0);

                                this.$store.commit(__WEBPACK_IMPORTED_MODULE_13__store_modules_available_contact_moments__["h" /* SET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS */], this.$t('form.order_salt.error_fetching_available_contact_moments'));

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 5]]);
            }));

            function fetchAvailableOptions() {
                return _ref2.apply(this, arguments);
            }

            return fetchAvailableOptions;
        }()
    }, {
        key: 'onSubmit',
        value: function () {
            var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var payload;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (this.disabled) {
                                    _context2.next = 24;
                                    break;
                                }

                                this.$store.commit(__WEBPACK_IMPORTED_MODULE_9__store_modules_plan_installation__["b" /* SET_SCHEDULING_INSTALLATION */], true);
                                _context2.prev = 2;
                                payload = {
                                    date: this.selectedOption.date,
                                    comment: this.comment,
                                    driver_id: this.selectedOption.driver_id
                                };
                                _context2.next = 6;
                                return this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__store_modules_plan_installation__["c" /* SUBMIT_ORDER */], payload);

                            case 6:
                                this.$notify.success(this.$t('form.installation.notify_success'));
                                _context2.next = 19;
                                break;

                            case 9:
                                _context2.prev = 9;
                                _context2.t0 = _context2['catch'](2);

                                if (!(_context2.t0.response && _context2.t0.response.data && _context2.t0.response.data.message)) {
                                    _context2.next = 17;
                                    break;
                                }

                                this.$notify.error(_context2.t0.response.data.message);
                                _context2.next = 15;
                                return this.fetchAvailableOptions();

                            case 15:
                                _context2.next = 18;
                                break;

                            case 17:
                                this.$notify.error(this.$t('form.installation.notify_failure'));

                            case 18:
                                __WEBPACK_IMPORTED_MODULE_16_raven_js___default.a.captureException(_context2.t0);

                            case 19:
                                _context2.prev = 19;

                                this.$store.commit(__WEBPACK_IMPORTED_MODULE_9__store_modules_plan_installation__["b" /* SET_SCHEDULING_INSTALLATION */], false);
                                return _context2.finish(19);

                            case 22:
                                _context2.next = 24;
                                return this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__store_modules_proposal_progress__["b" /* FETCH_INSTALLATION_PROGRESS */]);

                            case 24:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[2, 9, 19, 22]]);
            }));

            function onSubmit() {
                return _ref3.apply(this, arguments);
            }

            return onSubmit;
        }()
    }, {
        key: 'setAddress',
        value: function () {
            var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var addressValue;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                addressValue = this.getFieldValue('address');

                                if (!(!addressValue || addressValue === 'address')) {
                                    _context3.next = 3;
                                    break;
                                }

                                return _context3.abrupt('return');

                            case 3:
                                this.address.full_name = this.getFieldValue('name');
                                this.address.street = addressValue;
                                this.address.number = this.getFieldValue('address_number');
                                this.address.postalCode = this.getFieldValue('postal_code');
                                this.address.city = this.getFieldValue('city_name');
                                this.address.country = this.getFieldValue('country_name');

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function setAddress() {
                return _ref4.apply(this, arguments);
            }

            return setAddress;
        }()
    }, {
        key: 'selectOption',
        value: function selectOption(option) {
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_13__store_modules_available_contact_moments__["i" /* SET_SELECTED_OPTION */], option);
        }
    }, {
        key: 'getFieldValue',
        value: function getFieldValue(field) {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_11__store_modules_account_details__["c" /* GET_FIELD */]](field);
        }
    }, {
        key: 'getDateLabel',
        value: function getDateLabel() {
            var date = this.lastOrder.action_timestamp;
            if (date) {
                return __WEBPACK_IMPORTED_MODULE_15_moment___default()(date, 'DD-MM-YYYY hh:mm:ss').format('ddd ll') ? __WEBPACK_IMPORTED_MODULE_15_moment___default()(date, 'DD-MM-YYYY hh:mm:ss').format('ddd ll') : date;
            }
        }
    }, {
        key: 'useMoment',
        value: function useMoment(date, format, output) {
            return __WEBPACK_IMPORTED_MODULE_15_moment___default()(date, format).format(output);
        }
    }, {
        key: 'accountFields',
        get: function get() {
            return this.$store.state.account_details.fields;
        }
    }, {
        key: 'installationProgress',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_10__store_modules_proposal_progress__["d" /* GET_INSTALLATION_PROGRESS */]];
        }
    }, {
        key: 'requestedInstallation',
        get: function get() {
            return this.installationProgress.requested.completed;
        }
    }, {
        key: 'placedInstallation',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_10__store_modules_proposal_progress__["c" /* GET_INSTALLATION_PLACED */]];
        }
    }, {
        key: 'deliveryDate',
        get: function get() {
            if (this.installationProgress.install.date) {
                return this.installationProgress.install.date;
            } else {
                return this.installationProgress.requested.date;
            }
        }
    }, {
        key: 'fetchingAvailableContactMoments',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_13__store_modules_available_contact_moments__["e" /* GET_FETCHING_AVAILABLE_CONTACT_MOMENTS */]];
        }
    }, {
        key: 'errorFetchingAvailableContactMoments',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_13__store_modules_available_contact_moments__["d" /* GET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS */]];
        }
    }, {
        key: 'selectedOption',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_13__store_modules_available_contact_moments__["f" /* GET_SELECTED_OPTION */]];
        }
    }, {
        key: 'comment',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_13__store_modules_available_contact_moments__["c" /* GET_COMMENT */]];
        },
        set: function set(value) {
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_13__store_modules_available_contact_moments__["g" /* SET_COMMENT */], value);
        }
    }, {
        key: 'schedulingInstallation',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_9__store_modules_plan_installation__["a" /* GET_SCHEDULING_INSTALLATION */]];
        }
    }, {
        key: 'availableContactMoments',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_13__store_modules_available_contact_moments__["b" /* GET_AVAILABLE_CONTACT_MOMENTS */]];
        }
    }, {
        key: 'disabled',
        get: function get() {
            return this.schedulingInstallation || !this.selectedOption;
        }
    }, {
        key: 'contactUrl',
        get: function get() {
            return this.$t('account_info.address_information_contact_url');
        }
    }]);

    return WelcomePage;
}(__WEBPACK_IMPORTED_MODULE_8_vue__["default"]), (_applyDecoratedDescriptor(_class2.prototype, 'onAccountFieldsChange', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onAccountFieldsChange'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t('proposal.header')))]),_vm._v(" "),(_vm.requestedInstallation && !_vm.placedInstallation)?_c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{staticClass:"block has-small-margin-bottom has-no-top-margin order-information"},[_c('div',{staticClass:"information-header"},[_c('h2',[_vm._v(_vm._s(_vm.$t('form.installation.has_ordered_information.thank_you_time')))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t('form.installation.has_ordered_information.successfully_requested')))])]),_vm._v(" "),_c('div',{staticClass:"information-body"},[_c('div',{staticClass:"body-content"},[_c('img',{staticClass:"content-icon",attrs:{"src":"static/img/icons/calendar.svg","alt":"calendar icon"}}),_vm._v(" "),_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.useMoment(_vm.deliveryDate, 'DD/MM/YYYY', 'dddd, D MMMM YYYY')))])]),_vm._v(" "),_c('div',{staticClass:"body-content"},[_c('img',{staticClass:"content-icon",attrs:{"src":"static/img/icons/mail.svg","alt":"mail icon"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('form.installation.has_ordered_information.email_mail')))])]),_vm._v(" "),_c('div',{staticClass:"body-content"},[_c('img',{staticClass:"content-icon",attrs:{"src":"static/img/icons/location.svg","alt":"location icon"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('form.installation.has_ordered_information.location')))])]),_vm._v(" "),_c('div',{staticClass:"body-content"},[_c('p',[_vm._v(_vm._s(_vm.$t('form.installation.has_ordered_information.email_calendar')))])])]),_vm._v(" "),_c('hr',{staticClass:"border"}),_vm._v(" "),_c('div',{staticClass:"information-footer"},[_c('h4',[_vm._v(_vm._s(_vm.$t('form.installation.has_ordered_information.phone')))]),_vm._v(" "),_c('div',{staticClass:"footer-contact"},[_c('img',{staticClass:"icon-small",attrs:{"src":"static/img/icons/phone.svg","alt":"location icon"}}),_vm._v(" "),_c('p',[_vm._v("0800 / 24 550")])])])])]):_vm._e(),_vm._v(" "),_c('loader',{attrs:{"loading":_vm.fetchingAvailableContactMoments,"error":_vm.errorFetchingAvailableContactMoments}},[_c('div',{staticClass:"row"},[(!_vm.fetchingAvailableContactMoments && _vm.availableContactMoments && !_vm.requestedInstallation && !_vm.placedInstallation)?_c('div',{staticClass:"col-12 col-md-12 col-l-12 col-xl-10"},[_c('div',{staticClass:"block has-small-margin-bottom has-no-top-margin has-small-padding-top"},[_c('p',[_vm._v(_vm._s(_vm.$t('form.installation.label_info')))]),_vm._v(" "),(_vm.availableContactMoments && _vm.availableContactMoments.length === 0)?_c('p',[_vm._v("\n                        "+_vm._s(_vm.$t('form.order_salt.no_available_dates_found')))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row justify-content-center order-container"},_vm._l((_vm.availableContactMoments),function(option){return _c('div',{key:option.date,staticClass:"container-option",class:_vm.selectedOption === option ? 'selected' : '',on:{"click":function($event){_vm.selectOption(option)}}},[_c('p',{staticClass:"day-name"},[_vm._v(_vm._s(_vm.useMoment(option.date, 'YYYY-MM-DD', 'dddd')))]),_vm._v(" "),_c('h2',{staticClass:"day-date"},[_vm._v(_vm._s(_vm.useMoment(option.date, 'YYYY-MM-DD', 'D MMM').replace('.', ''))+"\n                            ")])])}))]),_vm._v(" "),_c('div',{staticClass:"row gap-y-1"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"block has-no-top-margin has-small-margin-bottom has-small-padding-top"},[_c('div',{staticClass:"address-header"},[_c('h4',[_vm._v(_vm._s(_vm.$t('form.installation.appointment.address')))])]),_vm._v(" "),_c('div',{staticClass:"address-group"},_vm._l((_vm.address),function(value){return _c('p',[_vm._v("\n                                    "+_vm._s(value ? value : '-')+"\n                                ")])}))])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"block has-no-top-margin has-small-margin-bottom has-small-padding-top"},[_c('h4',[_vm._v(_vm._s(_vm.$t('form.appointment.label_comment')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.comment),expression:"comment"}],staticClass:"block__textarea form__input--textarea border_dark",attrs:{"placeholder":_vm.$t('form.appointment.placeholder_comment')},domProps:{"value":(_vm.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comment=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"container-fluid no-padding"},[_c('div',{staticClass:"flex justify-content-end "},[_c('button',{staticClass:"button--cta no-margin-x",attrs:{"disabled":_vm.disabled},on:{"click":_vm.onSubmit}},[_vm._v(_vm._s(_vm.$t('form.installation.button_submit')))])])])]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSaltBlocks_vue__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e67002ec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSaltBlocks_vue__ = __webpack_require__(471);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSaltBlocks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e67002ec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSaltBlocks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrderSaltBlocks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_modules_order_salt__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_modules_orders__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_modules_account_details__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_modules_available_contact_moments__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_general_Loader_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_raven_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_raven_js__);









var _dec, _dec2, _class, _desc, _value, _class2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}











var OrderSaltBlocks = (_dec = Object(__WEBPACK_IMPORTED_MODULE_12_vue_property_decorator__["Component"])({
    components: { Loader: __WEBPACK_IMPORTED_MODULE_14__components_general_Loader_vue__["a" /* default */] }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_12_vue_property_decorator__["Watch"])('accountFields', { deep: true }), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(OrderSaltBlocks, _Vue);

    function OrderSaltBlocks() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, OrderSaltBlocks);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = OrderSaltBlocks.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(OrderSaltBlocks)).call.apply(_ref, [this].concat(args))), _this), _this.address = {
            full_name: '',
            street: '',
            number: '',
            postalCode: '',
            city: '',
            country: ''
        }, _this.activeTooltip = null, _temp), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(OrderSaltBlocks, [{
        key: 'created',
        value: function created() {
            this.fetchLastOrder();
            this.fetchAvailableOptions();
            this.setAddress();
        }
    }, {
        key: 'onAccountFieldsChange',
        value: function onAccountFieldsChange() {
            this.setAddress();
        }
    }, {
        key: 'fetchLastOrder',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__store_modules_orders__["a" /* FETCH_LAST_ORDER */]);

                            case 3:
                                _context.next = 8;
                                break;

                            case 5:
                                _context.prev = 5;
                                _context.t0 = _context['catch'](0);

                                this.$notify.error(this.$t('form.account_info.notify_failure'));

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 5]]);
            }));

            function fetchLastOrder() {
                return _ref2.apply(this, arguments);
            }

            return fetchLastOrder;
        }()
    }, {
        key: 'fetchAvailableOptions',
        value: function () {
            var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__store_modules_available_contact_moments__["a" /* FETCH_AVAILABLE_CONTACT_MOMENTS */]);

                            case 3:
                                _context2.next = 8;
                                break;

                            case 5:
                                _context2.prev = 5;
                                _context2.t0 = _context2['catch'](0);

                                this.$store.commit(__WEBPACK_IMPORTED_MODULE_13__store_modules_available_contact_moments__["h" /* SET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS */], this.$t('form.order_salt.error_fetching_available_contact_moments'));

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[0, 5]]);
            }));

            function fetchAvailableOptions() {
                return _ref3.apply(this, arguments);
            }

            return fetchAvailableOptions;
        }()
    }, {
        key: 'onSubmit',
        value: function () {
            var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var payload;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (this.disabled) {
                                    _context3.next = 24;
                                    break;
                                }

                                this.$store.commit(__WEBPACK_IMPORTED_MODULE_9__store_modules_order_salt__["b" /* SET_SUBMITTING_ORDER */], true);
                                _context3.prev = 2;
                                payload = {
                                    date: this.selectedOption.date,
                                    comment: this.comment,
                                    driver_id: this.selectedOption.driver_id
                                };
                                _context3.next = 6;
                                return this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__store_modules_order_salt__["c" /* SUBMIT_ORDER */], payload);

                            case 6:
                                this.$notify.success(this.$t('form.order_salt.notify_success'));
                                _context3.next = 19;
                                break;

                            case 9:
                                _context3.prev = 9;
                                _context3.t0 = _context3['catch'](2);

                                if (!(_context3.t0.response && _context3.t0.response.data && _context3.t0.response.data.message)) {
                                    _context3.next = 17;
                                    break;
                                }

                                this.$notify.error(_context3.t0.response.data.message);
                                _context3.next = 15;
                                return this.fetchAvailableOptions();

                            case 15:
                                _context3.next = 18;
                                break;

                            case 17:
                                this.$notify.error(this.$t('form.order_salt.notify_failure'));

                            case 18:
                                __WEBPACK_IMPORTED_MODULE_16_raven_js___default.a.captureException(_context3.t0);

                            case 19:
                                _context3.prev = 19;

                                this.$store.commit(__WEBPACK_IMPORTED_MODULE_9__store_modules_order_salt__["b" /* SET_SUBMITTING_ORDER */], false);
                                return _context3.finish(19);

                            case 22:
                                _context3.next = 24;
                                return this.fetchLastOrder();

                            case 24:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[2, 9, 19, 22]]);
            }));

            function onSubmit() {
                return _ref4.apply(this, arguments);
            }

            return onSubmit;
        }()
    }, {
        key: 'setAddress',
        value: function setAddress() {
            var addressValue = this.getFieldValue('address');
            if (!addressValue || addressValue === 'address') {
                return;
            }

            this.address.full_name = this.getFieldValue('name');
            this.address.street = addressValue;
            this.address.number = this.getFieldValue('address_number');
            this.address.postalCode = this.getFieldValue('postal_code');
            this.address.city = this.getFieldValue('city_name');
            this.address.country = this.getFieldValue('country_name');
        }
    }, {
        key: 'selectOption',
        value: function selectOption(option) {
            this.activeTooltip = null;
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_13__store_modules_available_contact_moments__["i" /* SET_SELECTED_OPTION */], option);
        }
    }, {
        key: 'getFieldValue',
        value: function getFieldValue(field) {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_11__store_modules_account_details__["c" /* GET_FIELD */]](field);
        }
    }, {
        key: 'getDateLabel',
        value: function getDateLabel() {
            var date = this.lastOrder.action_timestamp;
            if (date) {
                return __WEBPACK_IMPORTED_MODULE_15_moment___default()(date, 'DD-MM-YYYY hh:mm:ss').format('ddd ll') ? __WEBPACK_IMPORTED_MODULE_15_moment___default()(date, 'DD-MM-YYYY hh:mm:ss').format('ddd ll') : date;
            }
        }
    }, {
        key: 'useMoment',
        value: function useMoment(date, format, output) {
            return __WEBPACK_IMPORTED_MODULE_15_moment___default()(date, format).format(output);
        }
    }, {
        key: 'infoIcon',
        value: function infoIcon() {
            return '\n              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">\n                  <g clip-path="url(#clip0_5016_215)">\n                    <path d="M5.49984 10.5834C8.03114 10.5834 10.0832 8.53139 10.0832 6.00008C10.0832 3.46878 8.03114 1.41675 5.49984 1.41675C2.96853 1.41675 0.916504 3.46878 0.916504 6.00008C0.916504 8.53139 2.96853 10.5834 5.49984 10.5834Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>\n                    <path d="M5.5 7.83341V6.00008M5.5 4.16675H5.50458" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>\n                  </g>\n                  <defs>\n                    <clipPath id="clip0_5016_215">\n                      <rect width="11" height="11" fill="white" transform="translate(0 0.5)"/>\n                    </clipPath>\n                  </defs>\n              </svg>\n            ';
        }
    }, {
        key: 'toggleTooltip',
        value: function toggleTooltip(date) {
            this.activeTooltip = this.activeTooltip === date ? null : date;
        }
    }, {
        key: 'renderLabelTooltip',
        value: function renderLabelTooltip(label) {
            return this.$t('form.order_salt.label_' + label + '_tooltip');
        }
    }, {
        key: 'CO2Icon',
        value: function CO2Icon() {
            return '\n              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path d="M6.73345 1.59728L6.92777 1.20995C6.86771 1.17724 6.80095 1.16016 6.73317 1.16016C6.6654 1.16016 6.59863 1.17724 6.53857 1.20995L6.73345 1.59728Z" fill="#375278"/>\n                <path d="M7.50579 12.2195C8.75382 12.0889 9.91076 11.4799 10.7521 10.5108C11.5934 9.54174 12.0591 8.28164 12.0589 6.97506C12.0589 4.74911 10.8036 2.99252 9.62516 1.82896C8.9629 1.17978 8.23381 0.60882 7.45115 0.126474C7.38562 0.0865407 7.31951 0.0476569 7.25284 0.00983685L7.2407 0.0028105L7.23665 0.000702584C7.23665 0.000702584 7.23463 4.18803e-08 6.99989 0.46655L6.76583 0H6.76448L6.7638 0.000702584L6.75976 0.0028105L6.74762 0.00983685C6.68062 0.0470495 6.6145 0.08594 6.5493 0.126474C5.76664 0.60882 5.03755 1.17978 4.3753 1.82896C3.19689 2.99252 1.94092 4.74911 1.94092 6.97506C1.94082 8.28152 2.40661 9.54145 3.24792 10.5104C4.08923 11.4793 5.24607 12.0882 6.49399 12.2188V13.473C6.49399 13.6128 6.54729 13.7468 6.64217 13.8457C6.73704 13.9445 6.86572 14 6.99989 14C7.13406 14 7.26274 13.9445 7.35761 13.8457C7.45249 13.7468 7.50579 13.6128 7.50579 13.473V12.2195ZM7.50579 11.1585V9.63242L9.4599 8.22926C9.57037 8.14987 9.64604 8.02803 9.67026 7.89053C9.69449 7.75303 9.66528 7.61113 9.58907 7.49606C9.51286 7.38099 9.39589 7.30217 9.26389 7.27693C9.13189 7.2517 8.99567 7.28212 8.8852 7.36151L7.50579 8.35222V6.31528L9.04641 5.11448C9.14954 5.02916 9.21665 4.90531 9.2335 4.76925C9.25035 4.6332 9.2156 4.49566 9.13664 4.38587C9.05768 4.27608 8.94073 4.20269 8.81065 4.1813C8.68056 4.15991 8.5476 4.1922 8.44001 4.27132L7.50579 4.99925V3.45064C7.50579 3.38144 7.4927 3.31291 7.46728 3.24898C7.44185 3.18504 7.40459 3.12695 7.35761 3.07801C7.31064 3.02908 7.25487 2.99026 7.19349 2.96378C7.13211 2.93729 7.06633 2.92366 6.99989 2.92366C6.93345 2.92366 6.86767 2.93729 6.80629 2.96378C6.74491 2.99026 6.68914 3.02908 6.64217 3.07801C6.59519 3.12695 6.55793 3.18504 6.5325 3.24898C6.50708 3.31291 6.49399 3.38144 6.49399 3.45064V4.99925L5.56112 4.27132C5.45353 4.1922 5.32056 4.15991 5.19048 4.1813C5.0604 4.20269 4.94345 4.27608 4.86449 4.38587C4.78553 4.49566 4.75078 4.6332 4.76763 4.76925C4.78448 4.90531 4.85159 5.02916 4.95472 5.11448L6.49467 6.31599V8.35292L5.11525 7.36221C5.00479 7.28895 4.87136 7.26316 4.74302 7.29027C4.61468 7.31738 4.50143 7.39527 4.42709 7.50756C4.35275 7.61986 4.3231 7.7578 4.34439 7.8924C4.36568 8.02699 4.43623 8.14774 4.54123 8.22926L6.49467 9.63313V11.1585C5.51663 11.0302 4.61719 10.5344 3.96517 9.76428C3.31315 8.99415 2.95338 8.0026 2.95339 6.97576C2.95339 5.17631 3.97395 3.679 5.07208 2.59483C5.66118 2.0175 6.30791 1.50753 7.00124 1.07363C7.69456 1.50753 8.3413 2.0175 8.93039 2.59483C10.0279 3.679 11.0484 5.17631 11.0484 6.97576C11.0484 8.0026 10.6887 8.99415 10.0366 9.76428C9.38462 10.5344 8.48517 11.0302 7.50714 11.1585" fill="#272926"/>\n              </svg>\n            ';
        }
    }, {
        key: 'renderCO2Icons',
        value: function renderCO2Icons(label) {
            var count = label === 'suggested' ? 3 : label === 'alternative' ? 2 : 1;
            return this.CO2Icon().repeat(count);
        }
    }, {
        key: 'submittingOrder',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_9__store_modules_order_salt__["a" /* GET_SUBMITTING_ORDER */]];
        }
    }, {
        key: 'fetchingLastOrder',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_10__store_modules_orders__["d" /* GET_FETCHING_LAST_ORDER */]];
        }
    }, {
        key: 'selectedOption',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_13__store_modules_available_contact_moments__["f" /* GET_SELECTED_OPTION */]];
        }
    }, {
        key: 'fetchingAvailableContactMoments',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_13__store_modules_available_contact_moments__["e" /* GET_FETCHING_AVAILABLE_CONTACT_MOMENTS */]];
        }
    }, {
        key: 'errorFetchingAvailableContactMoments',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_13__store_modules_available_contact_moments__["d" /* GET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS */]];
        }
    }, {
        key: 'comment',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_13__store_modules_available_contact_moments__["c" /* GET_COMMENT */]];
        },
        set: function set(value) {
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_13__store_modules_available_contact_moments__["g" /* SET_COMMENT */], value);
        }
    }, {
        key: 'accountFields',
        get: function get() {
            return this.$store.state.account_details.fields;
        }
    }, {
        key: 'lastOrder',
        get: function get() {
            if (this.$store.getters[__WEBPACK_IMPORTED_MODULE_10__store_modules_orders__["e" /* GET_LAST_ORDER */]] !== null && this.$store.getters[__WEBPACK_IMPORTED_MODULE_10__store_modules_orders__["e" /* GET_LAST_ORDER */]] !== undefined) {
                if (this.$store.getters[__WEBPACK_IMPORTED_MODULE_10__store_modules_orders__["e" /* GET_LAST_ORDER */]].hasOwnProperty('completed') && this.$store.getters[__WEBPACK_IMPORTED_MODULE_10__store_modules_orders__["e" /* GET_LAST_ORDER */]].hasOwnProperty('created')) {
                    if (this.$store.getters[__WEBPACK_IMPORTED_MODULE_10__store_modules_orders__["e" /* GET_LAST_ORDER */]].completed === false) {
                        return this.$store.getters[__WEBPACK_IMPORTED_MODULE_10__store_modules_orders__["e" /* GET_LAST_ORDER */]];
                    } else return false;
                }
            } else {
                return false;
            }
        }
    }, {
        key: 'availableContactMoments',
        get: function get() {
            return this.$store.getters[__WEBPACK_IMPORTED_MODULE_13__store_modules_available_contact_moments__["b" /* GET_AVAILABLE_CONTACT_MOMENTS */]];
        }
    }, {
        key: 'disabled',
        get: function get() {
            return this.submittingOrder || this.fetchingLastOrder || !this.selectedOption || this.lastOrder;
        }
    }, {
        key: 'contactUrl',
        get: function get() {
            return this.$t('account_info.address_information_contact_url');
        }
    }]);

    return OrderSaltBlocks;
}(__WEBPACK_IMPORTED_MODULE_8_vue__["default"]), (_applyDecoratedDescriptor(_class2.prototype, 'onAccountFieldsChange', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onAccountFieldsChange'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('form.order_salt.header_main')))]),_vm._v(" "),(!_vm.fetchingLastOrder && _vm.lastOrder)?_c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{staticClass:"block has-small-margin-bottom has-no-top-margin order-information"},[_c('div',{staticClass:"information-header"},[_c('h2',[_vm._v(_vm._s(_vm.$t('form.order_salt.has_ordered_information.thank_you_time')))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t('form.order_salt.has_ordered_information.successfully_requested'))+" "+_vm._s(_vm.getDateLabel())+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"information-body"},[_c('div',{staticClass:"body-content"},[_c('img',{staticClass:"content-icon",attrs:{"src":"static/img/icons/calendar.svg","alt":"calendar icon"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('form.order_salt.has_ordered_information.email_calendar')))])]),_vm._v(" "),_c('div',{staticClass:"body-content"},[_c('img',{staticClass:"content-icon",attrs:{"src":"static/img/icons/mail.svg","alt":"mail icon"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('form.order_salt.has_ordered_information.email_mail')))])]),_vm._v(" "),_c('div',{staticClass:"body-content"},[_c('img',{staticClass:"content-icon",attrs:{"src":"static/img/icons/location.svg","alt":"location icon"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('form.order_salt.has_ordered_information.location')))])])]),_vm._v(" "),_c('hr',{staticClass:"border"}),_vm._v(" "),_c('div',{staticClass:"information-footer"},[_c('h4',[_vm._v(_vm._s(_vm.$t('form.order_salt.has_ordered_information.phone')))]),_vm._v(" "),_c('div',{staticClass:"footer-contact"},[_c('img',{staticClass:"icon-small",attrs:{"src":"static/img/icons/phone.svg","alt":"location icon"}}),_vm._v(" "),_c('p',[_vm._v("0800 / 24 550")])])])])]):_vm._e(),_vm._v(" "),_c('loader',{attrs:{"loading":_vm.fetchingAvailableContactMoments,"error":_vm.errorFetchingAvailableContactMoments}},[_c('div',{staticClass:"row"},[(!_vm.fetchingAvailableContactMoments && _vm.availableContactMoments && !_vm.lastOrder)?_c('div',{staticClass:"col-12 col-md-12 col-l-12 col-xl-10"},[_c('div',{staticClass:"block has-small-margin-bottom"},[_c('h2',[_vm._v(_vm._s(_vm.$t('form.order_salt.header_sub')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('form.order_salt.label_info')))]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('form.order_salt.available_dates')))])]),_vm._v(" "),(_vm.availableContactMoments && _vm.availableContactMoments.length === 0)?_c('p',[_vm._v("\n                        "+_vm._s(_vm.$t('form.order_salt.no_available_dates_found')))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row justify-content-center order-container"},_vm._l((_vm.availableContactMoments),function(option){return _c('div',{key:option.date,staticClass:"container-option",class:_vm.selectedOption === option ? 'selected' : '',on:{"click":function($event){_vm.selectOption(option)}}},[(option.label)?_c('div',{staticClass:"date-label",class:option.label.toLowerCase(),on:{"click":function($event){$event.stopPropagation();_vm.toggleTooltip(option.date)}}},[_c('span',[_vm._v(_vm._s(_vm.$t('form.order_salt.label_' + option.label)))]),_vm._v(" "),_c('i',{domProps:{"innerHTML":_vm._s(_vm.infoIcon())}}),_vm._v(" "),(_vm.activeTooltip === option.date)?_c('div',{staticClass:"tooltip"},[_c('span',[_vm._v(" "+_vm._s(_vm.renderLabelTooltip(option.label)))]),_vm._v(" "),_c('i',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"11","viewBox":"0 0 12 11","fill":"none"}},[_c('path',{attrs:{"d":"M5.10557 10.2111C5.4741 10.9482 6.5259 10.9482 6.89443 10.2111L11.2764 1.44721C11.6088 0.782312 11.1253 0 10.382 0H1.61803C0.874652 0 0.391156 0.782312 0.723607 1.44721L5.10557 10.2111Z","fill":"#322F35"}})])])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"day-name"},[_vm._v(_vm._s(_vm.useMoment(option.date, 'YYYY-MM-DD', 'dddd')))]),_vm._v(" "),_c('h2',{staticClass:"day-date"},[_vm._v(_vm._s(_vm.useMoment(option.date, 'YYYY-MM-DD', 'D MMM').replace('.', ''))+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"co2-icon"},[_c('span',[_vm._v(_vm._s(_vm.$t('form.order_salt.co2_saved'))+":")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.renderCO2Icons(option.label))}})])])}))]),_vm._v(" "),_c('div',{staticClass:"row gap-y-1"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"block has-no-top-margin has-small-margin-bottom has-small-padding-top"},[_c('div',{staticClass:"address-header"},[_c('h4',[_vm._v(_vm._s(_vm.$t('form.installation.appointment.address')))])]),_vm._v(" "),_c('div',{staticClass:"address-group"},_vm._l((_vm.address),function(value){return _c('p',[_vm._v("\n                                    "+_vm._s(value ? value : '-')+"\n                                ")])}))])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"block has-no-top-margin has-small-margin-bottom has-small-padding-top"},[_c('h4',[_vm._v(_vm._s(_vm.$t('form.appointment.label_comment')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.comment),expression:"comment"}],staticClass:"block__textarea form__input--textarea border_dark",attrs:{"placeholder":_vm.$t('form.appointment.placeholder_comment')},domProps:{"value":(_vm.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comment=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"container-fluid no-padding"},[_c('div',{staticClass:"flex justify-content-end "},[_c('button',{staticClass:"button--cta no-margin-x",attrs:{"disabled":_vm.disabled},on:{"click":_vm.onSubmit}},[_vm._v(_vm._s(_vm.$t('form.order_salt.button_submit')))])])])]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44e99784_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__ = __webpack_require__(474);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44e99784_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoginForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_modules_auth__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__general_LocaleButton__ = __webpack_require__(30);








var _dec, _class;






var LoginForm = (_dec = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Component"])({
    components: { LocaleButton: __WEBPACK_IMPORTED_MODULE_10__general_LocaleButton__["a" /* default */] }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(LoginForm, _Vue);

    function LoginForm() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, LoginForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = LoginForm.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(LoginForm)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'login-form', _this.busy = false, _this.error = '', _this.email = '', _this.password = '', _this.emailValidInput = true, _this.passwordMissingInput = false, _this.emailMissingInput = false, _this.loginFailed = false, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(LoginForm, [{
        key: 'login',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var payload, data, redirect;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.emailMissingInput = this.email.trim().length == 0;
                                this.passwordMissingInput = this.password.trim().length == 0;
                                this.emailValidInput = /^\w+([\+.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(this.email);
                                if (!(!this.emailMissingInput && this.emailValidInput && !this.passwordMissingInput)) {
                                    _context.next = 21;
                                    break;
                                }

                                this.error = false;
                                this.busy = true;
                                payload = { email: this.email, password: this.password };
                                _context.prev = 7;
                                _context.next = 10;
                                return this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__store_modules_auth__["e" /* LOGIN */], payload);

                            case 10:
                                _context.next = 16;
                                break;

                            case 12:
                                _context.prev = 12;
                                _context.t0 = _context['catch'](7);

                                if (_context.t0.response && _context.t0.response.data && _context.t0.response.data.data) {
                                    data = _context.t0.response.data.data;

                                    this.error = data.errors[0].message;
                                } else {
                                    this.loginFailed = true;
                                    this.error = this.$t('auth.notify_login_failure');
                                }
                                this.$notify.error(this.error);

                            case 16:
                                _context.prev = 16;

                                this.busy = false;
                                redirect = this.$route.query.redirect;

                                if (redirect) {
                                    this.$router.replace(redirect);
                                } else {
                                    this.$router.replace({
                                        name: 'home'
                                    });
                                }
                                return _context.finish(16);

                            case 21:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[7, 12, 16, 21]]);
            }));

            function login() {
                return _ref2.apply(this, arguments);
            }

            return login;
        }()
    }]);

    return LoginForm;
}(__WEBPACK_IMPORTED_MODULE_7_vue__["default"])) || _class);


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth container-fluid",on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.login($event)}}},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-xl-7 col-lg-8 col-md-10 col-sm-12"},[_c('div',{staticClass:"locale_block login_page"},[_c('locale-button',{staticClass:"locale_block__button--first",attrs:{"language":"nl"}}),_vm._v(" "),_c('locale-button',{staticClass:"locale_block__button",attrs:{"language":"fr"}})],1),_vm._v(" "),_c('div',{staticClass:"block--auth has-no-top-margin"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/logo_minimax.png","alt":"Minimax Client Dashboard","title":"Minimax Client Dashboard","height":"32px"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('auth.header_sub_signin')))]),_vm._v(" "),_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();_vm.login($event)}}},[_c('h1',[_vm._v(_vm._s(_vm.$t('auth.header_signin')))]),_vm._v(" "),(_vm.loginFailed)?_c('div',[_c('div',{staticClass:"row"},[_c('i',{staticClass:"form__input__error-icon mdi mdi-close-circle"}),_vm._v(" "),_c('div',{staticClass:"form__error-message--large"},[_vm._v("\n                                "+_vm._s(_vm.$t('auth.invalid_email_password'))+"\n                            ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('div',[_c('i',{staticClass:"form__input__icon mdi mdi-email-outline",class:{'has-error':!_vm.emailValidInput || _vm.emailMissingInput}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form__input--text underline has-icon",class:{'has-error': !_vm.emailValidInput || _vm.emailMissingInput},attrs:{"name":"email","autocomplete":"email","placeholder":_vm.$t('auth.hint_email')},domProps:{"value":(_vm.email)},on:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32,$event.key)){ return null; }$event.preventDefault();},function($event){_vm.emailMissingInput=false; _vm.emailValidInput=true; _vm.loginFailed=false}],"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),(_vm.emailMissingInput)?_c('div',[_c('div',{staticClass:"row"},[_c('i',{staticClass:"form__input__error-icon mdi mdi-close-circle"}),_vm._v(" "),_c('div',{staticClass:"form__error-message"},[_vm._v("\n                                    "+_vm._s(_vm.$t('auth.error_missing_email'))+"\n                                ")])])]):(!_vm.emailValidInput)?_c('div',[_c('div',{staticClass:"row"},[_c('i',{staticClass:"form__input__error-icon mdi mdi-close-circle"}),_vm._v(" "),_c('div',{staticClass:"form__error-message"},[_vm._v("\n                                    "+_vm._s(_vm.$t('auth.error_email'))+"\n                                ")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('div',[_c('i',{staticClass:"form__input__icon mdi mdi-account-key",class:{'has-error': _vm.passwordMissingInput}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form__input--text underline has-icon",class:{'has-error': _vm.passwordMissingInput},attrs:{"type":"password","autocomplete":"password","name":"password","placeholder":_vm.$t('auth.hint_password')},domProps:{"value":(_vm.password)},on:{"keydown":function($event){_vm.passwordMissingInput=false; _vm.loginFailed=false},"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),(_vm.passwordMissingInput)?_c('div',[_c('div',{staticClass:"row"},[_c('i',{staticClass:"form__input__error-icon mdi mdi-close-circle"}),_vm._v(" "),_c('div',{staticClass:"form__error-message"},[_vm._v("\n                                "+_vm._s(_vm.$t('auth.error_password'))+"\n                            ")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form__buttons"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 order-md-first"},[_c('router-link',{staticClass:"button full-width is-forgot-password",attrs:{"tag":"button","to":{ name: 'reset'}}},[_vm._v("\n                                    "+_vm._s(_vm.$t('auth.link_forgot_password'))+"\n                                ")])],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 order-first"},[_c('button',{staticClass:"button--cta full-width",class:{'is-loading': _vm.busy},attrs:{"type":"submit","disabled":_vm.busy}},[_vm._v("\n                                    "+_vm._s(_vm.$t('auth.button_signin'))+"\n                                ")])])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterForm_vue__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fc82cca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterForm_vue__ = __webpack_require__(477);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fc82cca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RegisterForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_modules_auth__ = __webpack_require__(13);






var _class;





var RegisterForm = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(RegisterForm, _Vue);

    function RegisterForm() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RegisterForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = RegisterForm.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(RegisterForm)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'account-form', _this.registrationComplete = false, _this.account = {
            email: '',
            repeat_email: '',
            password: '',
            repeat_password: '',
            first_name: '',
            last_name: ''
        }, _this.error = '', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(RegisterForm, [{
        key: 'created',
        value: function created() {
            this.registrationComplete = false;
            this.account = {
                email: '',
                repeat_email: '',
                password: '',
                repeat_password: '',
                first_name: '',
                last_name: ''
            };
        }
    }, {
        key: 'register',
        value: function register() {
            var _this2 = this;

            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_7__store_modules_auth__["g" /* REGISTER */], this.account).then(function () {
                _this2.registrationComplete = true;
            }).catch(function (e) {
                if (e.response && e.response.data) {
                    var data = e.response.data;
                    _this2.error = data.errors[0].msg;
                    console.error('[ Login ]', _this2.error);
                }
            });
        }
    }]);

    return RegisterForm;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;



/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.registrationComplete)?_c('div',[_c('h3',[_vm._v("Account succesvol aangemaakt")]),_vm._v(" "),_c('p',[_vm._v("Er is een e-mail verstuurd naar "+_vm._s(_vm.account.email)+". In die e-mail staat hoe u uw registratie kunt afronden.")]),_vm._v(" "),_c('a',{staticClass:"button--cta",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.changeAuthView('LoginForm')}}},[_vm._v("Terug naar inlogscherm")])]):_c('form',{staticClass:"form"},[(_vm.error !== undefined && _vm.error.length > 0)?_c('div',{staticClass:"alert--error"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('h3',[_vm._v("Maak account aan ")]),_vm._v(" "),_c('p',{staticClass:"is-muted"},[_vm._v("* Verplichte velden")]),_vm._v(" "),_c('h4',[_vm._v("Accountgegevens")]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.email),expression:"account.email"}],staticClass:"form__input--text",attrs:{"type":"text","autocomplete":"email","placeholder":"Emailadres *"},domProps:{"value":(_vm.account.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.repeat_email),expression:"account.repeat_email"}],staticClass:"form__input--text",attrs:{"type":"text","autocomplete":"email","placeholder":"Herhaal e-mailadres *"},domProps:{"value":(_vm.account.repeat_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "repeat_email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.password),expression:"account.password"}],staticClass:"form__input--text",attrs:{"type":"password","autocomplete":"new-password","placeholder":"Wachtwoord *"},domProps:{"value":(_vm.account.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.repeat_password),expression:"account.repeat_password"}],staticClass:"form__input--text",attrs:{"type":"password","autocomplete":"new-password","placeholder":"Herhaal wachtwoord *"},domProps:{"value":(_vm.account.repeat_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "repeat_password", $event.target.value)}}})]),_vm._v(" "),_c('h4',[_vm._v("Persoonlijke gegevens")]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.first_name),expression:"account.first_name"}],staticClass:"form__input--text",attrs:{"type":"text","placeholder":"Voornaam *"},domProps:{"value":(_vm.account.first_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "first_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.last_name),expression:"account.last_name"}],staticClass:"form__input--text",attrs:{"type":"text","placeholder":"Achternaam *"},domProps:{"value":(_vm.account.last_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "last_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8"},[_c('input',{staticClass:"form__input--text",attrs:{"type":"text","placeholder":"Straat"}})]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('input',{staticClass:"form__input--text",attrs:{"type":"text","placeholder":"Huisnummer"}})])])]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('input',{staticClass:"form__input--text",attrs:{"type":"text","placeholder":"Postcode"}})]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('input',{staticClass:"form__input--text",attrs:{"type":"text","placeholder":"Woonplaats"}})])])]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('input',{staticClass:"form__input--text",attrs:{"type":"text","placeholder":"Telefoonnummer"}})]),_vm._v(" "),_c('div',{staticClass:"form__buttons"},[_c('button',{staticClass:"button--cta",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.register($event)}}},[_vm._v("Maak account aan")]),_vm._v(" "),_c('router-link',{staticClass:"button--link",attrs:{"to":{ name: 'sign-in' }}},[_vm._v("Annuleren")])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordResetForm_vue__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8091d0c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordResetForm_vue__ = __webpack_require__(480);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordResetForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8091d0c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordResetForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PasswordResetForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__general_LocaleButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_modules_auth__ = __webpack_require__(13);









var _dec, _dec2, _class, _desc, _value, _class2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}






var PasswordResetForm = (_dec = Object(__WEBPACK_IMPORTED_MODULE_9_vue_property_decorator__["Component"])({
    components: { LocaleButton: __WEBPACK_IMPORTED_MODULE_10__general_LocaleButton__["a" /* default */] }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_9_vue_property_decorator__["Watch"])('credentials', { deep: true }), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(PasswordResetForm, _Vue);

    function PasswordResetForm() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, PasswordResetForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = PasswordResetForm.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(PasswordResetForm)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'password-reset-form', _this.loading = false, _this.error = '', _this.formValidated = false, _this.credentials = {
            password: '',
            passwordRepeat: ''
        }, _temp), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(PasswordResetForm, [{
        key: 'validate',
        value: function validate() {
            if (this.credentials.password == this.credentials.passwordRepeat) {
                if (this.credentials.password.length > 6) {
                    this.formValidated = true;
                }
            } else {
                this.formValidated = false;
            }
        }
    }, {
        key: 'change',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var token, payload, data;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.loading = true;
                                token = this.$route.params.token;
                                payload = {};

                                payload.token = token;
                                payload.password = this.credentials.password;
                                payload.repeat_password = this.credentials.passwordRepeat;
                                _context.prev = 6;
                                _context.next = 9;
                                return this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_11__store_modules_auth__["i" /* SUBMIT_PASSWORD_CHANGE */], payload);

                            case 9:
                                this.$notify.success(this.$t('auth.notify_success_reset_password'));
                                this.$router.replace({
                                    name: 'account'
                                });
                                _context.next = 27;
                                break;

                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context['catch'](6);

                                if (!(_context.t0.response && _context.t0.response.data)) {
                                    _context.next = 26;
                                    break;
                                }

                                data = _context.t0.response.data;

                                this.error = data.errors;
                                _context.t1 = this.error;
                                _context.next = _context.t1 === 'Invalid token' ? 21 : 23;
                                break;

                            case 21:
                                this.$notify.error(this.$t('auth.notify_failures.password_reset.invalid_token'));
                                return _context.abrupt('break', 24);

                            case 23:
                                this.$notify.error(this.$t('auth.notify_failures.reset_password.general'));

                            case 24:
                                _context.next = 27;
                                break;

                            case 26:
                                this.$notify.error(this.$t('auth.notify_failures.reset_password.general'));

                            case 27:
                                _context.prev = 27;

                                this.loading = false;
                                return _context.finish(27);

                            case 30:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[6, 13, 27, 30]]);
            }));

            function change() {
                return _ref2.apply(this, arguments);
            }

            return change;
        }()
    }]);

    return PasswordResetForm;
}(__WEBPACK_IMPORTED_MODULE_8_vue__["default"]), (_applyDecoratedDescriptor(_class2.prototype, 'validate', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'validate'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-xl-6 col-lg-8 col-md-10 col-sm-12"},[_c('div',{staticClass:"locale_block password_reset_page"},[_c('locale-button',{staticClass:"locale_block__button--first",attrs:{"language":"nl"}}),_vm._v(" "),_c('locale-button',{staticClass:"locale_block__button",attrs:{"language":"fr"}})],1),_vm._v(" "),_c('div',{staticClass:"block--auth has-no-top-margin"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/logo_minimax.png","alt":"Minimax Client Dashboard","title":"Minimax Client Dashboard","height":"32px"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('auth.header_sub_reset_password')))]),_vm._v(" "),_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();_vm.change($event)}}},[_c('h1',[_vm._v(_vm._s(_vm.$t('auth.header_reset_password')))]),_vm._v(" "),_c('span',{staticClass:"floating-label"},[_vm._v(_vm._s(_vm.$t('auth.new_password')))]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('i',{staticClass:"form__input__icon mdi mdi-textbox-password"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.password),expression:"credentials.password"}],staticClass:"form__input--text underline has-icon",attrs:{"type":"password","autocomplete":"password","placeholder":"****"},domProps:{"value":(_vm.credentials.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "password", $event.target.value)}}})]),_vm._v(" "),_c('span',{staticClass:"floating-label"},[_vm._v(_vm._s(_vm.$t('auth.repeat_new_password')))]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('i',{staticClass:"form__input__icon mdi mdi-textbox-password"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.passwordRepeat),expression:"credentials.passwordRepeat"}],staticClass:"form__input--text underline has-icon",attrs:{"type":"password","autocomplete":"password","placeholder":"****"},domProps:{"value":(_vm.credentials.passwordRepeat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "passwordRepeat", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form__buttons"},[_c('button',{staticClass:"button--cta",class:{'is-loading': _vm.loading},attrs:{"type":"submit","disabled":!_vm.formValidated}},[_vm._v("\n                            "+_vm._s(_vm.$t('auth.button_change_password'))+"\n                        ")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordForgottenForm_vue__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bbbe716_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordForgottenForm_vue__ = __webpack_require__(483);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordForgottenForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bbbe716_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordForgottenForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PasswordForgottenForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__general_LocaleButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_modules_auth__ = __webpack_require__(13);








var _dec, _class;






var PasswordForgottenForm = (_dec = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Component"])({
    components: { LocaleButton: __WEBPACK_IMPORTED_MODULE_9__general_LocaleButton__["a" /* default */] }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(PasswordForgottenForm, _Vue);

    function PasswordForgottenForm() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PasswordForgottenForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = PasswordForgottenForm.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(PasswordForgottenForm)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'password-forgotten-form', _this.newPasswordSent = false, _this.busy = false, _this.email = '', _this.error = '', _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(PasswordForgottenForm, [{
        key: 'request',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var payload, data;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.busy = true;
                                payload = { email: this.email };
                                _context.prev = 2;
                                _context.next = 5;
                                return this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__store_modules_auth__["h" /* REQUEST_NEW_PASSWORD */], payload);

                            case 5:
                                this.$notify.success(this.$t('form.password_forgotten.header_request_success'));
                                this.newPasswordSent = true;
                                _context.next = 14;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](2);

                                console.log(_context.t0);
                                if (_context.t0.response && _context.t0.response.data && _context.t0.response.data.errors) {
                                    data = _context.t0.response.data;

                                    this.error = data.errors;
                                } else {
                                    this.error = this.$t('form.password_forgotten.message_failure');
                                }
                                this.$notify.error(this.error);

                            case 14:
                                _context.prev = 14;

                                this.busy = false;
                                return _context.finish(14);

                            case 17:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[2, 9, 14, 17]]);
            }));

            function request() {
                return _ref2.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return PasswordForgottenForm;
}(__WEBPACK_IMPORTED_MODULE_7_vue__["default"])) || _class);


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-xl-7  col-lg-8 col-md-10 col-sm-12"},[_c('div',{staticClass:"locale_block login_page"},[_c('locale-button',{staticClass:"locale_block__button--first",attrs:{"language":"nl"}}),_vm._v(" "),_c('locale-button',{staticClass:"locale_block__button",attrs:{"language":"fr"}})],1),_vm._v(" "),_c('div',{staticClass:"block--auth has-no-top-margin"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/logo_minimax.png","alt":"Minimax Client Dashboard","title":"Minimax Client Dashboard","height":"32px"}}),_vm._v(" "),(!_vm.newPasswordSent)?_c('p',[_vm._v(_vm._s(_vm.$t('form.password_forgotten.message_forgotten_password')))]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.newPasswordSent)?_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t('form.password_forgotten.header_request_success')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('form.password_forgotten.message_success', {email: _vm.email})))]),_vm._v(" "),_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'sign-in'},"type":"button"}},[_vm._v("\n                            "+_vm._s(_vm.$t('common.button.go_back'))+"\n                        ")])],1):_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();_vm.request($event)}}},[_c('h1',[_vm._v(_vm._s(_vm.$t('form.password_forgotten.header_main')))]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('i',{staticClass:"form__input__icon mdi mdi-email-outline"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form__input--text underline has-icon",attrs:{"type":"email","required":"","name":"email","autocomplete":"email","placeholder":_vm.$t('auth.hint_email')},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form__buttons"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-4 col-lg-5 order-md-first"},[_c('router-link',{staticClass:"button full-width is-forgot-password",attrs:{"to":{name: 'sign-in'}}},[_vm._v("\n                                        "+_vm._s(_vm.$t('common.button.go_back'))+"\n                                    ")])],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8 col-lg-7 order-first"},[_c('button',{staticClass:"button--cta full-width is-forgot-password",class:{'is-loading': _vm.busy},attrs:{"type":"submit","disabled":_vm.busy}},[_vm._v("\n                                        "+_vm._s(_vm.$t('form.password_forgotten.button_submit'))+"\n                                    ")])])])])])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivationForm_vue__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e682c15a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivationForm_vue__ = __webpack_require__(486);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e682c15a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivationForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_property_decorator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_modules_auth__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__general_LocaleButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_instance__ = __webpack_require__(17);









var _dec, _dec2, _class, _desc, _value, _class2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}







var ActivationForm = (_dec = Object(__WEBPACK_IMPORTED_MODULE_9_vue_property_decorator__["Component"])({
    components: { LocaleButton: __WEBPACK_IMPORTED_MODULE_11__general_LocaleButton__["a" /* default */] }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_9_vue_property_decorator__["Watch"])('credentials', { deep: true }), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(ActivationForm, _Vue);

    function ActivationForm() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, ActivationForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ActivationForm.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(ActivationForm)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'activation-form', _this.loading = false, _this.error = '', _this.formValidated = false, _this.invalidToken = false, _this.alreadyActivated = false, _this.credentials = {
            password: '',
            passwordRepeat: ''
        }, _this.resendCodeStatus = {
            loading: false,
            error: '',
            hasResendCode: false
        }, _this.autoResent = false, _temp), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(ActivationForm, [{
        key: 'goToLogin',
        value: function goToLogin() {
            this.$router.push({ name: 'sign-in' }, function () {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            });
        }
    }, {
        key: 'validate',
        value: function validate() {
            if (this.credentials.password === this.credentials.passwordRepeat) {
                if (this.credentials.password.length > 6) {
                    this.formValidated = true;
                }
            } else {
                this.formValidated = false;
            }
        }
    }, {
        key: 'activate',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _this2 = this;

                var token, payload, data, email, resendResponse;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.loading = true;
                                token = this.$route.params.token;
                                payload = {};

                                payload.token = token;
                                payload.password = this.credentials.password;
                                payload.repeat_password = this.credentials.passwordRepeat;

                                _context.prev = 6;
                                _context.next = 9;
                                return this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__store_modules_auth__["a" /* ACTIVATE */], payload);

                            case 9:
                                this.$notify.success(this.$t('auth.notify_success_activate_account'));

                                this.$router.replace({
                                    name: 'account'
                                });

                                _context.next = 57;
                                break;

                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context['catch'](6);

                                if (!(_context.t0.response && _context.t0.response.data)) {
                                    _context.next = 55;
                                    break;
                                }

                                data = _context.t0.response.data;

                                this.error = data.errors;

                                this.invalidToken = false;
                                this.alreadyActivated = false;

                                _context.t1 = this.error;
                                _context.next = _context.t1 === 'Invalid token' ? 23 : _context.t1 === 'Already activated' ? 49 : 52;
                                break;

                            case 23:
                                this.invalidToken = true;

                                if (!this.autoResent) {
                                    _context.next = 26;
                                    break;
                                }

                                return _context.abrupt('break', 53);

                            case 26:
                                email = data && data.email ? data.email : '';

                                if (email) {
                                    _context.next = 30;
                                    break;
                                }

                                this.$notify.error(this.$t('auth.notify_failures.activate_account.resend_activation_link'));
                                return _context.abrupt('break', 53);

                            case 30:
                                _context.prev = 30;

                                this.resendCodeStatus.loading = true;

                                _context.next = 34;
                                return __WEBPACK_IMPORTED_MODULE_12__api_instance__["a" /* default */].post('auth/api/accounts/resend_activation_link', {
                                    email: email,
                                    platform: 'client_dashboard'
                                });

                            case 34:
                                resendResponse = _context.sent;

                                if (!(resendResponse && resendResponse.data && resendResponse.data.success === false)) {
                                    _context.next = 37;
                                    break;
                                }

                                throw new Error(resendResponse.data.message || 'Resend failed');

                            case 37:
                                this.autoResent = true;

                                this.$notify.success(this.$t('auth.notify_success_resend_activation_link'));

                                _context.next = 45;
                                break;

                            case 41:
                                _context.prev = 41;
                                _context.t2 = _context['catch'](30);

                                this.$notify.error(this.$t('auth.notify_failures.activate_account.resend_activation_link'));
                                console.log('[activate] Auto-resend failed:', _context.t2);

                            case 45:
                                _context.prev = 45;

                                this.resendCodeStatus.loading = false;
                                return _context.finish(45);

                            case 48:
                                return _context.abrupt('break', 53);

                            case 49:
                                this.alreadyActivated = true;
                                this.invalidToken = false;
                                return _context.abrupt('break', 53);

                            case 52:
                                this.$notify.error(this.$t('auth.notify_failures.activate_account.general'));

                            case 53:
                                _context.next = 57;
                                break;

                            case 55:
                                this.invalidToken = true;
                                this.$notify.error(this.$t('auth.notify_failures.activate_account.resend_activation_link'));

                            case 57:
                                _context.prev = 57;

                                this.loading = false;

                                if ((this.invalidToken || this.alreadyActivated) && window.innerWidth <= 768) {
                                    this.$nextTick(function () {
                                        var el = _this2.$el.querySelector('.activation-warning');
                                        if (!el) return;

                                        var rect = el.getBoundingClientRect();
                                        var pageTop = rect.top + window.scrollY;
                                        var offset = 250;

                                        window.scrollTo({
                                            top: pageTop - offset,
                                            behavior: 'smooth'
                                        });
                                    });
                                }
                                return _context.finish(57);

                            case 61:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[6, 13, 57, 61], [30, 41, 45, 48]]);
            }));

            function activate() {
                return _ref2.apply(this, arguments);
            }

            return activate;
        }()
    }]);

    return ActivationForm;
}(__WEBPACK_IMPORTED_MODULE_8_vue__["default"]), (_applyDecoratedDescriptor(_class2.prototype, 'validate', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'validate'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-xl-7 col-lg-8 col-md-10 col-sm-12"},[_c('div',{staticClass:"locale_block activation_page"},[_c('locale-button',{staticClass:"locale_block__button--first",attrs:{"language":"nl"}}),_vm._v(" "),_c('locale-button',{staticClass:"locale_block__button",attrs:{"language":"fr"}})],1),_vm._v(" "),_c('div',{staticClass:"block--auth has-no-top-margin"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/logo_minimax.png","alt":"Minimax Client Dashboard","title":"Minimax Client Dashboard","height":"32px"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('auth.header_sub_activate_account')))]),_vm._v(" "),_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();_vm.activate($event)}}},[_c('h1',[_vm._v(_vm._s(_vm.$t('auth.header_activate_account')))]),_vm._v(" "),_c('span',{staticClass:"floating-label"},[_vm._v(_vm._s(_vm.$t('auth.desired_password')))]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('i',{staticClass:"form__input__icon mdi mdi-textbox-password"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.password),expression:"credentials.password"}],staticClass:"form__input--text underline has-icon",attrs:{"type":"password","autocomplete":"password","placeholder":"****"},domProps:{"value":(_vm.credentials.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "password", $event.target.value)}}})]),_vm._v(" "),_c('span',{staticClass:"floating-label"},[_vm._v(_vm._s(_vm.$t('auth.repeat_desired_password')))]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('i',{staticClass:"form__input__icon mdi mdi-textbox-password"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.passwordRepeat),expression:"credentials.passwordRepeat"}],staticClass:"form__input--text underline has-icon",attrs:{"type":"password","autocomplete":"password","placeholder":"****"},domProps:{"value":(_vm.credentials.passwordRepeat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "passwordRepeat", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form__buttons"},[_c('button',{staticClass:"button--cta",class:{'is-loading': _vm.loading},attrs:{"type":"submit","disabled":!_vm.formValidated}},[_vm._v("\n                            "+_vm._s(_vm.$t('auth.button_activate_account'))+"\n                        ")]),_vm._v(" "),(!_vm.loading && _vm.invalidToken)?_c('p',{staticClass:"activation-warning"},[_vm._v("\n                            "+_vm._s(_vm.$t('auth.button_reset_activate_account_link'))+"\n                        ")]):_vm._e(),_vm._v(" "),(!_vm.loading && _vm.alreadyActivated)?_c('p',{staticClass:"activation-warning clickable",on:{"click":_vm.goToLogin}},[_vm._v("\n                            "+_vm._s(_vm.$t('auth.already_activated_account'))+"\n                        ")]):_vm._e()])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export responseInterceptor */
/* unused harmony export requestInterceptor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instance__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_auth__ = __webpack_require__(13);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__instance__["a"]; });








__WEBPACK_IMPORTED_MODULE_2__instance__["a" /* default */].defaults.headers.common['Accept-Language'] = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
__WEBPACK_IMPORTED_MODULE_2__instance__["a" /* default */].defaults.headers.common['Content-Type'] = 'application/json';

var responseInterceptor = __WEBPACK_IMPORTED_MODULE_2__instance__["a" /* default */].interceptors.response.use(function (response) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
}, function (error) {
    if (error && error.response && error.response.status === 401 && __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].currentRoute.name !== 'sign-in') {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_4__store_modules_auth__["b" /* CLEAR_USERDATA */]);
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'sign-in' });
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

var requestInterceptor = __WEBPACK_IMPORTED_MODULE_2__instance__["a" /* default */].interceptors.request.use(function (request) {
    var token = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters[__WEBPACK_IMPORTED_MODULE_4__store_modules_auth__["c" /* GET_TOKEN */]];
    if (token) {
        request.headers['Authorization'] = 'Bearer ' + token;
    }
    request.headers['X-Requested-With'] = 'XmlHttpRequest';
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(request);
}, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/***/ })
],[244]);


// WEBPACK FOOTER //
// static/js/app.7969dc23e65087b81d55.js